/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.8.0 (NJsonSchema v10.3.11.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class ActivityLogClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "USE_ENVIRONMENT_VARIABLE";
    }

    getActivityLogs(entity: string | null | undefined, entityId: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<ActivityLogModel[]> {
        let url_ = this.baseUrl + "/api/ActivityLog?";
        if (entity !== undefined && entity !== null)
            url_ += "entity=" + encodeURIComponent("" + entity) + "&";
        if (entityId !== undefined && entityId !== null)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityLogs(_response);
        });
    }

    protected processGetActivityLogs(response: AxiosResponse): Promise<ActivityLogModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityLogModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivityLogModel[]>(<any>null);
    }
}

export class AuthClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "USE_ENVIRONMENT_VARIABLE";
    }

    login(input: LoginInput , cancelToken?: CancelToken | undefined): Promise<Token> {
        let url_ = this.baseUrl + "/api/Auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<Token> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Token.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Token>(<any>null);
    }

    seedAdminAndRoles(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Auth/SeedAdmin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSeedAdminAndRoles(_response);
        });
    }

    protected processSeedAdminAndRoles(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    getUserPermissions(userId: string | null | undefined, userName: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Auth/GetUserPermissions?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (userName !== undefined && userName !== null)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserPermissions(_response);
        });
    }

    protected processGetUserPermissions(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    challenge(value: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Auth/challenge?";
        if (value !== undefined && value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChallenge(_response);
        });
    }

    protected processChallenge(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    signin(input: LoginInput , cancelToken?: CancelToken | undefined): Promise<Token> {
        let url_ = this.baseUrl + "/api/Auth/signin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSignin(_response);
        });
    }

    protected processSignin(response: AxiosResponse): Promise<Token> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Token.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Token>(<any>null);
    }

    refresh(  cancelToken?: CancelToken | undefined): Promise<Token> {
        let url_ = this.baseUrl + "/api/Auth/refresh";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefresh(_response);
        });
    }

    protected processRefresh(response: AxiosResponse): Promise<Token> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Token.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Token>(<any>null);
    }

    zaloVerificationCode(input: ZaloVerificationInput , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Auth/zalo-opt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processZaloVerificationCode(_response);
        });
    }

    protected processZaloVerificationCode(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    signinByZalo(input: LoginInput , cancelToken?: CancelToken | undefined): Promise<Token> {
        let url_ = this.baseUrl + "/api/Auth/signin-zalo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSigninByZalo(_response);
        });
    }

    protected processSigninByZalo(response: AxiosResponse): Promise<Token> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Token.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Token>(<any>null);
    }
}

export class BlogClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "USE_ENVIRONMENT_VARIABLE";
    }

    getList(pageNumber: number | undefined, pageSize: number | undefined, searchText: string | null | undefined, sortCriteria: string[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<PagedResultsOfBlogListViewModel> {
        let url_ = this.baseUrl + "/api/Blog/list?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach(item => { url_ += "SortCriteria=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<PagedResultsOfBlogListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultsOfBlogListViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultsOfBlogListViewModel>(<any>null);
    }

    create(title: string | null | undefined, description: string | null | undefined, image: FileParameter | null | undefined, content: string | null | undefined, blogType: BlogType | undefined, seoUrl: string | null | undefined, metaDescription: string | null | undefined, metaTitle: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Blog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (title !== null && title !== undefined)
            content_.append("Title", title.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (image !== null && image !== undefined)
            content_.append("Image", image.data, image.fileName ? image.fileName : "Image");
        if (content !== null && content !== undefined)
            content_.append("Content", content.toString());
        if (blogType === null || blogType === undefined)
            throw new Error("The parameter 'blogType' cannot be null.");
        else
            content_.append("BlogType", blogType.toString());
        if (seoUrl !== null && seoUrl !== undefined)
            content_.append("SeoUrl", seoUrl.toString());
        if (metaDescription !== null && metaDescription !== undefined)
            content_.append("MetaDescription", metaDescription.toString());
        if (metaTitle !== null && metaTitle !== undefined)
            content_.append("MetaTitle", metaTitle.toString());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    edit(id: number, title: string | null | undefined, description: string | null | undefined, image: FileParameter | null | undefined, content: string | null | undefined, blogType: BlogType | undefined, seoUrl: string | null | undefined, metaDescription: string | null | undefined, metaTitle: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Blog/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (title !== null && title !== undefined)
            content_.append("Title", title.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (image !== null && image !== undefined)
            content_.append("Image", image.data, image.fileName ? image.fileName : "Image");
        if (content !== null && content !== undefined)
            content_.append("Content", content.toString());
        if (blogType === null || blogType === undefined)
            throw new Error("The parameter 'blogType' cannot be null.");
        else
            content_.append("BlogType", blogType.toString());
        if (seoUrl !== null && seoUrl !== undefined)
            content_.append("SeoUrl", seoUrl.toString());
        if (metaDescription !== null && metaDescription !== undefined)
            content_.append("MetaDescription", metaDescription.toString());
        if (metaTitle !== null && metaTitle !== undefined)
            content_.append("MetaTitle", metaTitle.toString());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    get(id: number , cancelToken?: CancelToken | undefined): Promise<BlogViewModel> {
        let url_ = this.baseUrl + "/api/Blog/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<BlogViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BlogViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BlogViewModel>(<any>null);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Blog/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class ContentPageClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "USE_ENVIRONMENT_VARIABLE";
    }

    getList(pageNumber: number | undefined, pageSize: number | undefined, searchText: string | null | undefined, sortCriteria: string[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<PagedResultsOfContentPageListViewModel> {
        let url_ = this.baseUrl + "/api/ContentPage/list?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach(item => { url_ += "SortCriteria=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<PagedResultsOfContentPageListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultsOfContentPageListViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultsOfContentPageListViewModel>(<any>null);
    }

    getContentPageSeoUrls(  cancelToken?: CancelToken | undefined): Promise<PagedResultsOfContentPageListViewModel> {
        let url_ = this.baseUrl + "/api/ContentPage/get-content-page-seo-urls";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContentPageSeoUrls(_response);
        });
    }

    protected processGetContentPageSeoUrls(response: AxiosResponse): Promise<PagedResultsOfContentPageListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultsOfContentPageListViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultsOfContentPageListViewModel>(<any>null);
    }

    create(input: CreateContentPageInput , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ContentPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    edit(id: number, input: EditContentPageInput , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ContentPage/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    get(id: number , cancelToken?: CancelToken | undefined): Promise<ContentPageViewModel> {
        let url_ = this.baseUrl + "/api/ContentPage/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ContentPageViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContentPageViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentPageViewModel>(<any>null);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ContentPage/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getBySeoUrl(seoUrl: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<ContentPageViewModel> {
        let url_ = this.baseUrl + "/api/ContentPage/get-by-seourl?";
        if (seoUrl !== undefined && seoUrl !== null)
            url_ += "seoUrl=" + encodeURIComponent("" + seoUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBySeoUrl(_response);
        });
    }

    protected processGetBySeoUrl(response: AxiosResponse): Promise<ContentPageViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContentPageViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContentPageViewModel>(<any>null);
    }
}

export class CouponClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "USE_ENVIRONMENT_VARIABLE";
    }

    getList(pageNumber: number | undefined, pageSize: number | undefined, searchText: string | null | undefined, sortCriteria: string[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<PagedResultsOfCouponListViewModel> {
        let url_ = this.baseUrl + "/api/Coupon/list?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach(item => { url_ += "SortCriteria=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<PagedResultsOfCouponListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultsOfCouponListViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultsOfCouponListViewModel>(<any>null);
    }

    create(name: string | null | undefined, code: string | null | undefined, amount: number | undefined, limitation: number | undefined, status: CouponStatus | undefined, type: CouponType | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Coupon";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (code !== null && code !== undefined)
            content_.append("Code", code.toString());
        if (amount === null || amount === undefined)
            throw new Error("The parameter 'amount' cannot be null.");
        else
            content_.append("Amount", amount.toString());
        if (limitation === null || limitation === undefined)
            throw new Error("The parameter 'limitation' cannot be null.");
        else
            content_.append("Limitation", limitation.toString());
        if (status === null || status === undefined)
            throw new Error("The parameter 'status' cannot be null.");
        else
            content_.append("Status", status.toString());
        if (type === null || type === undefined)
            throw new Error("The parameter 'type' cannot be null.");
        else
            content_.append("Type", type.toString());
        if (fromDate !== null && fromDate !== undefined)
            content_.append("FromDate", fromDate.toJSON());
        if (toDate !== null && toDate !== undefined)
            content_.append("ToDate", toDate.toJSON());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    edit(id: number, name: string | null | undefined, code: string | null | undefined, amount: number | undefined, limitation: number | undefined, status: CouponStatus | undefined, type: CouponType | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Coupon/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (code !== null && code !== undefined)
            content_.append("Code", code.toString());
        if (amount === null || amount === undefined)
            throw new Error("The parameter 'amount' cannot be null.");
        else
            content_.append("Amount", amount.toString());
        if (limitation === null || limitation === undefined)
            throw new Error("The parameter 'limitation' cannot be null.");
        else
            content_.append("Limitation", limitation.toString());
        if (status === null || status === undefined)
            throw new Error("The parameter 'status' cannot be null.");
        else
            content_.append("Status", status.toString());
        if (type === null || type === undefined)
            throw new Error("The parameter 'type' cannot be null.");
        else
            content_.append("Type", type.toString());
        if (fromDate !== null && fromDate !== undefined)
            content_.append("FromDate", fromDate.toJSON());
        if (toDate !== null && toDate !== undefined)
            content_.append("ToDate", toDate.toJSON());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    get(id: number , cancelToken?: CancelToken | undefined): Promise<CouponViewModel> {
        let url_ = this.baseUrl + "/api/Coupon/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<CouponViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CouponViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CouponViewModel>(<any>null);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Coupon/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class CustomerClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "USE_ENVIRONMENT_VARIABLE";
    }

    getListPaged(filterLevel: CustomerLevel[] | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchText: string | null | undefined, sortCriteria: string[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<PagedResultsOfCustomerViewModel> {
        let url_ = this.baseUrl + "/api/Customer/list-paged?";
        if (filterLevel !== undefined && filterLevel !== null)
            filterLevel && filterLevel.forEach(item => { url_ += "FilterLevel=" + encodeURIComponent("" + item) + "&"; });
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach(item => { url_ += "SortCriteria=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListPaged(_response);
        });
    }

    protected processGetListPaged(response: AxiosResponse): Promise<PagedResultsOfCustomerViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultsOfCustomerViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultsOfCustomerViewModel>(<any>null);
    }

    getList(  cancelToken?: CancelToken | undefined): Promise<CustomerViewModel[]> {
        let url_ = this.baseUrl + "/api/Customer/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<CustomerViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerViewModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerViewModel[]>(<any>null);
    }

    updateLevel(input: UpdateCustomerLevelInput , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLevel(_response);
        });
    }

    protected processUpdateLevel(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    updateProfile(input: CustomerProfileInput, userId: string | null , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Customer/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProfile(_response);
        });
    }

    protected processUpdateProfile(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    delete(userId: string | null , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Customer/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getCustomer(id: string | null , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Customer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomer(_response);
        });
    }

    protected processGetCustomer(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getCustomer2(model: CheckUserExistInput , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Customer/check-user-exist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomer2(_response);
        });
    }

    protected processGetCustomer2(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    register(input: RegisterInput , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Customer/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class DecalPriceClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "USE_ENVIRONMENT_VARIABLE";
    }

    edit(id: number, description: string | null | undefined, quantity: number | undefined, printPrice: number | undefined, cutPrint: number | undefined, machiningPrice: number | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/DecalPrice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (quantity === null || quantity === undefined)
            throw new Error("The parameter 'quantity' cannot be null.");
        else
            content_.append("Quantity", quantity.toString());
        if (printPrice === null || printPrice === undefined)
            throw new Error("The parameter 'printPrice' cannot be null.");
        else
            content_.append("PrintPrice", printPrice.toString());
        if (cutPrint === null || cutPrint === undefined)
            throw new Error("The parameter 'cutPrint' cannot be null.");
        else
            content_.append("CutPrint", cutPrint.toString());
        if (machiningPrice === null || machiningPrice === undefined)
            throw new Error("The parameter 'machiningPrice' cannot be null.");
        else
            content_.append("MachiningPrice", machiningPrice.toString());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    get(id: number , cancelToken?: CancelToken | undefined): Promise<DecalPriceViewModel> {
        let url_ = this.baseUrl + "/api/DecalPrice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<DecalPriceViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DecalPriceViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DecalPriceViewModel>(<any>null);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/DecalPrice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getList(pageNumber: number | undefined, pageSize: number | undefined, searchText: string | null | undefined, sortCriteria: string[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<PagedResultsOfDecalPriceListViewModel> {
        let url_ = this.baseUrl + "/api/DecalPrice/list?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach(item => { url_ += "SortCriteria=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<PagedResultsOfDecalPriceListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultsOfDecalPriceListViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultsOfDecalPriceListViewModel>(<any>null);
    }
}

export class EmployeeClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "USE_ENVIRONMENT_VARIABLE";
    }

    getListPaged(pageNumber: number | undefined, pageSize: number | undefined, searchText: string | null | undefined, sortCriteria: string[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<PagedResultsOfEmployeeListViewModel> {
        let url_ = this.baseUrl + "/api/Employee/list-paged?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach(item => { url_ += "SortCriteria=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListPaged(_response);
        });
    }

    protected processGetListPaged(response: AxiosResponse): Promise<PagedResultsOfEmployeeListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultsOfEmployeeListViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultsOfEmployeeListViewModel>(<any>null);
    }

    getList(  cancelToken?: CancelToken | undefined): Promise<EmployeeListViewModel[]> {
        let url_ = this.baseUrl + "/api/Employee/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<EmployeeListViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeListViewModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeListViewModel[]>(<any>null);
    }

    getSaleEmployees(  cancelToken?: CancelToken | undefined): Promise<SelectModelOfString[]> {
        let url_ = this.baseUrl + "/api/Employee/GetSaleEmployees";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSaleEmployees(_response);
        });
    }

    protected processGetSaleEmployees(response: AxiosResponse): Promise<SelectModelOfString[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectModelOfString.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelectModelOfString[]>(<any>null);
    }

    create(input: CreateEmployeeInput , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Employee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    get(id: string | null , cancelToken?: CancelToken | undefined): Promise<EmployeeViewModel> {
        let url_ = this.baseUrl + "/api/Employee/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<EmployeeViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmployeeViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeViewModel>(<any>null);
    }

    edit(id: string | null, input: EditEmployeeInput , cancelToken?: CancelToken | undefined): Promise<IdentityResult> {
        let url_ = this.baseUrl + "/api/Employee/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: AxiosResponse): Promise<IdentityResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IdentityResult.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IdentityResult>(<any>null);
    }

    delete(id: string | null , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Employee/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class ExpensesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "USE_ENVIRONMENT_VARIABLE";
    }

    getList(dateTo: number | null | undefined, dateFrom: number | null | undefined, filterStatus: OrderStatus[] | null | undefined, filterPaymentStatus: ExpensesPaymentStatus[] | null | undefined, filterEmployee: string | null | undefined, isExportBilling: boolean | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchText: string | null | undefined, sortCriteria: string[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<PagedResultsOfExpensesListViewModel> {
        let url_ = this.baseUrl + "/api/Expenses/list?";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (filterStatus !== undefined && filterStatus !== null)
            filterStatus && filterStatus.forEach(item => { url_ += "filterStatus=" + encodeURIComponent("" + item) + "&"; });
        if (filterPaymentStatus !== undefined && filterPaymentStatus !== null)
            filterPaymentStatus && filterPaymentStatus.forEach(item => { url_ += "filterPaymentStatus=" + encodeURIComponent("" + item) + "&"; });
        if (filterEmployee !== undefined && filterEmployee !== null)
            url_ += "filterEmployee=" + encodeURIComponent("" + filterEmployee) + "&";
        if (isExportBilling !== undefined && isExportBilling !== null)
            url_ += "IsExportBilling=" + encodeURIComponent("" + isExportBilling) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach(item => { url_ += "SortCriteria=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<PagedResultsOfExpensesListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultsOfExpensesListViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultsOfExpensesListViewModel>(<any>null);
    }

    get(id: number , cancelToken?: CancelToken | undefined): Promise<ExpensesViewModel> {
        let url_ = this.baseUrl + "/api/Expenses/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ExpensesViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExpensesViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExpensesViewModel>(<any>null);
    }

    update(id: number, vendorId: string | null | undefined, vendorName: string | null | undefined, vendorPhoneNumber: string | null | undefined, vendorAddress: string | null | undefined, vendorEmail: string | null | undefined, shippingFee: number | undefined, importDate: Date | undefined, createExpensesDetails: CreateExpensesDetailInput[] | null | undefined, createExpensesDetailsStringJson: string | null | undefined, employeeId: string | null | undefined, discountAmount: number | undefined, depositAmount: number | undefined, vATAmount: number | undefined, couponCode: string | null | undefined, images: FileParameter[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Expenses/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (vendorId !== null && vendorId !== undefined)
            content_.append("VendorId", vendorId.toString());
        if (vendorName !== null && vendorName !== undefined)
            content_.append("VendorName", vendorName.toString());
        if (vendorPhoneNumber !== null && vendorPhoneNumber !== undefined)
            content_.append("VendorPhoneNumber", vendorPhoneNumber.toString());
        if (vendorAddress !== null && vendorAddress !== undefined)
            content_.append("VendorAddress", vendorAddress.toString());
        if (vendorEmail !== null && vendorEmail !== undefined)
            content_.append("VendorEmail", vendorEmail.toString());
        if (shippingFee === null || shippingFee === undefined)
            throw new Error("The parameter 'shippingFee' cannot be null.");
        else
            content_.append("ShippingFee", shippingFee.toString());
        if (importDate === null || importDate === undefined)
            throw new Error("The parameter 'importDate' cannot be null.");
        else
            content_.append("ImportDate", importDate.toJSON());
        if (createExpensesDetails !== null && createExpensesDetails !== undefined)
            createExpensesDetails.forEach(item_ => content_.append("CreateExpensesDetails", item_.toString()));
        if (createExpensesDetailsStringJson !== null && createExpensesDetailsStringJson !== undefined)
            content_.append("CreateExpensesDetailsStringJson", createExpensesDetailsStringJson.toString());
        if (employeeId !== null && employeeId !== undefined)
            content_.append("EmployeeId", employeeId.toString());
        if (discountAmount === null || discountAmount === undefined)
            throw new Error("The parameter 'discountAmount' cannot be null.");
        else
            content_.append("DiscountAmount", discountAmount.toString());
        if (depositAmount === null || depositAmount === undefined)
            throw new Error("The parameter 'depositAmount' cannot be null.");
        else
            content_.append("DepositAmount", depositAmount.toString());
        if (vATAmount === null || vATAmount === undefined)
            throw new Error("The parameter 'vATAmount' cannot be null.");
        else
            content_.append("VATAmount", vATAmount.toString());
        if (couponCode !== null && couponCode !== undefined)
            content_.append("CouponCode", couponCode.toString());
        if (images !== null && images !== undefined)
            images.forEach(item_ => content_.append("images", item_.data, item_.fileName ? item_.fileName : "images") );

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Expenses/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    updateStatus(input: UpdateOrderStatusInput , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Expenses/updateStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStatus(_response);
        });
    }

    protected processUpdateStatus(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    updatePaymentStatus(input: UpdateExpensesPaymentStatusInput , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Expenses/updatePaymentStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePaymentStatus(_response);
        });
    }

    protected processUpdatePaymentStatus(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    create(vendorId: string | null | undefined, vendorName: string | null | undefined, vendorPhoneNumber: string | null | undefined, vendorAddress: string | null | undefined, vendorEmail: string | null | undefined, shippingFee: number | undefined, importDate: Date | undefined, createExpensesDetails: CreateExpensesDetailInput[] | null | undefined, createExpensesDetailsStringJson: string | null | undefined, employeeId: string | null | undefined, discountAmount: number | undefined, depositAmount: number | undefined, vATAmount: number | undefined, couponCode: string | null | undefined, images: FileParameter[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Expenses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (vendorId !== null && vendorId !== undefined)
            content_.append("VendorId", vendorId.toString());
        if (vendorName !== null && vendorName !== undefined)
            content_.append("VendorName", vendorName.toString());
        if (vendorPhoneNumber !== null && vendorPhoneNumber !== undefined)
            content_.append("VendorPhoneNumber", vendorPhoneNumber.toString());
        if (vendorAddress !== null && vendorAddress !== undefined)
            content_.append("VendorAddress", vendorAddress.toString());
        if (vendorEmail !== null && vendorEmail !== undefined)
            content_.append("VendorEmail", vendorEmail.toString());
        if (shippingFee === null || shippingFee === undefined)
            throw new Error("The parameter 'shippingFee' cannot be null.");
        else
            content_.append("ShippingFee", shippingFee.toString());
        if (importDate === null || importDate === undefined)
            throw new Error("The parameter 'importDate' cannot be null.");
        else
            content_.append("ImportDate", importDate.toJSON());
        if (createExpensesDetails !== null && createExpensesDetails !== undefined)
            createExpensesDetails.forEach(item_ => content_.append("CreateExpensesDetails", item_.toString()));
        if (createExpensesDetailsStringJson !== null && createExpensesDetailsStringJson !== undefined)
            content_.append("CreateExpensesDetailsStringJson", createExpensesDetailsStringJson.toString());
        if (employeeId !== null && employeeId !== undefined)
            content_.append("EmployeeId", employeeId.toString());
        if (discountAmount === null || discountAmount === undefined)
            throw new Error("The parameter 'discountAmount' cannot be null.");
        else
            content_.append("DiscountAmount", discountAmount.toString());
        if (depositAmount === null || depositAmount === undefined)
            throw new Error("The parameter 'depositAmount' cannot be null.");
        else
            content_.append("DepositAmount", depositAmount.toString());
        if (vATAmount === null || vATAmount === undefined)
            throw new Error("The parameter 'vATAmount' cannot be null.");
        else
            content_.append("VATAmount", vATAmount.toString());
        if (couponCode !== null && couponCode !== undefined)
            content_.append("CouponCode", couponCode.toString());
        if (images !== null && images !== undefined)
            images.forEach(item_ => content_.append("images", item_.data, item_.fileName ? item_.fileName : "images") );

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    report(input: DownloadOrderReportInput , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Expenses/downloadReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReport(_response);
        });
    }

    protected processReport(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    updateOrderPaymentMethod(input: UpdateOrderPaymentMethodInput , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Expenses/update-order-payment-method";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrderPaymentMethod(_response);
        });
    }

    protected processUpdateOrderPaymentMethod(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    updateBankingNote(orderId: number | undefined, bankingNote: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Expenses/update-banking-note?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bankingNote);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBankingNote(_response);
        });
    }

    protected processUpdateBankingNote(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    updateOrderDetailStatus(orderDetailId: string | undefined, status: number , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Expenses/update-order-detail-status?";
        if (orderDetailId === null)
            throw new Error("The parameter 'orderDetailId' cannot be null.");
        else if (orderDetailId !== undefined)
            url_ += "orderDetailId=" + encodeURIComponent("" + orderDetailId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(status);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrderDetailStatus(_response);
        });
    }

    protected processUpdateOrderDetailStatus(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    updateCODNote(orderId: number, updateCODNoteInput: UpdateCODNoteInput , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Expenses/update-cod-note/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateCODNoteInput);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCODNote(_response);
        });
    }

    protected processUpdateCODNote(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    getOrderStatusStatistics(filterEmployee: string | null | undefined, dateFrom: number | null | undefined, dateTo: number | null | undefined , cancelToken?: CancelToken | undefined): Promise<OrderStatistics> {
        let url_ = this.baseUrl + "/api/Expenses/get-order-status-statistics?";
        if (filterEmployee !== undefined && filterEmployee !== null)
            url_ += "FilterEmployee=" + encodeURIComponent("" + filterEmployee) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderStatusStatistics(_response);
        });
    }

    protected processGetOrderStatusStatistics(response: AxiosResponse): Promise<OrderStatistics> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderStatistics.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderStatistics>(<any>null);
    }

    getOrderDetailStatusStatistics(employeeId: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/api/Expenses/get-order-detail-status-statistics?";
        if (employeeId !== undefined && employeeId !== null)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderDetailStatusStatistics(_response);
        });
    }

    protected processGetOrderDetailStatusStatistics(response: AxiosResponse): Promise<{ [key: string]: number; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200![key] = resultData200[key];
                }
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: number; }>(<any>null);
    }

    getCatalogueMaterials(productId: number | undefined , cancelToken?: CancelToken | undefined): Promise<CatalogueOrderMaterial[]> {
        let url_ = this.baseUrl + "/api/Expenses/GetCatalogueMaterials?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCatalogueMaterials(_response);
        });
    }

    protected processGetCatalogueMaterials(response: AxiosResponse): Promise<CatalogueOrderMaterial[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CatalogueOrderMaterial.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogueOrderMaterial[]>(<any>null);
    }
}

export class LibraryClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "USE_ENVIRONMENT_VARIABLE";
    }

    getProductCategoryOptions(  cancelToken?: CancelToken | undefined): Promise<BaseValueModelOfInteger[]> {
        let url_ = this.baseUrl + "/api/Library/getProductCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductCategoryOptions(_response);
        });
    }

    protected processGetProductCategoryOptions(response: AxiosResponse): Promise<BaseValueModelOfInteger[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BaseValueModelOfInteger.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BaseValueModelOfInteger[]>(<any>null);
    }

    getShapeOptions(  cancelToken?: CancelToken | undefined): Promise<BaseValueModelOfInteger[]> {
        let url_ = this.baseUrl + "/api/Library/getShapes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShapeOptions(_response);
        });
    }

    protected processGetShapeOptions(response: AxiosResponse): Promise<BaseValueModelOfInteger[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BaseValueModelOfInteger.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BaseValueModelOfInteger[]>(<any>null);
    }

    getSampleTypes(  cancelToken?: CancelToken | undefined): Promise<BaseValueModelOfInteger[]> {
        let url_ = this.baseUrl + "/api/Library/getSampleTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSampleTypes(_response);
        });
    }

    protected processGetSampleTypes(response: AxiosResponse): Promise<BaseValueModelOfInteger[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BaseValueModelOfInteger.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BaseValueModelOfInteger[]>(<any>null);
    }

    getSamples(shape: number | undefined, type: number | undefined, page: number | undefined, searchText: string | null | undefined, productCategory: number | undefined , cancelToken?: CancelToken | undefined): Promise<PagedResultsOfSampleForOnlineLibraryViewModel> {
        let url_ = this.baseUrl + "/api/Library/GetSamples?";
        if (shape === null)
            throw new Error("The parameter 'shape' cannot be null.");
        else if (shape !== undefined)
            url_ += "shape=" + encodeURIComponent("" + shape) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (productCategory === null)
            throw new Error("The parameter 'productCategory' cannot be null.");
        else if (productCategory !== undefined)
            url_ += "productCategory=" + encodeURIComponent("" + productCategory) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSamples(_response);
        });
    }

    protected processGetSamples(response: AxiosResponse): Promise<PagedResultsOfSampleForOnlineLibraryViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultsOfSampleForOnlineLibraryViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultsOfSampleForOnlineLibraryViewModel>(<any>null);
    }
}

export class OrderClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "USE_ENVIRONMENT_VARIABLE";
    }

    getList(dateTo: number | null | undefined, dateFrom: number | null | undefined, filterStatus: OrderStatus[] | null | undefined, filterPaymentStatus: OrderPaymentStatus[] | null | undefined, filterEmployee: string | null | undefined, filterType: FilterType | undefined, isExportBilling: boolean | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchText: string | null | undefined, sortCriteria: string[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<PagedResultsOfOrderListViewModel> {
        let url_ = this.baseUrl + "/api/Order/list?";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (filterStatus !== undefined && filterStatus !== null)
            filterStatus && filterStatus.forEach(item => { url_ += "filterStatus=" + encodeURIComponent("" + item) + "&"; });
        if (filterPaymentStatus !== undefined && filterPaymentStatus !== null)
            filterPaymentStatus && filterPaymentStatus.forEach(item => { url_ += "filterPaymentStatus=" + encodeURIComponent("" + item) + "&"; });
        if (filterEmployee !== undefined && filterEmployee !== null)
            url_ += "filterEmployee=" + encodeURIComponent("" + filterEmployee) + "&";
        if (filterType === null)
            throw new Error("The parameter 'filterType' cannot be null.");
        else if (filterType !== undefined)
            url_ += "FilterType=" + encodeURIComponent("" + filterType) + "&";
        if (isExportBilling !== undefined && isExportBilling !== null)
            url_ += "IsExportBilling=" + encodeURIComponent("" + isExportBilling) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach(item => { url_ += "SortCriteria=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<PagedResultsOfOrderListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultsOfOrderListViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultsOfOrderListViewModel>(<any>null);
    }

    get(id: number , cancelToken?: CancelToken | undefined): Promise<OrderViewModel> {
        let url_ = this.baseUrl + "/api/Order/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<OrderViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderViewModel>(<any>null);
    }

    update(id: number, input: CreateOrderInput , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Order/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Order/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    updateStatus(input: UpdateOrderStatusInput , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Order/updateStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStatus(_response);
        });
    }

    protected processUpdateStatus(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    updatePaymentStatus(input: UpdateOrderPaymentStatusInput , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Order/updatePaymentStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePaymentStatus(_response);
        });
    }

    protected processUpdatePaymentStatus(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    updateVATInvoiceStatus(input: UpdateOrderVATStatusInput , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Order/updateVATInvoiceStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateVATInvoiceStatus(_response);
        });
    }

    protected processUpdateVATInvoiceStatus(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    create(input: CreateOrderInput , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    report(input: DownloadOrderReportInput , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Order/downloadReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReport(_response);
        });
    }

    protected processReport(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getOrderMaterialByProductId(productId: number | undefined , cancelToken?: CancelToken | undefined): Promise<OrderMaterialVewModel> {
        let url_ = this.baseUrl + "/api/Order/get-order-material-byproductId?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderMaterialByProductId(_response);
        });
    }

    protected processGetOrderMaterialByProductId(response: AxiosResponse): Promise<OrderMaterialVewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderMaterialVewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderMaterialVewModel>(<any>null);
    }

    updateOrderPaymentMethod(input: UpdateOrderPaymentMethodInput , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Order/update-order-payment-method";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrderPaymentMethod(_response);
        });
    }

    protected processUpdateOrderPaymentMethod(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    getOrderDetailByOrderId(id: number , cancelToken?: CancelToken | undefined): Promise<OrderDetailViewModel[]> {
        let url_ = this.baseUrl + "/api/Order/GetOrderDetailByOrderId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderDetailByOrderId(_response);
        });
    }

    protected processGetOrderDetailByOrderId(response: AxiosResponse): Promise<OrderDetailViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderDetailViewModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderDetailViewModel[]>(<any>null);
    }

    getReferencePrices(customerId: string | null | undefined, productId: number | undefined , cancelToken?: CancelToken | undefined): Promise<OrderDetailViewModel[]> {
        let url_ = this.baseUrl + "/api/Order/GetReferencePrices?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReferencePrices(_response);
        });
    }

    protected processGetReferencePrices(response: AxiosResponse): Promise<OrderDetailViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderDetailViewModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderDetailViewModel[]>(<any>null);
    }

    updateBankingNote(orderId: number | undefined, bankingNote: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Order/update-banking-note?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bankingNote);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBankingNote(_response);
        });
    }

    protected processUpdateBankingNote(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    updateOrderDetailStatus(updateOrderDetailStatusModel: UpdateOrderDetailStatusModel , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Order/update-order-detail-status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateOrderDetailStatusModel);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrderDetailStatus(_response);
        });
    }

    protected processUpdateOrderDetailStatus(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    updateCODNote(orderId: number, updateCODNoteInput: UpdateCODNoteInput , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Order/update-cod-note/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateCODNoteInput);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCODNote(_response);
        });
    }

    protected processUpdateCODNote(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    getProducingList(dateTo: number | null | undefined, dateFrom: number | null | undefined, filterStatus: OrderDetailStatus[] | null | undefined, filterEmployee: string | null | undefined, isOrderForDesign: boolean | undefined, isOrderForPrint: boolean | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchText: string | null | undefined, sortCriteria: string[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<PagedResultsOfProducingListViewModel> {
        let url_ = this.baseUrl + "/api/Order/producing-list?";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (filterStatus !== undefined && filterStatus !== null)
            filterStatus && filterStatus.forEach(item => { url_ += "filterStatus=" + encodeURIComponent("" + item) + "&"; });
        if (filterEmployee !== undefined && filterEmployee !== null)
            url_ += "filterEmployee=" + encodeURIComponent("" + filterEmployee) + "&";
        if (isOrderForDesign === null)
            throw new Error("The parameter 'isOrderForDesign' cannot be null.");
        else if (isOrderForDesign !== undefined)
            url_ += "IsOrderForDesign=" + encodeURIComponent("" + isOrderForDesign) + "&";
        if (isOrderForPrint === null)
            throw new Error("The parameter 'isOrderForPrint' cannot be null.");
        else if (isOrderForPrint !== undefined)
            url_ += "IsOrderForPrint=" + encodeURIComponent("" + isOrderForPrint) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach(item => { url_ += "SortCriteria=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProducingList(_response);
        });
    }

    protected processGetProducingList(response: AxiosResponse): Promise<PagedResultsOfProducingListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultsOfProducingListViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultsOfProducingListViewModel>(<any>null);
    }

    getOrderStatusStatistics(filterEmployee: string | null | undefined, dateFrom: number | null | undefined, dateTo: number | null | undefined , cancelToken?: CancelToken | undefined): Promise<OrderStatistics> {
        let url_ = this.baseUrl + "/api/Order/get-order-status-statistics?";
        if (filterEmployee !== undefined && filterEmployee !== null)
            url_ += "FilterEmployee=" + encodeURIComponent("" + filterEmployee) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderStatusStatistics(_response);
        });
    }

    protected processGetOrderStatusStatistics(response: AxiosResponse): Promise<OrderStatistics> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrderStatistics.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderStatistics>(<any>null);
    }

    getOrderDetailStatusStatistics(employeeId: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/api/Order/get-order-detail-status-statistics?";
        if (employeeId !== undefined && employeeId !== null)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderDetailStatusStatistics(_response);
        });
    }

    protected processGetOrderDetailStatusStatistics(response: AxiosResponse): Promise<{ [key: string]: number; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200![key] = resultData200[key];
                }
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: number; }>(<any>null);
    }

    getCatalogueMaterials(productId: number | undefined , cancelToken?: CancelToken | undefined): Promise<CatalogueOrderMaterial[]> {
        let url_ = this.baseUrl + "/api/Order/GetCatalogueMaterials?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCatalogueMaterials(_response);
        });
    }

    protected processGetCatalogueMaterials(response: AxiosResponse): Promise<CatalogueOrderMaterial[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CatalogueOrderMaterial.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogueOrderMaterial[]>(<any>null);
    }

    getDebtOrdersByMonth(month: number | undefined, employeeId: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<OrderListViewModel[]> {
        let url_ = this.baseUrl + "/api/Order/GetDebtOrdersByMonth?";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (employeeId !== undefined && employeeId !== null)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDebtOrdersByMonth(_response);
        });
    }

    protected processGetDebtOrdersByMonth(response: AxiosResponse): Promise<OrderListViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderListViewModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderListViewModel[]>(<any>null);
    }

    getOrderDeposit(orderId: number | undefined , cancelToken?: CancelToken | undefined): Promise<OrderDepositModel[]> {
        let url_ = this.baseUrl + "/api/Order/GetOrderDeposit?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderDeposit(_response);
        });
    }

    protected processGetOrderDeposit(response: AxiosResponse): Promise<OrderDepositModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderDepositModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrderDepositModel[]>(<any>null);
    }

    setOrderDeposit(inputs: OrderDepositModel[] , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Order/SetOrderDeposit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputs);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetOrderDeposit(_response);
        });
    }

    protected processSetOrderDeposit(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(<any>null);
    }

    deleteOrderDeposit(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Order/DeleteOrderDeposit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteOrderDeposit(_response);
        });
    }

    protected processDeleteOrderDeposit(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class OtherServiceClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "USE_ENVIRONMENT_VARIABLE";
    }

    create(input: CreateOtherServiceInput , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/OtherService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    edit(id: number, input: EditOtherServiceInput , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/OtherService/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    get(id: number , cancelToken?: CancelToken | undefined): Promise<OtherServiceViewModel> {
        let url_ = this.baseUrl + "/api/OtherService/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<OtherServiceViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OtherServiceViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OtherServiceViewModel>(<any>null);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/OtherService/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    setPrice(id: number, input: EditOtherServicePriceInput[] , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/OtherService/editPrice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetPrice(_response);
        });
    }

    protected processSetPrice(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getList(pageNumber: number | undefined, pageSize: number | undefined, searchText: string | null | undefined, sortCriteria: string[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<PagedResultsOfOtherServiceListViewModel> {
        let url_ = this.baseUrl + "/api/OtherService/list?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach(item => { url_ += "SortCriteria=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<PagedResultsOfOtherServiceListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultsOfOtherServiceListViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultsOfOtherServiceListViewModel>(<any>null);
    }
}

export class PriceClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "USE_ENVIRONMENT_VARIABLE";
    }

    edit(inputs: UpdatePriceInput[] , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Price";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputs);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getStickerPrices(  cancelToken?: CancelToken | undefined): Promise<PriceListViewModel[]> {
        let url_ = this.baseUrl + "/api/Price/sticker-prices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStickerPrices(_response);
        });
    }

    protected processGetStickerPrices(response: AxiosResponse): Promise<PriceListViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PriceListViewModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PriceListViewModel[]>(<any>null);
    }

    getPrices(categoryIds: number[] | null | undefined, productId: number | null | undefined, type: QuotationType | undefined , cancelToken?: CancelToken | undefined): Promise<PriceListViewModel[]> {
        let url_ = this.baseUrl + "/api/Price/GetPrices?";
        if (categoryIds !== undefined && categoryIds !== null)
            categoryIds && categoryIds.forEach(item => { url_ += "categoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (productId !== undefined && productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPrices(_response);
        });
    }

    protected processGetPrices(response: AxiosResponse): Promise<PriceListViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PriceListViewModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PriceListViewModel[]>(<any>null);
    }

    addPrice(model: AddPriceInput , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Price/AddPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddPrice(_response);
        });
    }

    protected processAddPrice(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    updatePrices(models: PriceValueInput[] , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Price/UpdatePrices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(models);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePrices(_response);
        });
    }

    protected processUpdatePrices(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    updateQuantityThresholdByCategories(updateQuantityThresholdInput: UpdateQuantityThresholdInput , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Price/UpdateQuantityThresholdByCategories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateQuantityThresholdInput);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateQuantityThresholdByCategories(_response);
        });
    }

    protected processUpdateQuantityThresholdByCategories(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    updateSizeThresholdByCategories(updateSizeThresholdInput: UpdateSizeThresholdInput , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Price/UpdateSizeThreshold";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateSizeThresholdInput);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSizeThresholdByCategories(_response);
        });
    }

    protected processUpdateSizeThresholdByCategories(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    getUnpricingProductsByCategories(categoryIds: number[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<ProductListViewModel[]> {
        let url_ = this.baseUrl + "/api/Price/GetUnpricingProductsByCategories?";
        if (categoryIds !== undefined && categoryIds !== null)
            categoryIds && categoryIds.forEach(item => { url_ += "categoryIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUnpricingProductsByCategories(_response);
        });
    }

    protected processGetUnpricingProductsByCategories(response: AxiosResponse): Promise<ProductListViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductListViewModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductListViewModel[]>(<any>null);
    }

    getUnpricingProducts(  cancelToken?: CancelToken | undefined): Promise<ProductListViewModel[]> {
        let url_ = this.baseUrl + "/api/Price/GetUnpricingProducts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUnpricingProducts(_response);
        });
    }

    protected processGetUnpricingProducts(response: AxiosResponse): Promise<ProductListViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductListViewModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductListViewModel[]>(<any>null);
    }

    getCataloguePrice(  cancelToken?: CancelToken | undefined): Promise<CataloguePriceListViewModel[]> {
        let url_ = this.baseUrl + "/api/Price/GetCataloguePrice";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCataloguePrice(_response);
        });
    }

    protected processGetCataloguePrice(response: AxiosResponse): Promise<CataloguePriceListViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CataloguePriceListViewModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CataloguePriceListViewModel[]>(<any>null);
    }

    updateCatalogPriceThresholds(catalogUpdatePriceThresholdInputs: CatalogUpdatePriceThresholdInput[] , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Price/UpdateCatalogPriceThresholds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(catalogUpdatePriceThresholdInputs);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCatalogPriceThresholds(_response);
        });
    }

    protected processUpdateCatalogPriceThresholds(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    updateCatalogPrice(catalogUpdatePriceInput: CatalogUpdatePriceInput , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Price/UpdateCatalogPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(catalogUpdatePriceInput);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCatalogPrice(_response);
        });
    }

    protected processUpdateCatalogPrice(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    createCatalogPrice(catalogUpdatePriceInput: CatalogUpdatePriceInput , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Price/CreateCatalogPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(catalogUpdatePriceInput);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCatalogPrice(_response);
        });
    }

    protected processCreateCatalogPrice(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    getCatalogueProductItemsPrices(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<CatalogueProductItemsPrice[]> {
        let url_ = this.baseUrl + "/api/Price/GetCatalogueProductItemsPrices?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCatalogueProductItemsPrices(_response);
        });
    }

    protected processGetCatalogueProductItemsPrices(response: AxiosResponse): Promise<CatalogueProductItemsPrice[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CatalogueProductItemsPrice.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogueProductItemsPrice[]>(<any>null);
    }

    updateCatalogProductItemPrice(input: UpdateCatalogueProductItemPrice[] , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Price/UpdateCatalogProductItemPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCatalogProductItemPrice(_response);
        });
    }

    protected processUpdateCatalogProductItemPrice(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class ProductCategoryClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "USE_ENVIRONMENT_VARIABLE";
    }

    create(name: string | null | undefined, status: ProductCategoryStatus | undefined, seoUrl: string | null | undefined, image: FileParameter | null | undefined, metaDescription: string | null | undefined, metaTitle: string | null | undefined, showOnMenu: boolean | undefined, category: Category | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ProductCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (status === null || status === undefined)
            throw new Error("The parameter 'status' cannot be null.");
        else
            content_.append("Status", status.toString());
        if (seoUrl !== null && seoUrl !== undefined)
            content_.append("SeoUrl", seoUrl.toString());
        if (image !== null && image !== undefined)
            content_.append("Image", image.data, image.fileName ? image.fileName : "Image");
        if (metaDescription !== null && metaDescription !== undefined)
            content_.append("MetaDescription", metaDescription.toString());
        if (metaTitle !== null && metaTitle !== undefined)
            content_.append("MetaTitle", metaTitle.toString());
        if (showOnMenu === null || showOnMenu === undefined)
            throw new Error("The parameter 'showOnMenu' cannot be null.");
        else
            content_.append("ShowOnMenu", showOnMenu.toString());
        if (category === null || category === undefined)
            throw new Error("The parameter 'category' cannot be null.");
        else
            content_.append("Category", category.toString());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    edit(id: number, name: string | null | undefined, status: ProductCategoryStatus | undefined, seoUrl: string | null | undefined, image: FileParameter | null | undefined, metaDescription: string | null | undefined, metaTitle: string | null | undefined, showOnMenu: boolean | undefined, category: Category | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ProductCategory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (status === null || status === undefined)
            throw new Error("The parameter 'status' cannot be null.");
        else
            content_.append("Status", status.toString());
        if (seoUrl !== null && seoUrl !== undefined)
            content_.append("SeoUrl", seoUrl.toString());
        if (image !== null && image !== undefined)
            content_.append("Image", image.data, image.fileName ? image.fileName : "Image");
        if (metaDescription !== null && metaDescription !== undefined)
            content_.append("MetaDescription", metaDescription.toString());
        if (metaTitle !== null && metaTitle !== undefined)
            content_.append("MetaTitle", metaTitle.toString());
        if (showOnMenu === null || showOnMenu === undefined)
            throw new Error("The parameter 'showOnMenu' cannot be null.");
        else
            content_.append("ShowOnMenu", showOnMenu.toString());
        if (category === null || category === undefined)
            throw new Error("The parameter 'category' cannot be null.");
        else
            content_.append("Category", category.toString());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    get(id: number , cancelToken?: CancelToken | undefined): Promise<ProductCategoryViewModel> {
        let url_ = this.baseUrl + "/api/ProductCategory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ProductCategoryViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductCategoryViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductCategoryViewModel>(<any>null);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ProductCategory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getListPaged(pageNumber: number | undefined, pageSize: number | undefined, searchText: string | null | undefined, sortCriteria: string[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<PagedResultsOfProductCategoryListViewModel> {
        let url_ = this.baseUrl + "/api/ProductCategory/list-paged?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach(item => { url_ += "SortCriteria=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListPaged(_response);
        });
    }

    protected processGetListPaged(response: AxiosResponse): Promise<PagedResultsOfProductCategoryListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultsOfProductCategoryListViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultsOfProductCategoryListViewModel>(<any>null);
    }

    getList(  cancelToken?: CancelToken | undefined): Promise<ProductCategoryViewModel[]> {
        let url_ = this.baseUrl + "/api/ProductCategory/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<ProductCategoryViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductCategoryViewModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductCategoryViewModel[]>(<any>null);
    }

    getListByOrderNumber(  cancelToken?: CancelToken | undefined): Promise<ProductCategoryOrderNumber[]> {
        let url_ = this.baseUrl + "/api/ProductCategory/list-by-orderNumber";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListByOrderNumber(_response);
        });
    }

    protected processGetListByOrderNumber(response: AxiosResponse): Promise<ProductCategoryOrderNumber[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductCategoryOrderNumber.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductCategoryOrderNumber[]>(<any>null);
    }

    updateOrderNumber(updateOrderNumbers: UpdateCategoryOrderNumbers , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ProductCategory/update-orderNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateOrderNumbers);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrderNumber(_response);
        });
    }

    protected processUpdateOrderNumber(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    getProductMenu(  cancelToken?: CancelToken | undefined): Promise<ProductMenu[]> {
        let url_ = this.baseUrl + "/api/ProductCategory/get-product-menu";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductMenu(_response);
        });
    }

    protected processGetProductMenu(response: AxiosResponse): Promise<ProductMenu[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductMenu.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductMenu[]>(<any>null);
    }

    getHighlightProductCategories(  cancelToken?: CancelToken | undefined): Promise<ProductMenuItem[]> {
        let url_ = this.baseUrl + "/api/ProductCategory/get-highlight-productCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHighlightProductCategories(_response);
        });
    }

    protected processGetHighlightProductCategories(response: AxiosResponse): Promise<ProductMenuItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductMenuItem.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductMenuItem[]>(<any>null);
    }
}

export class ProductClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "USE_ENVIRONMENT_VARIABLE";
    }

    getListPaged(pageNumber: number | undefined, pageSize: number | undefined, searchText: string | null | undefined, sortCriteria: string[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<PagedResultsOfProductListViewModel> {
        let url_ = this.baseUrl + "/api/Product/list-paged?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach(item => { url_ += "SortCriteria=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListPaged(_response);
        });
    }

    protected processGetListPaged(response: AxiosResponse): Promise<PagedResultsOfProductListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultsOfProductListViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultsOfProductListViewModel>(<any>null);
    }

    create(name: string | null | undefined, description: string | null | undefined, basicCharacteristics: string | null | undefined, price: number | undefined, imageFiles: FileParameter[] | null | undefined, status: ProductStatus | undefined, seoUrl: string | null | undefined, metaDescription: string | null | undefined, metaTitle: string | null | undefined, productCategoryId: number | undefined, types: ProductType[] | null | undefined, paperType: PaperType | undefined, haveMachining: boolean | undefined, noMachining: boolean | undefined, isAnotherProduct: boolean | undefined, isHiddenPrice: boolean | undefined, displayNumber: number | null | undefined, productPricingType: ProductPricingType | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (basicCharacteristics !== null && basicCharacteristics !== undefined)
            content_.append("BasicCharacteristics", basicCharacteristics.toString());
        if (price === null || price === undefined)
            throw new Error("The parameter 'price' cannot be null.");
        else
            content_.append("Price", price.toString());
        if (imageFiles !== null && imageFiles !== undefined)
            imageFiles.forEach(item_ => content_.append("ImageFiles", item_.data, item_.fileName ? item_.fileName : "ImageFiles") );
        if (status === null || status === undefined)
            throw new Error("The parameter 'status' cannot be null.");
        else
            content_.append("Status", status.toString());
        if (seoUrl !== null && seoUrl !== undefined)
            content_.append("SeoUrl", seoUrl.toString());
        if (metaDescription !== null && metaDescription !== undefined)
            content_.append("MetaDescription", metaDescription.toString());
        if (metaTitle !== null && metaTitle !== undefined)
            content_.append("MetaTitle", metaTitle.toString());
        if (productCategoryId === null || productCategoryId === undefined)
            throw new Error("The parameter 'productCategoryId' cannot be null.");
        else
            content_.append("ProductCategoryId", productCategoryId.toString());
        if (types !== null && types !== undefined)
            types.forEach(item_ => content_.append("Types", item_.toString()));
        if (paperType === null || paperType === undefined)
            throw new Error("The parameter 'paperType' cannot be null.");
        else
            content_.append("PaperType", paperType.toString());
        if (haveMachining === null || haveMachining === undefined)
            throw new Error("The parameter 'haveMachining' cannot be null.");
        else
            content_.append("HaveMachining", haveMachining.toString());
        if (noMachining === null || noMachining === undefined)
            throw new Error("The parameter 'noMachining' cannot be null.");
        else
            content_.append("NoMachining", noMachining.toString());
        if (isAnotherProduct === null || isAnotherProduct === undefined)
            throw new Error("The parameter 'isAnotherProduct' cannot be null.");
        else
            content_.append("IsAnotherProduct", isAnotherProduct.toString());
        if (isHiddenPrice === null || isHiddenPrice === undefined)
            throw new Error("The parameter 'isHiddenPrice' cannot be null.");
        else
            content_.append("IsHiddenPrice", isHiddenPrice.toString());
        if (displayNumber !== null && displayNumber !== undefined)
            content_.append("DisplayNumber", displayNumber.toString());
        if (productPricingType === null || productPricingType === undefined)
            throw new Error("The parameter 'productPricingType' cannot be null.");
        else
            content_.append("ProductPricingType", productPricingType.toString());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    edit(id: number, name: string | null | undefined, description: string | null | undefined, basicCharacteristics: string | null | undefined, price: number | undefined, imageFiles: FileParameter[] | null | undefined, imageLinks: string[] | null | undefined, status: ProductStatus | undefined, seoUrl: string | null | undefined, metaDescription: string | null | undefined, metaTitle: string | null | undefined, productCategoryId: number | undefined, types: ProductType[] | null | undefined, paperType: PaperType | undefined, haveMachining: boolean | undefined, noMachining: boolean | undefined, isAnotherProduct: boolean | undefined, isHiddenPrice: boolean | undefined, displayNumber: number | null | undefined, productPricingType: ProductPricingType | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Product/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (basicCharacteristics !== null && basicCharacteristics !== undefined)
            content_.append("BasicCharacteristics", basicCharacteristics.toString());
        if (price === null || price === undefined)
            throw new Error("The parameter 'price' cannot be null.");
        else
            content_.append("Price", price.toString());
        if (imageFiles !== null && imageFiles !== undefined)
            imageFiles.forEach(item_ => content_.append("ImageFiles", item_.data, item_.fileName ? item_.fileName : "ImageFiles") );
        if (imageLinks !== null && imageLinks !== undefined)
            imageLinks.forEach(item_ => content_.append("ImageLinks", item_.toString()));
        if (status === null || status === undefined)
            throw new Error("The parameter 'status' cannot be null.");
        else
            content_.append("Status", status.toString());
        if (seoUrl !== null && seoUrl !== undefined)
            content_.append("SeoUrl", seoUrl.toString());
        if (metaDescription !== null && metaDescription !== undefined)
            content_.append("MetaDescription", metaDescription.toString());
        if (metaTitle !== null && metaTitle !== undefined)
            content_.append("MetaTitle", metaTitle.toString());
        if (productCategoryId === null || productCategoryId === undefined)
            throw new Error("The parameter 'productCategoryId' cannot be null.");
        else
            content_.append("ProductCategoryId", productCategoryId.toString());
        if (types !== null && types !== undefined)
            types.forEach(item_ => content_.append("Types", item_.toString()));
        if (paperType === null || paperType === undefined)
            throw new Error("The parameter 'paperType' cannot be null.");
        else
            content_.append("PaperType", paperType.toString());
        if (haveMachining === null || haveMachining === undefined)
            throw new Error("The parameter 'haveMachining' cannot be null.");
        else
            content_.append("HaveMachining", haveMachining.toString());
        if (noMachining === null || noMachining === undefined)
            throw new Error("The parameter 'noMachining' cannot be null.");
        else
            content_.append("NoMachining", noMachining.toString());
        if (isAnotherProduct === null || isAnotherProduct === undefined)
            throw new Error("The parameter 'isAnotherProduct' cannot be null.");
        else
            content_.append("IsAnotherProduct", isAnotherProduct.toString());
        if (isHiddenPrice === null || isHiddenPrice === undefined)
            throw new Error("The parameter 'isHiddenPrice' cannot be null.");
        else
            content_.append("IsHiddenPrice", isHiddenPrice.toString());
        if (displayNumber !== null && displayNumber !== undefined)
            content_.append("DisplayNumber", displayNumber.toString());
        if (productPricingType === null || productPricingType === undefined)
            throw new Error("The parameter 'productPricingType' cannot be null.");
        else
            content_.append("ProductPricingType", productPricingType.toString());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    get(id: number , cancelToken?: CancelToken | undefined): Promise<ProductViewModel> {
        let url_ = this.baseUrl + "/api/Product/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ProductViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductViewModel>(<any>null);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Product/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getProductNames(  cancelToken?: CancelToken | undefined): Promise<ProductViewModel[]> {
        let url_ = this.baseUrl + "/api/Product/ProductNames";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductNames(_response);
        });
    }

    protected processGetProductNames(response: AxiosResponse): Promise<ProductViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductViewModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductViewModel[]>(<any>null);
    }

    getCatalogueMaterials(  cancelToken?: CancelToken | undefined): Promise<CatalogueMaterialsViewModel[]> {
        let url_ = this.baseUrl + "/api/Product/GetCatalogueMaterials";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCatalogueMaterials(_response);
        });
    }

    protected processGetCatalogueMaterials(response: AxiosResponse): Promise<CatalogueMaterialsViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CatalogueMaterialsViewModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogueMaterialsViewModel[]>(<any>null);
    }

    getCatalogueProductItems(  cancelToken?: CancelToken | undefined): Promise<SelectModelOfGuid[]> {
        let url_ = this.baseUrl + "/api/Product/get-catalogue-product-items";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCatalogueProductItems(_response);
        });
    }

    protected processGetCatalogueProductItems(response: AxiosResponse): Promise<SelectModelOfGuid[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectModelOfGuid.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SelectModelOfGuid[]>(<any>null);
    }

    getProcessingTypes(productId: number | undefined , cancelToken?: CancelToken | undefined): Promise<ProcessingTypeModel[]> {
        let url_ = this.baseUrl + "/api/Product/get-processing-types?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProcessingTypes(_response);
        });
    }

    protected processGetProcessingTypes(response: AxiosResponse): Promise<ProcessingTypeModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcessingTypeModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessingTypeModel[]>(<any>null);
    }

    createProcessingType(input: ProcessingTypeInput , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Product/create-processing-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProcessingType(_response);
        });
    }

    protected processCreateProcessingType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    getProductMenuSetting(  cancelToken?: CancelToken | undefined): Promise<ProductMenuSettingModel[]> {
        let url_ = this.baseUrl + "/api/Product/get-product-menu-setting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductMenuSetting(_response);
        });
    }

    protected processGetProductMenuSetting(response: AxiosResponse): Promise<ProductMenuSettingModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductMenuSettingModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductMenuSettingModel[]>(<any>null);
    }

    createProductMenuSetting(id: string | null | undefined, productId: number | null | undefined, categoryId: number | undefined, ordinal: number | undefined, image: FileParameter | null | undefined, productMenuTypeId: number | undefined, isChangeImage: boolean | undefined, url: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Product/create-product-menu-setting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (productId !== null && productId !== undefined)
            content_.append("ProductId", productId.toString());
        if (categoryId === null || categoryId === undefined)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else
            content_.append("CategoryId", categoryId.toString());
        if (ordinal === null || ordinal === undefined)
            throw new Error("The parameter 'ordinal' cannot be null.");
        else
            content_.append("Ordinal", ordinal.toString());
        if (image !== null && image !== undefined)
            content_.append("Image", image.data, image.fileName ? image.fileName : "Image");
        if (productMenuTypeId === null || productMenuTypeId === undefined)
            throw new Error("The parameter 'productMenuTypeId' cannot be null.");
        else
            content_.append("ProductMenuTypeId", productMenuTypeId.toString());
        if (isChangeImage === null || isChangeImage === undefined)
            throw new Error("The parameter 'isChangeImage' cannot be null.");
        else
            content_.append("IsChangeImage", isChangeImage.toString());
        if (url !== null && url !== undefined)
            content_.append("Url", url.toString());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProductMenuSetting(_response);
        });
    }

    protected processCreateProductMenuSetting(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    updateProductMenuSetting(id: string | null | undefined, productId: number | null | undefined, categoryId: number | undefined, ordinal: number | undefined, image: FileParameter | null | undefined, productMenuTypeId: number | undefined, isChangeImage: boolean | undefined, url: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Product/update-product-menu-setting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (productId !== null && productId !== undefined)
            content_.append("ProductId", productId.toString());
        if (categoryId === null || categoryId === undefined)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else
            content_.append("CategoryId", categoryId.toString());
        if (ordinal === null || ordinal === undefined)
            throw new Error("The parameter 'ordinal' cannot be null.");
        else
            content_.append("Ordinal", ordinal.toString());
        if (image !== null && image !== undefined)
            content_.append("Image", image.data, image.fileName ? image.fileName : "Image");
        if (productMenuTypeId === null || productMenuTypeId === undefined)
            throw new Error("The parameter 'productMenuTypeId' cannot be null.");
        else
            content_.append("ProductMenuTypeId", productMenuTypeId.toString());
        if (isChangeImage === null || isChangeImage === undefined)
            throw new Error("The parameter 'isChangeImage' cannot be null.");
        else
            content_.append("IsChangeImage", isChangeImage.toString());
        if (url !== null && url !== undefined)
            content_.append("Url", url.toString());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProductMenuSetting(_response);
        });
    }

    protected processUpdateProductMenuSetting(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    removeProductMenuSetting(id: string | null | undefined, productId: number | null | undefined, categoryId: number | undefined, ordinal: number | undefined, image: FileParameter | null | undefined, productMenuTypeId: number | undefined, isChangeImage: boolean | undefined, url: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Product/remove-product-menu-setting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (productId !== null && productId !== undefined)
            content_.append("ProductId", productId.toString());
        if (categoryId === null || categoryId === undefined)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else
            content_.append("CategoryId", categoryId.toString());
        if (ordinal === null || ordinal === undefined)
            throw new Error("The parameter 'ordinal' cannot be null.");
        else
            content_.append("Ordinal", ordinal.toString());
        if (image !== null && image !== undefined)
            content_.append("Image", image.data, image.fileName ? image.fileName : "Image");
        if (productMenuTypeId === null || productMenuTypeId === undefined)
            throw new Error("The parameter 'productMenuTypeId' cannot be null.");
        else
            content_.append("ProductMenuTypeId", productMenuTypeId.toString());
        if (isChangeImage === null || isChangeImage === undefined)
            throw new Error("The parameter 'isChangeImage' cannot be null.");
        else
            content_.append("IsChangeImage", isChangeImage.toString());
        if (url !== null && url !== undefined)
            content_.append("Url", url.toString());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveProductMenuSetting(_response);
        });
    }

    protected processRemoveProductMenuSetting(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    updateProductMenuType(productMenuTypeInput: ProductMenuTypeInput , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Product/update-product-menu-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productMenuTypeInput);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProductMenuType(_response);
        });
    }

    protected processUpdateProductMenuType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500 !== undefined ? resultData500 : <any>null;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }

    getProductMaterialsByProductId(productId: number , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Product/Client/GetProductMaterialsByProductId/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductMaterialsByProductId(_response);
        });
    }

    protected processGetProductMaterialsByProductId(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getStickerMaterials(  cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Product/Client/GetStickerMaterials";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStickerMaterials(_response);
        });
    }

    protected processGetStickerMaterials(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getHastagPrices(  cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Product/Client/GetHastagPrices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHastagPrices(_response);
        });
    }

    protected processGetHastagPrices(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getCatalogueMaterialData(  cancelToken?: CancelToken | undefined): Promise<CatalogueMaterials> {
        let url_ = this.baseUrl + "/api/Product/Client/GetCatalogueMaterialData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCatalogueMaterialData(_response);
        });
    }

    protected processGetCatalogueMaterialData(response: AxiosResponse): Promise<CatalogueMaterials> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogueMaterials.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogueMaterials>(<any>null);
    }

    getCataloguePrices(  cancelToken?: CancelToken | undefined): Promise<CataloguePriceViewModel[]> {
        let url_ = this.baseUrl + "/api/Product/Client/GetCataloguePrices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCataloguePrices(_response);
        });
    }

    protected processGetCataloguePrices(response: AxiosResponse): Promise<CataloguePriceViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CataloguePriceViewModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CataloguePriceViewModel[]>(<any>null);
    }

    getProductCart(productIds: number[] , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Product/Client/GetProductCart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productIds);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductCart(_response);
        });
    }

    protected processGetProductCart(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getProductDetail(productId: number , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Product/Client/GetProductDetail/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductDetail(_response);
        });
    }

    protected processGetProductDetail(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getStandeeMaterials(  cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Product/Client/GetStandeeMaterials";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStandeeMaterials(_response);
        });
    }

    protected processGetStandeeMaterials(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class RevenueStatisticsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "USE_ENVIRONMENT_VARIABLE";
    }

    getList(pageNumber: number | undefined, pageSize: number | undefined, searchText: string | null | undefined, sortCriteria: string[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<PagedResultsOfRevenueStatisticsListViewModel> {
        let url_ = this.baseUrl + "/api/RevenueStatistics/list?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach(item => { url_ += "SortCriteria=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<PagedResultsOfRevenueStatisticsListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultsOfRevenueStatisticsListViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultsOfRevenueStatisticsListViewModel>(<any>null);
    }

    getByEmployee(year: number | undefined , cancelToken?: CancelToken | undefined): Promise<RevenueStatisticsByEmployee[]> {
        let url_ = this.baseUrl + "/api/RevenueStatistics/GetByEmployee?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByEmployee(_response);
        });
    }

    protected processGetByEmployee(response: AxiosResponse): Promise<RevenueStatisticsByEmployee[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RevenueStatisticsByEmployee.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RevenueStatisticsByEmployee[]>(<any>null);
    }

    getByProductCategoryInMonth(pageNumber: number | undefined, pageSize: number | null | undefined , cancelToken?: CancelToken | undefined): Promise<RevenueStatisticsByProductCategory[]> {
        let url_ = this.baseUrl + "/api/RevenueStatistics/GetByProductCategoryInMonth?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByProductCategoryInMonth(_response);
        });
    }

    protected processGetByProductCategoryInMonth(response: AxiosResponse): Promise<RevenueStatisticsByProductCategory[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RevenueStatisticsByProductCategory.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RevenueStatisticsByProductCategory[]>(<any>null);
    }

    getByProductCategoryInWeek(pageNumber: number | undefined, pageSize: number | null | undefined , cancelToken?: CancelToken | undefined): Promise<RevenueStatisticsByProductCategory[]> {
        let url_ = this.baseUrl + "/api/RevenueStatistics/GetByProductCategoryInWeek?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByProductCategoryInWeek(_response);
        });
    }

    protected processGetByProductCategoryInWeek(response: AxiosResponse): Promise<RevenueStatisticsByProductCategory[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RevenueStatisticsByProductCategory.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RevenueStatisticsByProductCategory[]>(<any>null);
    }
}

export class SampleClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "USE_ENVIRONMENT_VARIABLE";
    }

    create(name: string | null | undefined, status: BaseStatus | undefined, description: string | null | undefined, image: FileParameter | null | undefined, shapeId: number | null | undefined, sampleTypeId: number | null | undefined, produCategoryId: number | undefined, sampleTypeIds: number[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Sample";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (status === null || status === undefined)
            throw new Error("The parameter 'status' cannot be null.");
        else
            content_.append("Status", status.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (image !== null && image !== undefined)
            content_.append("Image", image.data, image.fileName ? image.fileName : "Image");
        if (shapeId !== null && shapeId !== undefined)
            content_.append("ShapeId", shapeId.toString());
        if (sampleTypeId !== null && sampleTypeId !== undefined)
            content_.append("SampleTypeId", sampleTypeId.toString());
        if (produCategoryId === null || produCategoryId === undefined)
            throw new Error("The parameter 'produCategoryId' cannot be null.");
        else
            content_.append("ProduCategoryId", produCategoryId.toString());
        if (sampleTypeIds !== null && sampleTypeIds !== undefined)
            sampleTypeIds.forEach(item_ => content_.append("SampleTypeIds", item_.toString()));

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    edit(id: number, name: string | null | undefined, status: BaseStatus | undefined, description: string | null | undefined, image: FileParameter | null | undefined, shapeId: number | null | undefined, sampleTypeId: number | null | undefined, produCategoryId: number | undefined, sampleTypeIds: number[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Sample/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (status === null || status === undefined)
            throw new Error("The parameter 'status' cannot be null.");
        else
            content_.append("Status", status.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (image !== null && image !== undefined)
            content_.append("Image", image.data, image.fileName ? image.fileName : "Image");
        if (shapeId !== null && shapeId !== undefined)
            content_.append("ShapeId", shapeId.toString());
        if (sampleTypeId !== null && sampleTypeId !== undefined)
            content_.append("SampleTypeId", sampleTypeId.toString());
        if (produCategoryId === null || produCategoryId === undefined)
            throw new Error("The parameter 'produCategoryId' cannot be null.");
        else
            content_.append("ProduCategoryId", produCategoryId.toString());
        if (sampleTypeIds !== null && sampleTypeIds !== undefined)
            sampleTypeIds.forEach(item_ => content_.append("SampleTypeIds", item_.toString()));

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    get(id: number , cancelToken?: CancelToken | undefined): Promise<SampleViewModel> {
        let url_ = this.baseUrl + "/api/Sample/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<SampleViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SampleViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SampleViewModel>(<any>null);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Sample/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getList(shapeId: number | undefined, sampleTypeId: number | undefined, productCategoryId: number | undefined, status: BaseStatus | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchText: string | null | undefined, sortCriteria: string[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<PagedResultsOfSampleListViewModel> {
        let url_ = this.baseUrl + "/api/Sample/list?";
        if (shapeId === null)
            throw new Error("The parameter 'shapeId' cannot be null.");
        else if (shapeId !== undefined)
            url_ += "ShapeId=" + encodeURIComponent("" + shapeId) + "&";
        if (sampleTypeId === null)
            throw new Error("The parameter 'sampleTypeId' cannot be null.");
        else if (sampleTypeId !== undefined)
            url_ += "SampleTypeId=" + encodeURIComponent("" + sampleTypeId) + "&";
        if (productCategoryId === null)
            throw new Error("The parameter 'productCategoryId' cannot be null.");
        else if (productCategoryId !== undefined)
            url_ += "ProductCategoryId=" + encodeURIComponent("" + productCategoryId) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach(item => { url_ += "SortCriteria=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<PagedResultsOfSampleListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultsOfSampleListViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultsOfSampleListViewModel>(<any>null);
    }
}

export class SampleTypeClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "USE_ENVIRONMENT_VARIABLE";
    }

    getList(isIncludeInactive: boolean | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchText: string | null | undefined, sortCriteria: string[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<PagedResultsOfSampleTypeListViewModel> {
        let url_ = this.baseUrl + "/api/SampleType/list?";
        if (isIncludeInactive === null)
            throw new Error("The parameter 'isIncludeInactive' cannot be null.");
        else if (isIncludeInactive !== undefined)
            url_ += "IsIncludeInactive=" + encodeURIComponent("" + isIncludeInactive) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach(item => { url_ += "SortCriteria=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<PagedResultsOfSampleTypeListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultsOfSampleTypeListViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultsOfSampleTypeListViewModel>(<any>null);
    }

    create(name: string | null | undefined, status: BaseStatus | undefined, type: SampleLibraryType | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SampleType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (status === null || status === undefined)
            throw new Error("The parameter 'status' cannot be null.");
        else
            content_.append("Status", status.toString());
        if (type === null || type === undefined)
            throw new Error("The parameter 'type' cannot be null.");
        else
            content_.append("Type", type.toString());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    edit(id: number, name: string | null | undefined, status: BaseStatus | undefined, type: SampleLibraryType | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SampleType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (status === null || status === undefined)
            throw new Error("The parameter 'status' cannot be null.");
        else
            content_.append("Status", status.toString());
        if (type === null || type === undefined)
            throw new Error("The parameter 'type' cannot be null.");
        else
            content_.append("Type", type.toString());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    get(id: number , cancelToken?: CancelToken | undefined): Promise<SampleTypeViewModel> {
        let url_ = this.baseUrl + "/api/SampleType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<SampleTypeViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SampleTypeViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SampleTypeViewModel>(<any>null);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SampleType/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class SettingClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "USE_ENVIRONMENT_VARIABLE";
    }

    getList(pageNumber: number | undefined, pageSize: number | undefined, searchText: string | null | undefined, sortCriteria: string[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<PagedResultsOfSettingListViewModel> {
        let url_ = this.baseUrl + "/api/Setting/list?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach(item => { url_ += "SortCriteria=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<PagedResultsOfSettingListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultsOfSettingListViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultsOfSettingListViewModel>(<any>null);
    }

    edit(id: number, name: string | null | undefined, image: FileParameter | null | undefined, content: string | null | undefined, type: SettingType | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Setting/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (image !== null && image !== undefined)
            content_.append("Image", image.data, image.fileName ? image.fileName : "Image");
        if (content !== null && content !== undefined)
            content_.append("Content", content.toString());
        if (type === null || type === undefined)
            throw new Error("The parameter 'type' cannot be null.");
        else
            content_.append("Type", type.toString());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    get(id: number , cancelToken?: CancelToken | undefined): Promise<SettingViewModel> {
        let url_ = this.baseUrl + "/api/Setting/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<SettingViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SettingViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SettingViewModel>(<any>null);
    }

    getMasterData(  cancelToken?: CancelToken | undefined): Promise<MasterDataViewModel> {
        let url_ = this.baseUrl + "/api/Setting/GetMasterData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMasterData(_response);
        });
    }

    protected processGetMasterData(response: AxiosResponse): Promise<MasterDataViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MasterDataViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MasterDataViewModel>(<any>null);
    }

    getSettingItemByCode(code: string | null , cancelToken?: CancelToken | undefined): Promise<SettingViewModel> {
        let url_ = this.baseUrl + "/api/Setting/Client/get-setting-item-by-code/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettingItemByCode(_response);
        });
    }

    protected processGetSettingItemByCode(response: AxiosResponse): Promise<SettingViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SettingViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SettingViewModel>(<any>null);
    }
}

export class ShapeClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "USE_ENVIRONMENT_VARIABLE";
    }

    create(name: string | null | undefined, status: ShapeStatus | undefined, description: string | null | undefined, image: FileParameter | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Shape";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (status === null || status === undefined)
            throw new Error("The parameter 'status' cannot be null.");
        else
            content_.append("Status", status.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (image !== null && image !== undefined)
            content_.append("Image", image.data, image.fileName ? image.fileName : "Image");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    edit(id: number, name: string | null | undefined, status: ShapeStatus | undefined, description: string | null | undefined, image: FileParameter | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Shape/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (status === null || status === undefined)
            throw new Error("The parameter 'status' cannot be null.");
        else
            content_.append("Status", status.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (image !== null && image !== undefined)
            content_.append("Image", image.data, image.fileName ? image.fileName : "Image");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    get(id: number , cancelToken?: CancelToken | undefined): Promise<ShapeViewModel> {
        let url_ = this.baseUrl + "/api/Shape/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ShapeViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ShapeViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShapeViewModel>(<any>null);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Shape/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getList(pageNumber: number | undefined, pageSize: number | undefined, searchText: string | null | undefined, sortCriteria: string[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<PagedResultsOfShapeListViewModel> {
        let url_ = this.baseUrl + "/api/Shape/list?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach(item => { url_ += "SortCriteria=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<PagedResultsOfShapeListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultsOfShapeListViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultsOfShapeListViewModel>(<any>null);
    }
}

export class SliderClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "USE_ENVIRONMENT_VARIABLE";
    }

    getList(  cancelToken?: CancelToken | undefined): Promise<SliderViewModel> {
        let url_ = this.baseUrl + "/api/Slider";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<SliderViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SliderViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SliderViewModel>(<any>null);
    }

    create(imageFiles: FileParameter[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Slider";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (imageFiles !== null && imageFiles !== undefined)
            imageFiles.forEach(item_ => content_.append("ImageFiles", item_.data, item_.fileName ? item_.fileName : "ImageFiles") );

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    edit(imageFiles: FileParameter[] | null | undefined, imageLinks: string[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Slider";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (imageFiles !== null && imageFiles !== undefined)
            imageFiles.forEach(item_ => content_.append("ImageFiles", item_.data, item_.fileName ? item_.fileName : "ImageFiles") );
        if (imageLinks !== null && imageLinks !== undefined)
            imageLinks.forEach(item_ => content_.append("ImageLinks", item_.toString()));

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class SuppliesCategoryClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "USE_ENVIRONMENT_VARIABLE";
    }

    create(name: string | null | undefined, metaDescription: string | null | undefined, orderNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SuppliesCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (metaDescription !== null && metaDescription !== undefined)
            content_.append("MetaDescription", metaDescription.toString());
        if (orderNumber === null || orderNumber === undefined)
            throw new Error("The parameter 'orderNumber' cannot be null.");
        else
            content_.append("OrderNumber", orderNumber.toString());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    edit(id: number, name: string | null | undefined, metaDescription: string | null | undefined, orderNumber: number | undefined, status: BaseStatus | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SuppliesCategory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (metaDescription !== null && metaDescription !== undefined)
            content_.append("MetaDescription", metaDescription.toString());
        if (orderNumber === null || orderNumber === undefined)
            throw new Error("The parameter 'orderNumber' cannot be null.");
        else
            content_.append("OrderNumber", orderNumber.toString());
        if (status === null || status === undefined)
            throw new Error("The parameter 'status' cannot be null.");
        else
            content_.append("Status", status.toString());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    get(id: number , cancelToken?: CancelToken | undefined): Promise<SuppliesCategoryViewModel> {
        let url_ = this.baseUrl + "/api/SuppliesCategory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<SuppliesCategoryViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SuppliesCategoryViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuppliesCategoryViewModel>(<any>null);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SuppliesCategory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getListPaged(pageNumber: number | undefined, pageSize: number | undefined, searchText: string | null | undefined, sortCriteria: string[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<PagedResultsOfSuppliesCategoryViewModel> {
        let url_ = this.baseUrl + "/api/SuppliesCategory/list-paged?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach(item => { url_ += "SortCriteria=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListPaged(_response);
        });
    }

    protected processGetListPaged(response: AxiosResponse): Promise<PagedResultsOfSuppliesCategoryViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultsOfSuppliesCategoryViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultsOfSuppliesCategoryViewModel>(<any>null);
    }

    getList(  cancelToken?: CancelToken | undefined): Promise<SuppliesCategoryViewModel[]> {
        let url_ = this.baseUrl + "/api/SuppliesCategory/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<SuppliesCategoryViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SuppliesCategoryViewModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuppliesCategoryViewModel[]>(<any>null);
    }

    getListByOrderNumber(  cancelToken?: CancelToken | undefined): Promise<SuppliesCategoryOrderNumber[]> {
        let url_ = this.baseUrl + "/api/SuppliesCategory/list-by-orderNumber";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListByOrderNumber(_response);
        });
    }

    protected processGetListByOrderNumber(response: AxiosResponse): Promise<SuppliesCategoryOrderNumber[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SuppliesCategoryOrderNumber.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuppliesCategoryOrderNumber[]>(<any>null);
    }

    updateOrderNumber(updateOrderNumbers: UpdateSuppliesCategoryOrderNumbers , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SuppliesCategory/update-orderNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateOrderNumbers);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrderNumber(_response);
        });
    }

    protected processUpdateOrderNumber(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class SuppliesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "USE_ENVIRONMENT_VARIABLE";
    }

    getListPaged(pageNumber: number | undefined, pageSize: number | undefined, searchText: string | null | undefined, sortCriteria: string[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<PagedResultsOfSuppliesViewModel> {
        let url_ = this.baseUrl + "/api/Supplies/list-paged?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach(item => { url_ += "SortCriteria=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListPaged(_response);
        });
    }

    protected processGetListPaged(response: AxiosResponse): Promise<PagedResultsOfSuppliesViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedResultsOfSuppliesViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedResultsOfSuppliesViewModel>(<any>null);
    }

    create(name: string | null | undefined, description: string | null | undefined, price: number | undefined, suppliesCategoryId: number | undefined, orderNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Supplies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (price === null || price === undefined)
            throw new Error("The parameter 'price' cannot be null.");
        else
            content_.append("Price", price.toString());
        if (suppliesCategoryId === null || suppliesCategoryId === undefined)
            throw new Error("The parameter 'suppliesCategoryId' cannot be null.");
        else
            content_.append("SuppliesCategoryId", suppliesCategoryId.toString());
        if (orderNumber === null || orderNumber === undefined)
            throw new Error("The parameter 'orderNumber' cannot be null.");
        else
            content_.append("OrderNumber", orderNumber.toString());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    edit(id: number, name: string | null | undefined, description: string | null | undefined, orderNumber: number | undefined, suppliesCategoryId: number | undefined, status: BaseStatus | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Supplies/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (orderNumber === null || orderNumber === undefined)
            throw new Error("The parameter 'orderNumber' cannot be null.");
        else
            content_.append("OrderNumber", orderNumber.toString());
        if (suppliesCategoryId === null || suppliesCategoryId === undefined)
            throw new Error("The parameter 'suppliesCategoryId' cannot be null.");
        else
            content_.append("SuppliesCategoryId", suppliesCategoryId.toString());
        if (status === null || status === undefined)
            throw new Error("The parameter 'status' cannot be null.");
        else
            content_.append("Status", status.toString());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    get(id: number , cancelToken?: CancelToken | undefined): Promise<SuppliesViewModel> {
        let url_ = this.baseUrl + "/api/Supplies/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<SuppliesViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SuppliesViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuppliesViewModel>(<any>null);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Supplies/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getSuppliesNames(  cancelToken?: CancelToken | undefined): Promise<BaseValueModelOfInteger[]> {
        let url_ = this.baseUrl + "/api/Supplies/SuppliesNames";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSuppliesNames(_response);
        });
    }

    protected processGetSuppliesNames(response: AxiosResponse): Promise<BaseValueModelOfInteger[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BaseValueModelOfInteger.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BaseValueModelOfInteger[]>(<any>null);
    }

    getSuppliesList(  cancelToken?: CancelToken | undefined): Promise<SuppliesViewModel[]> {
        let url_ = this.baseUrl + "/api/Supplies/SuppliesList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSuppliesList(_response);
        });
    }

    protected processGetSuppliesList(response: AxiosResponse): Promise<SuppliesViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SuppliesViewModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SuppliesViewModel[]>(<any>null);
    }
}

export class VendorClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "USE_ENVIRONMENT_VARIABLE";
    }

    create(id: string | undefined, name: string | null | undefined, phoneNumber: string | null | undefined, address: string | null | undefined, email: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Vendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (phoneNumber !== null && phoneNumber !== undefined)
            content_.append("PhoneNumber", phoneNumber.toString());
        if (address !== null && address !== undefined)
            content_.append("Address", address.toString());
        if (email !== null && email !== undefined)
            content_.append("Email", email.toString());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    edit(id: string | undefined, name: string | null | undefined, phoneNumber: string | null | undefined, address: string | null | undefined, email: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Vendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (phoneNumber !== null && phoneNumber !== undefined)
            content_.append("PhoneNumber", phoneNumber.toString());
        if (address !== null && address !== undefined)
            content_.append("Address", address.toString());
        if (email !== null && email !== undefined)
            content_.append("Email", email.toString());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    get(id: string , cancelToken?: CancelToken | undefined): Promise<VendorModel> {
        let url_ = this.baseUrl + "/api/Vendor/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<VendorModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VendorModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VendorModel>(<any>null);
    }

    getList(  cancelToken?: CancelToken | undefined): Promise<VendorModel[]> {
        let url_ = this.baseUrl + "/api/Vendor/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<VendorModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VendorModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VendorModel[]>(<any>null);
    }
}

export class ZaloClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "USE_ENVIRONMENT_VARIABLE";
    }

    getCodeChallenge(  cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Zalo/GetCodeChallenge";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCodeChallenge(_response);
        });
    }

    protected processGetCodeChallenge(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    callBackAuthorizationCode(code: string | null | undefined, oa_id: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Zalo/CallBackAuthorizationCode?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (oa_id !== undefined && oa_id !== null)
            url_ += "oa_id=" + encodeURIComponent("" + oa_id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCallBackAuthorizationCode(_response);
        });
    }

    protected processCallBackAuthorizationCode(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    encryptValue(value: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Zalo/EncryptValue?";
        if (value !== undefined && value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEncryptValue(_response);
        });
    }

    protected processEncryptValue(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    decryptValue(value: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Zalo/DecryptValue?";
        if (value !== undefined && value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDecryptValue(_response);
        });
    }

    protected processDecryptValue(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }

    loadTokensFromFile(  cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Zalo/LoadTokensFromFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoadTokensFromFile(_response);
        });
    }

    protected processLoadTokensFromFile(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class ActivityLogModel implements IActivityLogModel {
    id!: string;
    userName?: string | undefined;
    entityName?: string | undefined;
    entityId?: string | undefined;
    type!: number;
    typeDesc?: string | undefined;
    date!: Date;
    oldValues?: { [key: string]: string; } | undefined;
    newValues?: { [key: string]: string; } | undefined;

    constructor(data?: IActivityLogModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.entityName = _data["entityName"];
            this.entityId = _data["entityId"];
            this.type = _data["type"];
            this.typeDesc = _data["typeDesc"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            if (_data["oldValues"]) {
                this.oldValues = {} as any;
                for (let key in _data["oldValues"]) {
                    if (_data["oldValues"].hasOwnProperty(key))
                        this.oldValues![key] = _data["oldValues"][key];
                }
            }
            if (_data["newValues"]) {
                this.newValues = {} as any;
                for (let key in _data["newValues"]) {
                    if (_data["newValues"].hasOwnProperty(key))
                        this.newValues![key] = _data["newValues"][key];
                }
            }
        }
    }

    static fromJS(data: any): ActivityLogModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLogModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["entityName"] = this.entityName;
        data["entityId"] = this.entityId;
        data["type"] = this.type;
        data["typeDesc"] = this.typeDesc;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (this.oldValues) {
            data["oldValues"] = {};
            for (let key in this.oldValues) {
                if (this.oldValues.hasOwnProperty(key))
                    data["oldValues"][key] = this.oldValues[key];
            }
        }
        if (this.newValues) {
            data["newValues"] = {};
            for (let key in this.newValues) {
                if (this.newValues.hasOwnProperty(key))
                    data["newValues"][key] = this.newValues[key];
            }
        }
        return data; 
    }
}

export interface IActivityLogModel {
    id: string;
    userName?: string | undefined;
    entityName?: string | undefined;
    entityId?: string | undefined;
    type: number;
    typeDesc?: string | undefined;
    date: Date;
    oldValues?: { [key: string]: string; } | undefined;
    newValues?: { [key: string]: string; } | undefined;
}

export class Token implements IToken {
    uId?: string | undefined;
    expiration!: Date;
    accessToken?: string | undefined;
    claims?: string[] | undefined;

    constructor(data?: IToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uId = _data["uId"];
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : <any>undefined;
            this.accessToken = _data["accessToken"];
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(item);
            }
        }
    }

    static fromJS(data: any): Token {
        data = typeof data === 'object' ? data : {};
        let result = new Token();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uId"] = this.uId;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : <any>undefined;
        data["accessToken"] = this.accessToken;
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item);
        }
        return data; 
    }
}

export interface IToken {
    uId?: string | undefined;
    expiration: Date;
    accessToken?: string | undefined;
    claims?: string[] | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; } | undefined;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        this.extensions![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    data["extensions"][key] = this.extensions[key];
            }
        }
        return data; 
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; } | undefined;
}

export class LoginInput implements ILoginInput {
    userName?: string | undefined;
    password?: string | undefined;

    constructor(data?: ILoginInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginInput {
        data = typeof data === 'object' ? data : {};
        let result = new LoginInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data; 
    }
}

export interface ILoginInput {
    userName?: string | undefined;
    password?: string | undefined;
}

export class ZaloVerificationInput implements IZaloVerificationInput {
    phoneNumber!: string;

    constructor(data?: IZaloVerificationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): ZaloVerificationInput {
        data = typeof data === 'object' ? data : {};
        let result = new ZaloVerificationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        return data; 
    }
}

export interface IZaloVerificationInput {
    phoneNumber: string;
}

export class PagedResultsOfBlogListViewModel implements IPagedResultsOfBlogListViewModel {
    resultCount!: number;
    pageNumber!: number;
    totalPages!: number;
    pageSize!: number;
    results?: BlogListViewModel[] | undefined;

    constructor(data?: IPagedResultsOfBlogListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(BlogListViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultsOfBlogListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultsOfBlogListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultsOfBlogListViewModel {
    resultCount: number;
    pageNumber: number;
    totalPages: number;
    pageSize: number;
    results?: BlogListViewModel[] | undefined;
}

export class BlogListViewModel implements IBlogListViewModel {
    id!: number;
    title?: string | undefined;
    description?: string | undefined;
    image?: string | undefined;
    blogType!: BlogType;
    seoUrl?: string | undefined;
    metaDescription?: string | undefined;
    metaTitle?: string | undefined;

    constructor(data?: IBlogListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.image = _data["image"];
            this.blogType = _data["blogType"];
            this.seoUrl = _data["seoUrl"];
            this.metaDescription = _data["metaDescription"];
            this.metaTitle = _data["metaTitle"];
        }
    }

    static fromJS(data: any): BlogListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BlogListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["image"] = this.image;
        data["blogType"] = this.blogType;
        data["seoUrl"] = this.seoUrl;
        data["metaDescription"] = this.metaDescription;
        data["metaTitle"] = this.metaTitle;
        return data; 
    }
}

export interface IBlogListViewModel {
    id: number;
    title?: string | undefined;
    description?: string | undefined;
    image?: string | undefined;
    blogType: BlogType;
    seoUrl?: string | undefined;
    metaDescription?: string | undefined;
    metaTitle?: string | undefined;
}

export enum BlogType {
    Coupon = 1,
    Assist = 2,
}

export class BlogViewModel implements IBlogViewModel {
    id!: number;
    title?: string | undefined;
    description?: string | undefined;
    image?: string | undefined;
    content?: string | undefined;
    blogType!: BlogType;
    seoUrl?: string | undefined;
    metaDescription?: string | undefined;
    metaTitle?: string | undefined;

    constructor(data?: IBlogViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.image = _data["image"];
            this.content = _data["content"];
            this.blogType = _data["blogType"];
            this.seoUrl = _data["seoUrl"];
            this.metaDescription = _data["metaDescription"];
            this.metaTitle = _data["metaTitle"];
        }
    }

    static fromJS(data: any): BlogViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BlogViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["image"] = this.image;
        data["content"] = this.content;
        data["blogType"] = this.blogType;
        data["seoUrl"] = this.seoUrl;
        data["metaDescription"] = this.metaDescription;
        data["metaTitle"] = this.metaTitle;
        return data; 
    }
}

export interface IBlogViewModel {
    id: number;
    title?: string | undefined;
    description?: string | undefined;
    image?: string | undefined;
    content?: string | undefined;
    blogType: BlogType;
    seoUrl?: string | undefined;
    metaDescription?: string | undefined;
    metaTitle?: string | undefined;
}

export class PagedResultsOfContentPageListViewModel implements IPagedResultsOfContentPageListViewModel {
    resultCount!: number;
    pageNumber!: number;
    totalPages!: number;
    pageSize!: number;
    results?: ContentPageListViewModel[] | undefined;

    constructor(data?: IPagedResultsOfContentPageListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ContentPageListViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultsOfContentPageListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultsOfContentPageListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultsOfContentPageListViewModel {
    resultCount: number;
    pageNumber: number;
    totalPages: number;
    pageSize: number;
    results?: ContentPageListViewModel[] | undefined;
}

export class ContentPageListViewModel implements IContentPageListViewModel {
    id!: number;
    title?: string | undefined;
    seoUrl?: string | undefined;
    metaDescription?: string | undefined;

    constructor(data?: IContentPageListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.seoUrl = _data["seoUrl"];
            this.metaDescription = _data["metaDescription"];
        }
    }

    static fromJS(data: any): ContentPageListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContentPageListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["seoUrl"] = this.seoUrl;
        data["metaDescription"] = this.metaDescription;
        return data; 
    }
}

export interface IContentPageListViewModel {
    id: number;
    title?: string | undefined;
    seoUrl?: string | undefined;
    metaDescription?: string | undefined;
}

export class CreateContentPageInput implements ICreateContentPageInput {
    title!: string;
    content!: string;
    seoUrl!: string;
    metaDescription?: string | undefined;
    metaTitle?: string | undefined;

    constructor(data?: ICreateContentPageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.content = _data["content"];
            this.seoUrl = _data["seoUrl"];
            this.metaDescription = _data["metaDescription"];
            this.metaTitle = _data["metaTitle"];
        }
    }

    static fromJS(data: any): CreateContentPageInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContentPageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["content"] = this.content;
        data["seoUrl"] = this.seoUrl;
        data["metaDescription"] = this.metaDescription;
        data["metaTitle"] = this.metaTitle;
        return data; 
    }
}

export interface ICreateContentPageInput {
    title: string;
    content: string;
    seoUrl: string;
    metaDescription?: string | undefined;
    metaTitle?: string | undefined;
}

export class EditContentPageInput implements IEditContentPageInput {
    title!: string;
    content!: string;
    seoUrl!: string;
    metaDescription?: string | undefined;
    metaTitle?: string | undefined;

    constructor(data?: IEditContentPageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.content = _data["content"];
            this.seoUrl = _data["seoUrl"];
            this.metaDescription = _data["metaDescription"];
            this.metaTitle = _data["metaTitle"];
        }
    }

    static fromJS(data: any): EditContentPageInput {
        data = typeof data === 'object' ? data : {};
        let result = new EditContentPageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["content"] = this.content;
        data["seoUrl"] = this.seoUrl;
        data["metaDescription"] = this.metaDescription;
        data["metaTitle"] = this.metaTitle;
        return data; 
    }
}

export interface IEditContentPageInput {
    title: string;
    content: string;
    seoUrl: string;
    metaDescription?: string | undefined;
    metaTitle?: string | undefined;
}

export class ContentPageViewModel implements IContentPageViewModel {
    id!: number;
    title?: string | undefined;
    content?: string | undefined;
    seoUrl?: string | undefined;
    metaDescription?: string | undefined;
    metaTitle?: string | undefined;

    constructor(data?: IContentPageViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.seoUrl = _data["seoUrl"];
            this.metaDescription = _data["metaDescription"];
            this.metaTitle = _data["metaTitle"];
        }
    }

    static fromJS(data: any): ContentPageViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContentPageViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["content"] = this.content;
        data["seoUrl"] = this.seoUrl;
        data["metaDescription"] = this.metaDescription;
        data["metaTitle"] = this.metaTitle;
        return data; 
    }
}

export interface IContentPageViewModel {
    id: number;
    title?: string | undefined;
    content?: string | undefined;
    seoUrl?: string | undefined;
    metaDescription?: string | undefined;
    metaTitle?: string | undefined;
}

export class PagedResultsOfCouponListViewModel implements IPagedResultsOfCouponListViewModel {
    resultCount!: number;
    pageNumber!: number;
    totalPages!: number;
    pageSize!: number;
    results?: CouponListViewModel[] | undefined;

    constructor(data?: IPagedResultsOfCouponListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CouponListViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultsOfCouponListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultsOfCouponListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultsOfCouponListViewModel {
    resultCount: number;
    pageNumber: number;
    totalPages: number;
    pageSize: number;
    results?: CouponListViewModel[] | undefined;
}

export class CouponListViewModel implements ICouponListViewModel {
    id!: number;
    name?: string | undefined;
    code?: string | undefined;
    amount!: number;
    limitation!: number;
    status!: CouponStatus;
    type!: CouponType;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;

    constructor(data?: ICouponListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.amount = _data["amount"];
            this.limitation = _data["limitation"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CouponListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CouponListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["amount"] = this.amount;
        data["limitation"] = this.limitation;
        data["status"] = this.status;
        data["type"] = this.type;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ICouponListViewModel {
    id: number;
    name?: string | undefined;
    code?: string | undefined;
    amount: number;
    limitation: number;
    status: CouponStatus;
    type: CouponType;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
}

export enum CouponStatus {
    Active = 1,
    Inactive = 2,
}

export enum CouponType {
    Money = 1,
    Percent = 2,
}

export class CouponViewModel implements ICouponViewModel {
    name?: string | undefined;
    code?: string | undefined;
    amount!: number;
    limitation!: number;
    status!: CouponStatus;
    type!: CouponType;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;

    constructor(data?: ICouponViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.amount = _data["amount"];
            this.limitation = _data["limitation"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CouponViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CouponViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["amount"] = this.amount;
        data["limitation"] = this.limitation;
        data["status"] = this.status;
        data["type"] = this.type;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ICouponViewModel {
    name?: string | undefined;
    code?: string | undefined;
    amount: number;
    limitation: number;
    status: CouponStatus;
    type: CouponType;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
}

export class PagedResultsOfCustomerViewModel implements IPagedResultsOfCustomerViewModel {
    resultCount!: number;
    pageNumber!: number;
    totalPages!: number;
    pageSize!: number;
    results?: CustomerViewModel[] | undefined;

    constructor(data?: IPagedResultsOfCustomerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(CustomerViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultsOfCustomerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultsOfCustomerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultsOfCustomerViewModel {
    resultCount: number;
    pageNumber: number;
    totalPages: number;
    pageSize: number;
    results?: CustomerViewModel[] | undefined;
}

export class CustomerViewModel implements ICustomerViewModel {
    id?: string | undefined;
    displayName?: string | undefined;
    phone?: string | undefined;
    level!: CustomerLevel;
    email?: string | undefined;
    address?: string | undefined;
    assignedSales?: string | undefined;
    assignedSalesId?: string | undefined;
    customerCode?: string | undefined;

    constructor(data?: ICustomerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.phone = _data["phone"];
            this.level = _data["level"];
            this.email = _data["email"];
            this.address = _data["address"];
            this.assignedSales = _data["assignedSales"];
            this.assignedSalesId = _data["assignedSalesId"];
            this.customerCode = _data["customerCode"];
        }
    }

    static fromJS(data: any): CustomerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["phone"] = this.phone;
        data["level"] = this.level;
        data["email"] = this.email;
        data["address"] = this.address;
        data["assignedSales"] = this.assignedSales;
        data["assignedSalesId"] = this.assignedSalesId;
        data["customerCode"] = this.customerCode;
        return data; 
    }
}

export interface ICustomerViewModel {
    id?: string | undefined;
    displayName?: string | undefined;
    phone?: string | undefined;
    level: CustomerLevel;
    email?: string | undefined;
    address?: string | undefined;
    assignedSales?: string | undefined;
    assignedSalesId?: string | undefined;
    customerCode?: string | undefined;
}

export enum CustomerLevel {
    Ordinary = 1,
    Vip_1 = 2,
    Vip_2 = 3,
    SuperVip = 4,
}

export class UpdateCustomerLevelInput implements IUpdateCustomerLevelInput {
    id?: string | undefined;
    level!: CustomerLevel;

    constructor(data?: IUpdateCustomerLevelInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.level = _data["level"];
        }
    }

    static fromJS(data: any): UpdateCustomerLevelInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerLevelInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["level"] = this.level;
        return data; 
    }
}

export interface IUpdateCustomerLevelInput {
    id?: string | undefined;
    level: CustomerLevel;
}

export class CustomerProfileInput implements ICustomerProfileInput {
    userId?: string | undefined;
    username?: string | undefined;
    fullName?: string | undefined;
    address?: string | undefined;
    gender!: Gender;
    phone?: string | undefined;
    customerLevel!: CustomerLevel;
    email?: string | undefined;
    assignedSalesId?: string | undefined;

    constructor(data?: ICustomerProfileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.username = _data["username"];
            this.fullName = _data["fullName"];
            this.address = _data["address"];
            this.gender = _data["gender"];
            this.phone = _data["phone"];
            this.customerLevel = _data["customerLevel"];
            this.email = _data["email"];
            this.assignedSalesId = _data["assignedSalesId"];
        }
    }

    static fromJS(data: any): CustomerProfileInput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerProfileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["username"] = this.username;
        data["fullName"] = this.fullName;
        data["address"] = this.address;
        data["gender"] = this.gender;
        data["phone"] = this.phone;
        data["customerLevel"] = this.customerLevel;
        data["email"] = this.email;
        data["assignedSalesId"] = this.assignedSalesId;
        return data; 
    }
}

export interface ICustomerProfileInput {
    userId?: string | undefined;
    username?: string | undefined;
    fullName?: string | undefined;
    address?: string | undefined;
    gender: Gender;
    phone?: string | undefined;
    customerLevel: CustomerLevel;
    email?: string | undefined;
    assignedSalesId?: string | undefined;
}

export enum Gender {
    Male = 1,
    Female = 2,
}

export class CheckUserExistInput implements ICheckUserExistInput {
    phoneNumber?: string | undefined;
    userName?: string | undefined;

    constructor(data?: ICheckUserExistInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): CheckUserExistInput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckUserExistInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface ICheckUserExistInput {
    phoneNumber?: string | undefined;
    userName?: string | undefined;
}

export class RegisterInput implements IRegisterInput {
    displayName?: string | undefined;
    userName!: string;
    password!: string;
    email?: string | undefined;
    phoneNumber!: string;
    address?: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["address"] = this.address;
        return data; 
    }
}

export interface IRegisterInput {
    displayName?: string | undefined;
    userName: string;
    password: string;
    email?: string | undefined;
    phoneNumber: string;
    address?: string | undefined;
}

export class DecalPriceViewModel implements IDecalPriceViewModel {
    id!: number;
    description?: string | undefined;
    quantity!: number;
    printPrice!: number;
    cutPrice!: number;
    machiningPrice!: number;

    constructor(data?: IDecalPriceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.printPrice = _data["printPrice"];
            this.cutPrice = _data["cutPrice"];
            this.machiningPrice = _data["machiningPrice"];
        }
    }

    static fromJS(data: any): DecalPriceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DecalPriceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["printPrice"] = this.printPrice;
        data["cutPrice"] = this.cutPrice;
        data["machiningPrice"] = this.machiningPrice;
        return data; 
    }
}

export interface IDecalPriceViewModel {
    id: number;
    description?: string | undefined;
    quantity: number;
    printPrice: number;
    cutPrice: number;
    machiningPrice: number;
}

export class PagedResultsOfDecalPriceListViewModel implements IPagedResultsOfDecalPriceListViewModel {
    resultCount!: number;
    pageNumber!: number;
    totalPages!: number;
    pageSize!: number;
    results?: DecalPriceListViewModel[] | undefined;

    constructor(data?: IPagedResultsOfDecalPriceListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(DecalPriceListViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultsOfDecalPriceListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultsOfDecalPriceListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultsOfDecalPriceListViewModel {
    resultCount: number;
    pageNumber: number;
    totalPages: number;
    pageSize: number;
    results?: DecalPriceListViewModel[] | undefined;
}

export class DecalPriceListViewModel implements IDecalPriceListViewModel {
    id!: number;
    description?: string | undefined;
    quantity!: number;
    printPrice!: number;
    cutPrice!: number;
    machiningPrice!: number;

    constructor(data?: IDecalPriceListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.printPrice = _data["printPrice"];
            this.cutPrice = _data["cutPrice"];
            this.machiningPrice = _data["machiningPrice"];
        }
    }

    static fromJS(data: any): DecalPriceListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DecalPriceListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["printPrice"] = this.printPrice;
        data["cutPrice"] = this.cutPrice;
        data["machiningPrice"] = this.machiningPrice;
        return data; 
    }
}

export interface IDecalPriceListViewModel {
    id: number;
    description?: string | undefined;
    quantity: number;
    printPrice: number;
    cutPrice: number;
    machiningPrice: number;
}

export class PagedResultsOfEmployeeListViewModel implements IPagedResultsOfEmployeeListViewModel {
    resultCount!: number;
    pageNumber!: number;
    totalPages!: number;
    pageSize!: number;
    results?: EmployeeListViewModel[] | undefined;

    constructor(data?: IPagedResultsOfEmployeeListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(EmployeeListViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultsOfEmployeeListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultsOfEmployeeListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultsOfEmployeeListViewModel {
    resultCount: number;
    pageNumber: number;
    totalPages: number;
    pageSize: number;
    results?: EmployeeListViewModel[] | undefined;
}

export class EmployeeListViewModel implements IEmployeeListViewModel {
    id?: string | undefined;
    fullName?: string | undefined;
    userName?: string | undefined;
    phoneNumber?: string | undefined;
    permissions?: string[] | undefined;

    constructor(data?: IEmployeeListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): EmployeeListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data; 
    }
}

export interface IEmployeeListViewModel {
    id?: string | undefined;
    fullName?: string | undefined;
    userName?: string | undefined;
    phoneNumber?: string | undefined;
    permissions?: string[] | undefined;
}

export class SelectModelOfString implements ISelectModelOfString {
    id?: string | undefined;
    name?: string | undefined;
    defaultValue!: boolean;

    constructor(data?: ISelectModelOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.defaultValue = _data["defaultValue"];
        }
    }

    static fromJS(data: any): SelectModelOfString {
        data = typeof data === 'object' ? data : {};
        let result = new SelectModelOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["defaultValue"] = this.defaultValue;
        return data; 
    }
}

export interface ISelectModelOfString {
    id?: string | undefined;
    name?: string | undefined;
    defaultValue: boolean;
}

export class CreateEmployeeInput implements ICreateEmployeeInput {
    fullName!: string;
    userName!: string;
    password!: string;
    phoneNumber?: string | undefined;
    permissions?: string[] | undefined;

    constructor(data?: ICreateEmployeeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateEmployeeInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmployeeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data; 
    }
}

export interface ICreateEmployeeInput {
    fullName: string;
    userName: string;
    password: string;
    phoneNumber?: string | undefined;
    permissions?: string[] | undefined;
}

export class EmployeeViewModel implements IEmployeeViewModel {
    id?: string | undefined;
    fullName?: string | undefined;
    userName?: string | undefined;
    phoneNumber?: string | undefined;
    permissions?: string[] | undefined;

    constructor(data?: IEmployeeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): EmployeeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data; 
    }
}

export interface IEmployeeViewModel {
    id?: string | undefined;
    fullName?: string | undefined;
    userName?: string | undefined;
    phoneNumber?: string | undefined;
    permissions?: string[] | undefined;
}

export class IdentityResult implements IIdentityResult {
    succeeded!: boolean;
    errors?: IdentityError[] | undefined;

    constructor(data?: IIdentityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(IdentityError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IdentityResult {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IIdentityResult {
    succeeded: boolean;
    errors?: IdentityError[] | undefined;
}

export class IdentityError implements IIdentityError {
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IIdentityError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): IdentityError {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data; 
    }
}

export interface IIdentityError {
    code?: string | undefined;
    description?: string | undefined;
}

export class EditEmployeeInput implements IEditEmployeeInput {
    userName!: string;
    fullName!: string;
    password?: string | undefined;
    phoneNumber?: string | undefined;
    permissions?: string[] | undefined;

    constructor(data?: IEditEmployeeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.fullName = _data["fullName"];
            this.password = _data["password"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): EditEmployeeInput {
        data = typeof data === 'object' ? data : {};
        let result = new EditEmployeeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["fullName"] = this.fullName;
        data["password"] = this.password;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data; 
    }
}

export interface IEditEmployeeInput {
    userName: string;
    fullName: string;
    password?: string | undefined;
    phoneNumber?: string | undefined;
    permissions?: string[] | undefined;
}

export class PagedResultsOfExpensesListViewModel implements IPagedResultsOfExpensesListViewModel {
    resultCount!: number;
    pageNumber!: number;
    totalPages!: number;
    pageSize!: number;
    results?: ExpensesListViewModel[] | undefined;

    constructor(data?: IPagedResultsOfExpensesListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ExpensesListViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultsOfExpensesListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultsOfExpensesListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultsOfExpensesListViewModel {
    resultCount: number;
    pageNumber: number;
    totalPages: number;
    pageSize: number;
    results?: ExpensesListViewModel[] | undefined;
}

export class ExpensesListViewModel implements IExpensesListViewModel {
    id!: number;
    code?: string | undefined;
    status!: OrderStatus;
    paymentStatus!: ExpensesPaymentStatus;
    totalCustomerPay!: number;
    dateCreated!: number;
    importDate!: number;
    vendorName?: string | undefined;
    employeeName?: string | undefined;
    supplies?: string[] | undefined;
    depositAmount!: number;
    remainTotalCustomerPay!: number;
    paymentMethod!: OrderPaymentMethod;
    bankingNote?: string | undefined;
    vatAmount!: number;
    shippingFee!: number;
    discountAmount!: number;
    expensesDetails?: ExpensesDetailViewModel[] | undefined;

    constructor(data?: IExpensesListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.status = _data["status"];
            this.paymentStatus = _data["paymentStatus"];
            this.totalCustomerPay = _data["totalCustomerPay"];
            this.dateCreated = _data["dateCreated"];
            this.importDate = _data["importDate"];
            this.vendorName = _data["vendorName"];
            this.employeeName = _data["employeeName"];
            if (Array.isArray(_data["supplies"])) {
                this.supplies = [] as any;
                for (let item of _data["supplies"])
                    this.supplies!.push(item);
            }
            this.depositAmount = _data["depositAmount"];
            this.remainTotalCustomerPay = _data["remainTotalCustomerPay"];
            this.paymentMethod = _data["paymentMethod"];
            this.bankingNote = _data["bankingNote"];
            this.vatAmount = _data["vatAmount"];
            this.shippingFee = _data["shippingFee"];
            this.discountAmount = _data["discountAmount"];
            if (Array.isArray(_data["expensesDetails"])) {
                this.expensesDetails = [] as any;
                for (let item of _data["expensesDetails"])
                    this.expensesDetails!.push(ExpensesDetailViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExpensesListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExpensesListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["status"] = this.status;
        data["paymentStatus"] = this.paymentStatus;
        data["totalCustomerPay"] = this.totalCustomerPay;
        data["dateCreated"] = this.dateCreated;
        data["importDate"] = this.importDate;
        data["vendorName"] = this.vendorName;
        data["employeeName"] = this.employeeName;
        if (Array.isArray(this.supplies)) {
            data["supplies"] = [];
            for (let item of this.supplies)
                data["supplies"].push(item);
        }
        data["depositAmount"] = this.depositAmount;
        data["remainTotalCustomerPay"] = this.remainTotalCustomerPay;
        data["paymentMethod"] = this.paymentMethod;
        data["bankingNote"] = this.bankingNote;
        data["vatAmount"] = this.vatAmount;
        data["shippingFee"] = this.shippingFee;
        data["discountAmount"] = this.discountAmount;
        if (Array.isArray(this.expensesDetails)) {
            data["expensesDetails"] = [];
            for (let item of this.expensesDetails)
                data["expensesDetails"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IExpensesListViewModel {
    id: number;
    code?: string | undefined;
    status: OrderStatus;
    paymentStatus: ExpensesPaymentStatus;
    totalCustomerPay: number;
    dateCreated: number;
    importDate: number;
    vendorName?: string | undefined;
    employeeName?: string | undefined;
    supplies?: string[] | undefined;
    depositAmount: number;
    remainTotalCustomerPay: number;
    paymentMethod: OrderPaymentMethod;
    bankingNote?: string | undefined;
    vatAmount: number;
    shippingFee: number;
    discountAmount: number;
    expensesDetails?: ExpensesDetailViewModel[] | undefined;
}

export enum OrderStatus {
    Ordered = 1,
    OrderReady = 4,
    Delivered = 5,
    Canceled = 6,
    ExpressDelivery = 12,
    InStock = 14,
    Billing = 15,
    Done = 90,
    NotDone = 91,
}

export enum ExpensesPaymentStatus {
    NotPaid = 1,
    PaidDeposit = 2,
    Debt = 3,
    Paid = 4,
}

export enum OrderPaymentMethod {
    Cash = 0,
    BankTransfer = 1,
    Momo = 2,
}

export class ExpensesDetailViewModel implements IExpensesDetailViewModel {
    id!: string;
    suppliesId!: number;
    categoryId!: number;
    suppliesName?: string | undefined;
    width!: number;
    height!: number;
    quantity!: number;
    total!: number;
    note?: string | undefined;
    sample?: string | undefined;
    area!: number;
    couponCode?: string | undefined;
    couponAmount!: number;
    pricePerUnit!: number;
    employee?: string | undefined;
    vat!: number;
    status!: OrderDetailStatus;
    totalArea!: number;
    imagePaths?: string[] | undefined;

    constructor(data?: IExpensesDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.suppliesId = _data["suppliesId"];
            this.categoryId = _data["categoryId"];
            this.suppliesName = _data["suppliesName"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.quantity = _data["quantity"];
            this.total = _data["total"];
            this.note = _data["note"];
            this.sample = _data["sample"];
            this.area = _data["area"];
            this.couponCode = _data["couponCode"];
            this.couponAmount = _data["couponAmount"];
            this.pricePerUnit = _data["pricePerUnit"];
            this.employee = _data["employee"];
            this.vat = _data["vat"];
            this.status = _data["status"];
            this.totalArea = _data["totalArea"];
            if (Array.isArray(_data["imagePaths"])) {
                this.imagePaths = [] as any;
                for (let item of _data["imagePaths"])
                    this.imagePaths!.push(item);
            }
        }
    }

    static fromJS(data: any): ExpensesDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExpensesDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["suppliesId"] = this.suppliesId;
        data["categoryId"] = this.categoryId;
        data["suppliesName"] = this.suppliesName;
        data["width"] = this.width;
        data["height"] = this.height;
        data["quantity"] = this.quantity;
        data["total"] = this.total;
        data["note"] = this.note;
        data["sample"] = this.sample;
        data["area"] = this.area;
        data["couponCode"] = this.couponCode;
        data["couponAmount"] = this.couponAmount;
        data["pricePerUnit"] = this.pricePerUnit;
        data["employee"] = this.employee;
        data["vat"] = this.vat;
        data["status"] = this.status;
        data["totalArea"] = this.totalArea;
        if (Array.isArray(this.imagePaths)) {
            data["imagePaths"] = [];
            for (let item of this.imagePaths)
                data["imagePaths"].push(item);
        }
        return data; 
    }
}

export interface IExpensesDetailViewModel {
    id: string;
    suppliesId: number;
    categoryId: number;
    suppliesName?: string | undefined;
    width: number;
    height: number;
    quantity: number;
    total: number;
    note?: string | undefined;
    sample?: string | undefined;
    area: number;
    couponCode?: string | undefined;
    couponAmount: number;
    pricePerUnit: number;
    employee?: string | undefined;
    vat: number;
    status: OrderDetailStatus;
    totalArea: number;
    imagePaths?: string[] | undefined;
}

export enum OrderDetailStatus {
    Ordered = 2,
    Delivered = 3,
    Processing = 4,
    Printed = 5,
    OrderReady = 6,
    Designing = 10,
    ReDesign = 11,
    WaitingForApprove = 12,
    Approved = 13,
}

export class ExpensesViewModel implements IExpensesViewModel {
    id!: number;
    code?: string | undefined;
    status!: OrderStatus;
    paymentStatus?: OrderPaymentStatus | undefined;
    orderDate!: number;
    employeeId?: string | undefined;
    employeeName?: string | undefined;
    vendorEmail?: string | undefined;
    vendorId!: string;
    vendorName?: string | undefined;
    vendorPhone?: string | undefined;
    vendorAddress?: string | undefined;
    total!: number;
    vatAmount!: number;
    couponAmount!: number;
    totalCustomerPay!: number;
    depositAmount!: number;
    remainTotalCustomerPay!: number;
    shippingFee!: number;
    importDate!: number;
    expensesDetails?: ExpensesDetailViewModel[] | undefined;

    constructor(data?: IExpensesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.status = _data["status"];
            this.paymentStatus = _data["paymentStatus"];
            this.orderDate = _data["orderDate"];
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.vendorEmail = _data["vendorEmail"];
            this.vendorId = _data["vendorId"];
            this.vendorName = _data["vendorName"];
            this.vendorPhone = _data["vendorPhone"];
            this.vendorAddress = _data["vendorAddress"];
            this.total = _data["total"];
            this.vatAmount = _data["vatAmount"];
            this.couponAmount = _data["couponAmount"];
            this.totalCustomerPay = _data["totalCustomerPay"];
            this.depositAmount = _data["depositAmount"];
            this.remainTotalCustomerPay = _data["remainTotalCustomerPay"];
            this.shippingFee = _data["shippingFee"];
            this.importDate = _data["importDate"];
            if (Array.isArray(_data["expensesDetails"])) {
                this.expensesDetails = [] as any;
                for (let item of _data["expensesDetails"])
                    this.expensesDetails!.push(ExpensesDetailViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExpensesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExpensesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["status"] = this.status;
        data["paymentStatus"] = this.paymentStatus;
        data["orderDate"] = this.orderDate;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["vendorEmail"] = this.vendorEmail;
        data["vendorId"] = this.vendorId;
        data["vendorName"] = this.vendorName;
        data["vendorPhone"] = this.vendorPhone;
        data["vendorAddress"] = this.vendorAddress;
        data["total"] = this.total;
        data["vatAmount"] = this.vatAmount;
        data["couponAmount"] = this.couponAmount;
        data["totalCustomerPay"] = this.totalCustomerPay;
        data["depositAmount"] = this.depositAmount;
        data["remainTotalCustomerPay"] = this.remainTotalCustomerPay;
        data["shippingFee"] = this.shippingFee;
        data["importDate"] = this.importDate;
        if (Array.isArray(this.expensesDetails)) {
            data["expensesDetails"] = [];
            for (let item of this.expensesDetails)
                data["expensesDetails"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IExpensesViewModel {
    id: number;
    code?: string | undefined;
    status: OrderStatus;
    paymentStatus?: OrderPaymentStatus | undefined;
    orderDate: number;
    employeeId?: string | undefined;
    employeeName?: string | undefined;
    vendorEmail?: string | undefined;
    vendorId: string;
    vendorName?: string | undefined;
    vendorPhone?: string | undefined;
    vendorAddress?: string | undefined;
    total: number;
    vatAmount: number;
    couponAmount: number;
    totalCustomerPay: number;
    depositAmount: number;
    remainTotalCustomerPay: number;
    shippingFee: number;
    importDate: number;
    expensesDetails?: ExpensesDetailViewModel[] | undefined;
}

export enum OrderPaymentStatus {
    NotPaid = 1,
    PaidDeposit = 2,
    Debt = 3,
    Paid = 4,
    NonPerformingLoan = 5,
    Billing = 6,
}

export class UpdateOrderStatusInput implements IUpdateOrderStatusInput {
    ids?: number[] | undefined;
    status!: OrderStatus;

    constructor(data?: IUpdateOrderStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateOrderStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["status"] = this.status;
        return data; 
    }
}

export interface IUpdateOrderStatusInput {
    ids?: number[] | undefined;
    status: OrderStatus;
}

export class UpdateExpensesPaymentStatusInput implements IUpdateExpensesPaymentStatusInput {
    ids!: number[];
    paymentStatus!: ExpensesPaymentStatus;
    depositAmount!: number;

    constructor(data?: IUpdateExpensesPaymentStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.paymentStatus = _data["paymentStatus"];
            this.depositAmount = _data["depositAmount"];
        }
    }

    static fromJS(data: any): UpdateExpensesPaymentStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExpensesPaymentStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["paymentStatus"] = this.paymentStatus;
        data["depositAmount"] = this.depositAmount;
        return data; 
    }
}

export interface IUpdateExpensesPaymentStatusInput {
    ids: number[];
    paymentStatus: ExpensesPaymentStatus;
    depositAmount: number;
}

export class CreateExpensesDetailInput implements ICreateExpensesDetailInput {
    id?: string | undefined;
    suppliesId!: number;
    categoryId!: number;
    processingSettings?: ProcessingSettingModel[] | undefined;
    width!: number;
    height!: number;
    quantity!: number;
    area!: number;
    pricePerUnit!: number;
    totalPrice!: number;
    imageFiles?: any[] | undefined;
    isUpdateImages!: boolean;
    note?: string | undefined;
    sample?: string | undefined;
    couponCode?: string | undefined;
    depositAmount!: number;
    includeVAT!: boolean;
    vatAmount!: number;
    status!: OrderDetailStatus;
    indexImgId!: number;

    constructor(data?: ICreateExpensesDetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.suppliesId = _data["suppliesId"];
            this.categoryId = _data["categoryId"];
            if (Array.isArray(_data["processingSettings"])) {
                this.processingSettings = [] as any;
                for (let item of _data["processingSettings"])
                    this.processingSettings!.push(ProcessingSettingModel.fromJS(item));
            }
            this.width = _data["width"];
            this.height = _data["height"];
            this.quantity = _data["quantity"];
            this.area = _data["area"];
            this.pricePerUnit = _data["pricePerUnit"];
            this.totalPrice = _data["totalPrice"];
            if (Array.isArray(_data["imageFiles"])) {
                this.imageFiles = [] as any;
                for (let item of _data["imageFiles"])
                    this.imageFiles!.push(item);
            }
            this.isUpdateImages = _data["isUpdateImages"];
            this.note = _data["note"];
            this.sample = _data["sample"];
            this.couponCode = _data["couponCode"];
            this.depositAmount = _data["depositAmount"];
            this.includeVAT = _data["includeVAT"];
            this.vatAmount = _data["vatAmount"];
            this.status = _data["status"];
            this.indexImgId = _data["indexImgId"];
        }
    }

    static fromJS(data: any): CreateExpensesDetailInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExpensesDetailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["suppliesId"] = this.suppliesId;
        data["categoryId"] = this.categoryId;
        if (Array.isArray(this.processingSettings)) {
            data["processingSettings"] = [];
            for (let item of this.processingSettings)
                data["processingSettings"].push(item.toJSON());
        }
        data["width"] = this.width;
        data["height"] = this.height;
        data["quantity"] = this.quantity;
        data["area"] = this.area;
        data["pricePerUnit"] = this.pricePerUnit;
        data["totalPrice"] = this.totalPrice;
        if (Array.isArray(this.imageFiles)) {
            data["imageFiles"] = [];
            for (let item of this.imageFiles)
                data["imageFiles"].push(item);
        }
        data["isUpdateImages"] = this.isUpdateImages;
        data["note"] = this.note;
        data["sample"] = this.sample;
        data["couponCode"] = this.couponCode;
        data["depositAmount"] = this.depositAmount;
        data["includeVAT"] = this.includeVAT;
        data["vatAmount"] = this.vatAmount;
        data["status"] = this.status;
        data["indexImgId"] = this.indexImgId;
        return data; 
    }
}

export interface ICreateExpensesDetailInput {
    id?: string | undefined;
    suppliesId: number;
    categoryId: number;
    processingSettings?: ProcessingSettingModel[] | undefined;
    width: number;
    height: number;
    quantity: number;
    area: number;
    pricePerUnit: number;
    totalPrice: number;
    imageFiles?: any[] | undefined;
    isUpdateImages: boolean;
    note?: string | undefined;
    sample?: string | undefined;
    couponCode?: string | undefined;
    depositAmount: number;
    includeVAT: boolean;
    vatAmount: number;
    status: OrderDetailStatus;
    indexImgId: number;
}

export class ProcessingSettingModel implements IProcessingSettingModel {
    id!: string;
    name?: string | undefined;
    productId!: number;
    processingSettingModelItems?: ProcessingSettingModelItem[] | undefined;

    constructor(data?: IProcessingSettingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.productId = _data["productId"];
            if (Array.isArray(_data["processingSettingModelItems"])) {
                this.processingSettingModelItems = [] as any;
                for (let item of _data["processingSettingModelItems"])
                    this.processingSettingModelItems!.push(ProcessingSettingModelItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcessingSettingModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessingSettingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["productId"] = this.productId;
        if (Array.isArray(this.processingSettingModelItems)) {
            data["processingSettingModelItems"] = [];
            for (let item of this.processingSettingModelItems)
                data["processingSettingModelItems"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProcessingSettingModel {
    id: string;
    name?: string | undefined;
    productId: number;
    processingSettingModelItems?: ProcessingSettingModelItem[] | undefined;
}

export class ProcessingSettingModelItem implements IProcessingSettingModelItem {
    id!: string;
    name?: string | undefined;

    constructor(data?: IProcessingSettingModelItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProcessingSettingModelItem {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessingSettingModelItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IProcessingSettingModelItem {
    id: string;
    name?: string | undefined;
}

export class DownloadOrderReportInput implements IDownloadOrderReportInput {
    dateTo?: number | undefined;
    dateFrom?: number | undefined;
    filterStatus?: OrderStatus[] | undefined;
    filterPaymentStatus?: OrderPaymentStatus[] | undefined;
    employeeId?: string | undefined;
    orderIds?: number[] | undefined;

    constructor(data?: IDownloadOrderReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTo = _data["dateTo"];
            this.dateFrom = _data["dateFrom"];
            if (Array.isArray(_data["filterStatus"])) {
                this.filterStatus = [] as any;
                for (let item of _data["filterStatus"])
                    this.filterStatus!.push(item);
            }
            if (Array.isArray(_data["filterPaymentStatus"])) {
                this.filterPaymentStatus = [] as any;
                for (let item of _data["filterPaymentStatus"])
                    this.filterPaymentStatus!.push(item);
            }
            this.employeeId = _data["employeeId"];
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [] as any;
                for (let item of _data["orderIds"])
                    this.orderIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DownloadOrderReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadOrderReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTo"] = this.dateTo;
        data["dateFrom"] = this.dateFrom;
        if (Array.isArray(this.filterStatus)) {
            data["filterStatus"] = [];
            for (let item of this.filterStatus)
                data["filterStatus"].push(item);
        }
        if (Array.isArray(this.filterPaymentStatus)) {
            data["filterPaymentStatus"] = [];
            for (let item of this.filterPaymentStatus)
                data["filterPaymentStatus"].push(item);
        }
        data["employeeId"] = this.employeeId;
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            for (let item of this.orderIds)
                data["orderIds"].push(item);
        }
        return data; 
    }
}

export interface IDownloadOrderReportInput {
    dateTo?: number | undefined;
    dateFrom?: number | undefined;
    filterStatus?: OrderStatus[] | undefined;
    filterPaymentStatus?: OrderPaymentStatus[] | undefined;
    employeeId?: string | undefined;
    orderIds?: number[] | undefined;
}

export class UpdateOrderPaymentMethodInput implements IUpdateOrderPaymentMethodInput {
    orderIds?: number[] | undefined;
    paymentMethod!: OrderPaymentMethod;

    constructor(data?: IUpdateOrderPaymentMethodInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [] as any;
                for (let item of _data["orderIds"])
                    this.orderIds!.push(item);
            }
            this.paymentMethod = _data["paymentMethod"];
        }
    }

    static fromJS(data: any): UpdateOrderPaymentMethodInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderPaymentMethodInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            for (let item of this.orderIds)
                data["orderIds"].push(item);
        }
        data["paymentMethod"] = this.paymentMethod;
        return data; 
    }
}

export interface IUpdateOrderPaymentMethodInput {
    orderIds?: number[] | undefined;
    paymentMethod: OrderPaymentMethod;
}

export class UpdateCODNoteInput implements IUpdateCODNoteInput {
    codAmount!: number;
    note?: string | undefined;

    constructor(data?: IUpdateCODNoteInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codAmount = _data["codAmount"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateCODNoteInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCODNoteInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codAmount"] = this.codAmount;
        data["note"] = this.note;
        return data; 
    }
}

export interface IUpdateCODNoteInput {
    codAmount: number;
    note?: string | undefined;
}

export class OrderStatistics implements IOrderStatistics {
    orderStatus?: { [key: string]: number; } | undefined;
    orderPaymentStatus?: { [key: string]: number; } | undefined;

    constructor(data?: IOrderStatistics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["orderStatus"]) {
                this.orderStatus = {} as any;
                for (let key in _data["orderStatus"]) {
                    if (_data["orderStatus"].hasOwnProperty(key))
                        this.orderStatus![key] = _data["orderStatus"][key];
                }
            }
            if (_data["orderPaymentStatus"]) {
                this.orderPaymentStatus = {} as any;
                for (let key in _data["orderPaymentStatus"]) {
                    if (_data["orderPaymentStatus"].hasOwnProperty(key))
                        this.orderPaymentStatus![key] = _data["orderPaymentStatus"][key];
                }
            }
        }
    }

    static fromJS(data: any): OrderStatistics {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStatistics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.orderStatus) {
            data["orderStatus"] = {};
            for (let key in this.orderStatus) {
                if (this.orderStatus.hasOwnProperty(key))
                    data["orderStatus"][key] = this.orderStatus[key];
            }
        }
        if (this.orderPaymentStatus) {
            data["orderPaymentStatus"] = {};
            for (let key in this.orderPaymentStatus) {
                if (this.orderPaymentStatus.hasOwnProperty(key))
                    data["orderPaymentStatus"][key] = this.orderPaymentStatus[key];
            }
        }
        return data; 
    }
}

export interface IOrderStatistics {
    orderStatus?: { [key: string]: number; } | undefined;
    orderPaymentStatus?: { [key: string]: number; } | undefined;
}

export class CatalogueOrderMaterial implements ICatalogueOrderMaterial {
    catalogueProductItemId!: string;
    catalogueProductItemName?: string | undefined;
    processingTypes?: ProcessingType[] | undefined;
    processingTypes2?: ProcessingType[] | undefined;
    polymeCoverTypes?: PolymeCoverType[] | undefined;
    prices?: Price[] | undefined;
    pageOptions?: number[] | undefined;
    bookOptions?: number[] | undefined;
    sizeOptions?: CatalogueSizeOption[] | undefined;

    constructor(data?: ICatalogueOrderMaterial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.catalogueProductItemId = _data["catalogueProductItemId"];
            this.catalogueProductItemName = _data["catalogueProductItemName"];
            if (Array.isArray(_data["processingTypes"])) {
                this.processingTypes = [] as any;
                for (let item of _data["processingTypes"])
                    this.processingTypes!.push(ProcessingType.fromJS(item));
            }
            if (Array.isArray(_data["processingTypes2"])) {
                this.processingTypes2 = [] as any;
                for (let item of _data["processingTypes2"])
                    this.processingTypes2!.push(ProcessingType.fromJS(item));
            }
            if (Array.isArray(_data["polymeCoverTypes"])) {
                this.polymeCoverTypes = [] as any;
                for (let item of _data["polymeCoverTypes"])
                    this.polymeCoverTypes!.push(PolymeCoverType.fromJS(item));
            }
            if (Array.isArray(_data["prices"])) {
                this.prices = [] as any;
                for (let item of _data["prices"])
                    this.prices!.push(Price.fromJS(item));
            }
            if (Array.isArray(_data["pageOptions"])) {
                this.pageOptions = [] as any;
                for (let item of _data["pageOptions"])
                    this.pageOptions!.push(item);
            }
            if (Array.isArray(_data["bookOptions"])) {
                this.bookOptions = [] as any;
                for (let item of _data["bookOptions"])
                    this.bookOptions!.push(item);
            }
            if (Array.isArray(_data["sizeOptions"])) {
                this.sizeOptions = [] as any;
                for (let item of _data["sizeOptions"])
                    this.sizeOptions!.push(CatalogueSizeOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CatalogueOrderMaterial {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogueOrderMaterial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["catalogueProductItemId"] = this.catalogueProductItemId;
        data["catalogueProductItemName"] = this.catalogueProductItemName;
        if (Array.isArray(this.processingTypes)) {
            data["processingTypes"] = [];
            for (let item of this.processingTypes)
                data["processingTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.processingTypes2)) {
            data["processingTypes2"] = [];
            for (let item of this.processingTypes2)
                data["processingTypes2"].push(item.toJSON());
        }
        if (Array.isArray(this.polymeCoverTypes)) {
            data["polymeCoverTypes"] = [];
            for (let item of this.polymeCoverTypes)
                data["polymeCoverTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.prices)) {
            data["prices"] = [];
            for (let item of this.prices)
                data["prices"].push(item.toJSON());
        }
        if (Array.isArray(this.pageOptions)) {
            data["pageOptions"] = [];
            for (let item of this.pageOptions)
                data["pageOptions"].push(item);
        }
        if (Array.isArray(this.bookOptions)) {
            data["bookOptions"] = [];
            for (let item of this.bookOptions)
                data["bookOptions"].push(item);
        }
        if (Array.isArray(this.sizeOptions)) {
            data["sizeOptions"] = [];
            for (let item of this.sizeOptions)
                data["sizeOptions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICatalogueOrderMaterial {
    catalogueProductItemId: string;
    catalogueProductItemName?: string | undefined;
    processingTypes?: ProcessingType[] | undefined;
    processingTypes2?: ProcessingType[] | undefined;
    polymeCoverTypes?: PolymeCoverType[] | undefined;
    prices?: Price[] | undefined;
    pageOptions?: number[] | undefined;
    bookOptions?: number[] | undefined;
    sizeOptions?: CatalogueSizeOption[] | undefined;
}

export class BaseEntity implements IBaseEntity {
    dateCreated!: Date;
    isDeleted!: boolean;
    dateDeleted?: Date | undefined;
    dateUpdated?: Date | undefined;

    constructor(data?: IBaseEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.dateDeleted = _data["dateDeleted"] ? new Date(_data["dateDeleted"].toString()) : <any>undefined;
            this.dateUpdated = _data["dateUpdated"] ? new Date(_data["dateUpdated"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseEntity {
        data = typeof data === 'object' ? data : {};
        let result = new BaseEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["dateDeleted"] = this.dateDeleted ? this.dateDeleted.toISOString() : <any>undefined;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IBaseEntity {
    dateCreated: Date;
    isDeleted: boolean;
    dateDeleted?: Date | undefined;
    dateUpdated?: Date | undefined;
}

export class ProcessingType extends BaseEntity implements IProcessingType {
    id!: string;
    name?: string | undefined;
    productCategoryId!: number;
    productId?: number | undefined;
    step!: number;
    showOnClientSite!: boolean;
    isNotProcessedValue!: boolean;
    isNewApproach!: boolean;
    productCategory?: ProductCategory | undefined;
    product?: Product | undefined;
    processingTypeItems?: ProcessingTypeItem[] | undefined;

    constructor(data?: IProcessingType) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.productCategoryId = _data["productCategoryId"];
            this.productId = _data["productId"];
            this.step = _data["step"];
            this.showOnClientSite = _data["showOnClientSite"];
            this.isNotProcessedValue = _data["isNotProcessedValue"];
            this.isNewApproach = _data["isNewApproach"];
            this.productCategory = _data["productCategory"] ? ProductCategory.fromJS(_data["productCategory"]) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            if (Array.isArray(_data["processingTypeItems"])) {
                this.processingTypeItems = [] as any;
                for (let item of _data["processingTypeItems"])
                    this.processingTypeItems!.push(ProcessingTypeItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcessingType {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessingType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["productCategoryId"] = this.productCategoryId;
        data["productId"] = this.productId;
        data["step"] = this.step;
        data["showOnClientSite"] = this.showOnClientSite;
        data["isNotProcessedValue"] = this.isNotProcessedValue;
        data["isNewApproach"] = this.isNewApproach;
        data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        if (Array.isArray(this.processingTypeItems)) {
            data["processingTypeItems"] = [];
            for (let item of this.processingTypeItems)
                data["processingTypeItems"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IProcessingType extends IBaseEntity {
    id: string;
    name?: string | undefined;
    productCategoryId: number;
    productId?: number | undefined;
    step: number;
    showOnClientSite: boolean;
    isNotProcessedValue: boolean;
    isNewApproach: boolean;
    productCategory?: ProductCategory | undefined;
    product?: Product | undefined;
    processingTypeItems?: ProcessingTypeItem[] | undefined;
}

export class ProductCategory extends BaseEntity implements IProductCategory {
    id!: number;
    name!: string;
    status!: ProductCategoryStatus;
    image!: string;
    seoUrl!: string;
    metaDescription?: string | undefined;
    showOnMenu!: boolean;
    metaTitle?: string | undefined;
    isSampleCategory!: boolean;
    category!: Category;
    orderNumber!: number;
    products?: Product[] | undefined;
    processingTypes?: ProcessingType[] | undefined;
    polymeCoverTypes?: PolymeCoverType[] | undefined;

    constructor(data?: IProductCategory) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.image = _data["image"];
            this.seoUrl = _data["seoUrl"];
            this.metaDescription = _data["metaDescription"];
            this.showOnMenu = _data["showOnMenu"];
            this.metaTitle = _data["metaTitle"];
            this.isSampleCategory = _data["isSampleCategory"];
            this.category = _data["category"];
            this.orderNumber = _data["orderNumber"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(Product.fromJS(item));
            }
            if (Array.isArray(_data["processingTypes"])) {
                this.processingTypes = [] as any;
                for (let item of _data["processingTypes"])
                    this.processingTypes!.push(ProcessingType.fromJS(item));
            }
            if (Array.isArray(_data["polymeCoverTypes"])) {
                this.polymeCoverTypes = [] as any;
                for (let item of _data["polymeCoverTypes"])
                    this.polymeCoverTypes!.push(PolymeCoverType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["image"] = this.image;
        data["seoUrl"] = this.seoUrl;
        data["metaDescription"] = this.metaDescription;
        data["showOnMenu"] = this.showOnMenu;
        data["metaTitle"] = this.metaTitle;
        data["isSampleCategory"] = this.isSampleCategory;
        data["category"] = this.category;
        data["orderNumber"] = this.orderNumber;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        if (Array.isArray(this.processingTypes)) {
            data["processingTypes"] = [];
            for (let item of this.processingTypes)
                data["processingTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.polymeCoverTypes)) {
            data["polymeCoverTypes"] = [];
            for (let item of this.polymeCoverTypes)
                data["polymeCoverTypes"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IProductCategory extends IBaseEntity {
    id: number;
    name: string;
    status: ProductCategoryStatus;
    image: string;
    seoUrl: string;
    metaDescription?: string | undefined;
    showOnMenu: boolean;
    metaTitle?: string | undefined;
    isSampleCategory: boolean;
    category: Category;
    orderNumber: number;
    products?: Product[] | undefined;
    processingTypes?: ProcessingType[] | undefined;
    polymeCoverTypes?: PolymeCoverType[] | undefined;
}

export enum ProductCategoryStatus {
    Active = 1,
    Inactive = 2,
}

export enum Category {
    QuickPrinting = 1,
    InkjetPrinting = 3,
    AdPrinting = 4,
    OffsetPrinting = 5,
    Other = 6,
}

export class Product extends BaseEntity implements IProduct {
    id!: number;
    name!: string;
    productCategoryId!: number;
    code!: string;
    description?: string | undefined;
    basicCharacteristics?: string | undefined;
    price!: number;
    images!: string;
    status!: ProductStatus;
    seoUrl!: string;
    metaDescription?: string | undefined;
    metaTitle?: string | undefined;
    types!: string;
    haveMachining!: boolean;
    noMachining!: boolean;
    isAnotherProduct!: boolean;
    isHiddenPrice!: boolean;
    displayNumber?: number | undefined;
    productCategory?: ProductCategory | undefined;
    prices?: Price[] | undefined;
    quotations?: Quotation[] | undefined;
    processingTypes?: ProcessingType[] | undefined;

    constructor(data?: IProduct) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.productCategoryId = _data["productCategoryId"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.basicCharacteristics = _data["basicCharacteristics"];
            this.price = _data["price"];
            this.images = _data["images"];
            this.status = _data["status"];
            this.seoUrl = _data["seoUrl"];
            this.metaDescription = _data["metaDescription"];
            this.metaTitle = _data["metaTitle"];
            this.types = _data["types"];
            this.haveMachining = _data["haveMachining"];
            this.noMachining = _data["noMachining"];
            this.isAnotherProduct = _data["isAnotherProduct"];
            this.isHiddenPrice = _data["isHiddenPrice"];
            this.displayNumber = _data["displayNumber"];
            this.productCategory = _data["productCategory"] ? ProductCategory.fromJS(_data["productCategory"]) : <any>undefined;
            if (Array.isArray(_data["prices"])) {
                this.prices = [] as any;
                for (let item of _data["prices"])
                    this.prices!.push(Price.fromJS(item));
            }
            if (Array.isArray(_data["quotations"])) {
                this.quotations = [] as any;
                for (let item of _data["quotations"])
                    this.quotations!.push(Quotation.fromJS(item));
            }
            if (Array.isArray(_data["processingTypes"])) {
                this.processingTypes = [] as any;
                for (let item of _data["processingTypes"])
                    this.processingTypes!.push(ProcessingType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["productCategoryId"] = this.productCategoryId;
        data["code"] = this.code;
        data["description"] = this.description;
        data["basicCharacteristics"] = this.basicCharacteristics;
        data["price"] = this.price;
        data["images"] = this.images;
        data["status"] = this.status;
        data["seoUrl"] = this.seoUrl;
        data["metaDescription"] = this.metaDescription;
        data["metaTitle"] = this.metaTitle;
        data["types"] = this.types;
        data["haveMachining"] = this.haveMachining;
        data["noMachining"] = this.noMachining;
        data["isAnotherProduct"] = this.isAnotherProduct;
        data["isHiddenPrice"] = this.isHiddenPrice;
        data["displayNumber"] = this.displayNumber;
        data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        if (Array.isArray(this.prices)) {
            data["prices"] = [];
            for (let item of this.prices)
                data["prices"].push(item.toJSON());
        }
        if (Array.isArray(this.quotations)) {
            data["quotations"] = [];
            for (let item of this.quotations)
                data["quotations"].push(item.toJSON());
        }
        if (Array.isArray(this.processingTypes)) {
            data["processingTypes"] = [];
            for (let item of this.processingTypes)
                data["processingTypes"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IProduct extends IBaseEntity {
    id: number;
    name: string;
    productCategoryId: number;
    code: string;
    description?: string | undefined;
    basicCharacteristics?: string | undefined;
    price: number;
    images: string;
    status: ProductStatus;
    seoUrl: string;
    metaDescription?: string | undefined;
    metaTitle?: string | undefined;
    types: string;
    haveMachining: boolean;
    noMachining: boolean;
    isAnotherProduct: boolean;
    isHiddenPrice: boolean;
    displayNumber?: number | undefined;
    productCategory?: ProductCategory | undefined;
    prices?: Price[] | undefined;
    quotations?: Quotation[] | undefined;
    processingTypes?: ProcessingType[] | undefined;
}

export enum ProductStatus {
    Active = 1,
    Inactive = 2,
}

export class Price extends BaseEntity implements IPrice {
    productId!: number;
    machining!: boolean;
    machiningType!: MachiningType;
    cutType!: CutType;
    customerLevel!: CustomerLevel;
    value!: string;
    product?: Product | undefined;

    constructor(data?: IPrice) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.productId = _data["productId"];
            this.machining = _data["machining"];
            this.machiningType = _data["machiningType"];
            this.cutType = _data["cutType"];
            this.customerLevel = _data["customerLevel"];
            this.value = _data["value"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Price {
        data = typeof data === 'object' ? data : {};
        let result = new Price();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["machining"] = this.machining;
        data["machiningType"] = this.machiningType;
        data["cutType"] = this.cutType;
        data["customerLevel"] = this.customerLevel;
        data["value"] = this.value;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IPrice extends IBaseEntity {
    productId: number;
    machining: boolean;
    machiningType: MachiningType;
    cutType: CutType;
    customerLevel: CustomerLevel;
    value: string;
    product?: Product | undefined;
}

export enum MachiningType {
    None = 0,
    Machining = 1,
    Hologram = 2,
    Tinsel = 3,
}

export enum CutType {
    None = 0,
    Straight = 1,
    Special = 2,
}

export class Quotation extends BaseEntity implements IQuotation {
    id!: string;
    name?: string | undefined;
    price!: number;
    width!: number;
    height!: number;
    minQuantity!: number;
    maxQuantity!: number;
    unit!: PricingUnit;
    isPricingByQuantity!: boolean;
    quotationType!: QuotationType;
    productCategoryId?: number | undefined;
    productId?: number | undefined;
    productCategory?: ProductCategory | undefined;
    product?: Product | undefined;

    constructor(data?: IQuotation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.price = _data["price"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.minQuantity = _data["minQuantity"];
            this.maxQuantity = _data["maxQuantity"];
            this.unit = _data["unit"];
            this.isPricingByQuantity = _data["isPricingByQuantity"];
            this.quotationType = _data["quotationType"];
            this.productCategoryId = _data["productCategoryId"];
            this.productId = _data["productId"];
            this.productCategory = _data["productCategory"] ? ProductCategory.fromJS(_data["productCategory"]) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Quotation {
        data = typeof data === 'object' ? data : {};
        let result = new Quotation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["price"] = this.price;
        data["width"] = this.width;
        data["height"] = this.height;
        data["minQuantity"] = this.minQuantity;
        data["maxQuantity"] = this.maxQuantity;
        data["unit"] = this.unit;
        data["isPricingByQuantity"] = this.isPricingByQuantity;
        data["quotationType"] = this.quotationType;
        data["productCategoryId"] = this.productCategoryId;
        data["productId"] = this.productId;
        data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IQuotation extends IBaseEntity {
    id: string;
    name?: string | undefined;
    price: number;
    width: number;
    height: number;
    minQuantity: number;
    maxQuantity: number;
    unit: PricingUnit;
    isPricingByQuantity: boolean;
    quotationType: QuotationType;
    productCategoryId?: number | undefined;
    productId?: number | undefined;
    productCategory?: ProductCategory | undefined;
    product?: Product | undefined;
}

export enum PricingUnit {
    Cm = 1,
    M = 2,
    Unit = 3,
}

export enum QuotationType {
    None = 0,
    Sticker = 1,
    Standee = 2,
    Paper = 3,
    Catalogue = 4,
    InkjetPrinting = 5,
}

export class PolymeCoverType extends BaseEntity implements IPolymeCoverType {
    id!: string;
    name?: string | undefined;
    productCategoryId!: number;
    showOnClientSite!: boolean;
    isNotProcessedValue!: boolean;
    productCategory?: ProductCategory | undefined;
    orderDetails?: OrderDetail[] | undefined;

    constructor(data?: IPolymeCoverType) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.productCategoryId = _data["productCategoryId"];
            this.showOnClientSite = _data["showOnClientSite"];
            this.isNotProcessedValue = _data["isNotProcessedValue"];
            this.productCategory = _data["productCategory"] ? ProductCategory.fromJS(_data["productCategory"]) : <any>undefined;
            if (Array.isArray(_data["orderDetails"])) {
                this.orderDetails = [] as any;
                for (let item of _data["orderDetails"])
                    this.orderDetails!.push(OrderDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PolymeCoverType {
        data = typeof data === 'object' ? data : {};
        let result = new PolymeCoverType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["productCategoryId"] = this.productCategoryId;
        data["showOnClientSite"] = this.showOnClientSite;
        data["isNotProcessedValue"] = this.isNotProcessedValue;
        data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        if (Array.isArray(this.orderDetails)) {
            data["orderDetails"] = [];
            for (let item of this.orderDetails)
                data["orderDetails"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IPolymeCoverType extends IBaseEntity {
    id: string;
    name?: string | undefined;
    productCategoryId: number;
    showOnClientSite: boolean;
    isNotProcessedValue: boolean;
    productCategory?: ProductCategory | undefined;
    orderDetails?: OrderDetail[] | undefined;
}

export class OrderDetail extends BaseEntity implements IOrderDetail {
    id!: string;
    orderId!: number;
    serviceName!: string;
    machining!: boolean;
    cutType!: CutType;
    width!: number;
    height!: number;
    quantity!: number;
    area!: number;
    couponCode?: string | undefined;
    couponAmount!: number;
    pricePerUnit!: number;
    totalPrice!: number;
    note?: string | undefined;
    sample?: string | undefined;
    fileName?: string | undefined;
    includeVAT!: boolean;
    vatAmount!: number;
    status!: OrderDetailStatus;
    catalogueProductItemId?: string | undefined;
    totalPage!: number;
    employeeId?: string | undefined;
    type!: OrderDetailType;
    processingTypeId?: string | undefined;
    processingTypeId2?: string | undefined;
    polymeCoverTypeId?: string | undefined;
    productCategoryId?: number | undefined;
    productId?: number | undefined;
    order?: Order | undefined;
    processingType?: ProcessingType | undefined;
    processingType2?: ProcessingType | undefined;
    polymeCoverType?: PolymeCoverType | undefined;
    productCategory?: ProductCategory | undefined;
    product?: Product | undefined;
    catalogueProductItem?: CatalogueProductItem | undefined;
    employee?: Admin | undefined;
    orderDetailProcessingTypeItems?: OrderDetailProcessingTypeItem[] | undefined;

    constructor(data?: IOrderDetail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.serviceName = _data["serviceName"];
            this.machining = _data["machining"];
            this.cutType = _data["cutType"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.quantity = _data["quantity"];
            this.area = _data["area"];
            this.couponCode = _data["couponCode"];
            this.couponAmount = _data["couponAmount"];
            this.pricePerUnit = _data["pricePerUnit"];
            this.totalPrice = _data["totalPrice"];
            this.note = _data["note"];
            this.sample = _data["sample"];
            this.fileName = _data["fileName"];
            this.includeVAT = _data["includeVAT"];
            this.vatAmount = _data["vatAmount"];
            this.status = _data["status"];
            this.catalogueProductItemId = _data["catalogueProductItemId"];
            this.totalPage = _data["totalPage"];
            this.employeeId = _data["employeeId"];
            this.type = _data["type"];
            this.processingTypeId = _data["processingTypeId"];
            this.processingTypeId2 = _data["processingTypeId2"];
            this.polymeCoverTypeId = _data["polymeCoverTypeId"];
            this.productCategoryId = _data["productCategoryId"];
            this.productId = _data["productId"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.processingType = _data["processingType"] ? ProcessingType.fromJS(_data["processingType"]) : <any>undefined;
            this.processingType2 = _data["processingType2"] ? ProcessingType.fromJS(_data["processingType2"]) : <any>undefined;
            this.polymeCoverType = _data["polymeCoverType"] ? PolymeCoverType.fromJS(_data["polymeCoverType"]) : <any>undefined;
            this.productCategory = _data["productCategory"] ? ProductCategory.fromJS(_data["productCategory"]) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.catalogueProductItem = _data["catalogueProductItem"] ? CatalogueProductItem.fromJS(_data["catalogueProductItem"]) : <any>undefined;
            this.employee = _data["employee"] ? Admin.fromJS(_data["employee"]) : <any>undefined;
            if (Array.isArray(_data["orderDetailProcessingTypeItems"])) {
                this.orderDetailProcessingTypeItems = [] as any;
                for (let item of _data["orderDetailProcessingTypeItems"])
                    this.orderDetailProcessingTypeItems!.push(OrderDetailProcessingTypeItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderDetail {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["serviceName"] = this.serviceName;
        data["machining"] = this.machining;
        data["cutType"] = this.cutType;
        data["width"] = this.width;
        data["height"] = this.height;
        data["quantity"] = this.quantity;
        data["area"] = this.area;
        data["couponCode"] = this.couponCode;
        data["couponAmount"] = this.couponAmount;
        data["pricePerUnit"] = this.pricePerUnit;
        data["totalPrice"] = this.totalPrice;
        data["note"] = this.note;
        data["sample"] = this.sample;
        data["fileName"] = this.fileName;
        data["includeVAT"] = this.includeVAT;
        data["vatAmount"] = this.vatAmount;
        data["status"] = this.status;
        data["catalogueProductItemId"] = this.catalogueProductItemId;
        data["totalPage"] = this.totalPage;
        data["employeeId"] = this.employeeId;
        data["type"] = this.type;
        data["processingTypeId"] = this.processingTypeId;
        data["processingTypeId2"] = this.processingTypeId2;
        data["polymeCoverTypeId"] = this.polymeCoverTypeId;
        data["productCategoryId"] = this.productCategoryId;
        data["productId"] = this.productId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["processingType"] = this.processingType ? this.processingType.toJSON() : <any>undefined;
        data["processingType2"] = this.processingType2 ? this.processingType2.toJSON() : <any>undefined;
        data["polymeCoverType"] = this.polymeCoverType ? this.polymeCoverType.toJSON() : <any>undefined;
        data["productCategory"] = this.productCategory ? this.productCategory.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["catalogueProductItem"] = this.catalogueProductItem ? this.catalogueProductItem.toJSON() : <any>undefined;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        if (Array.isArray(this.orderDetailProcessingTypeItems)) {
            data["orderDetailProcessingTypeItems"] = [];
            for (let item of this.orderDetailProcessingTypeItems)
                data["orderDetailProcessingTypeItems"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IOrderDetail extends IBaseEntity {
    id: string;
    orderId: number;
    serviceName: string;
    machining: boolean;
    cutType: CutType;
    width: number;
    height: number;
    quantity: number;
    area: number;
    couponCode?: string | undefined;
    couponAmount: number;
    pricePerUnit: number;
    totalPrice: number;
    note?: string | undefined;
    sample?: string | undefined;
    fileName?: string | undefined;
    includeVAT: boolean;
    vatAmount: number;
    status: OrderDetailStatus;
    catalogueProductItemId?: string | undefined;
    totalPage: number;
    employeeId?: string | undefined;
    type: OrderDetailType;
    processingTypeId?: string | undefined;
    processingTypeId2?: string | undefined;
    polymeCoverTypeId?: string | undefined;
    productCategoryId?: number | undefined;
    productId?: number | undefined;
    order?: Order | undefined;
    processingType?: ProcessingType | undefined;
    processingType2?: ProcessingType | undefined;
    polymeCoverType?: PolymeCoverType | undefined;
    productCategory?: ProductCategory | undefined;
    product?: Product | undefined;
    catalogueProductItem?: CatalogueProductItem | undefined;
    employee?: Admin | undefined;
    orderDetailProcessingTypeItems?: OrderDetailProcessingTypeItem[] | undefined;
}

export enum OrderDetailType {
    Product = 1,
    OtherService = 2,
}

export class Order extends BaseEntity implements IOrder {
    id!: number;
    code!: string;
    status!: OrderStatus;
    paymentStatus!: OrderPaymentStatus;
    gender!: Gender;
    customerId?: string | undefined;
    customerName!: string;
    customerPhoneNumber!: string;
    customerAddress?: string | undefined;
    customerNameOnBehalf?: string | undefined;
    customerPhoneNumberOnBehalf?: string | undefined;
    deliveryType!: OrderDeliveryType;
    needInstruction!: boolean;
    needTest!: boolean;
    needBill!: boolean;
    isSaveTemplate!: boolean;
    companyName?: string | undefined;
    companyAddress?: string | undefined;
    companyTaxCode?: string | undefined;
    otherRequirement?: string | undefined;
    total!: number;
    vatAmount!: number;
    discountAmount!: number;
    couponCode?: string | undefined;
    totalCustomerPay!: number;
    depositAmount!: number;
    deliveryDate!: Date;
    customerLevel!: CustomerLevel;
    orderFormularType!: OrderFormularType;
    paymentMethod!: OrderPaymentMethod;
    bankingNote?: string | undefined;
    employeeId?: string | undefined;
    email?: string | undefined;
    codAmount!: number;
    codNote?: string | undefined;
    shippingFee!: number;
    isSentCompleteMessage!: boolean;
    vatInvoiceStatus!: VATInvoiceStatus;
    employee?: Admin | undefined;
    customer?: Customer | undefined;
    orderDetails?: OrderDetail[] | undefined;
    orderDeposits?: OrderDeposit[] | undefined;

    constructor(data?: IOrder) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.status = _data["status"];
            this.paymentStatus = _data["paymentStatus"];
            this.gender = _data["gender"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.customerPhoneNumber = _data["customerPhoneNumber"];
            this.customerAddress = _data["customerAddress"];
            this.customerNameOnBehalf = _data["customerNameOnBehalf"];
            this.customerPhoneNumberOnBehalf = _data["customerPhoneNumberOnBehalf"];
            this.deliveryType = _data["deliveryType"];
            this.needInstruction = _data["needInstruction"];
            this.needTest = _data["needTest"];
            this.needBill = _data["needBill"];
            this.isSaveTemplate = _data["isSaveTemplate"];
            this.companyName = _data["companyName"];
            this.companyAddress = _data["companyAddress"];
            this.companyTaxCode = _data["companyTaxCode"];
            this.otherRequirement = _data["otherRequirement"];
            this.total = _data["total"];
            this.vatAmount = _data["vatAmount"];
            this.discountAmount = _data["discountAmount"];
            this.couponCode = _data["couponCode"];
            this.totalCustomerPay = _data["totalCustomerPay"];
            this.depositAmount = _data["depositAmount"];
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : <any>undefined;
            this.customerLevel = _data["customerLevel"];
            this.orderFormularType = _data["orderFormularType"];
            this.paymentMethod = _data["paymentMethod"];
            this.bankingNote = _data["bankingNote"];
            this.employeeId = _data["employeeId"];
            this.email = _data["email"];
            this.codAmount = _data["codAmount"];
            this.codNote = _data["codNote"];
            this.shippingFee = _data["shippingFee"];
            this.isSentCompleteMessage = _data["isSentCompleteMessage"];
            this.vatInvoiceStatus = _data["vatInvoiceStatus"];
            this.employee = _data["employee"] ? Admin.fromJS(_data["employee"]) : <any>undefined;
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            if (Array.isArray(_data["orderDetails"])) {
                this.orderDetails = [] as any;
                for (let item of _data["orderDetails"])
                    this.orderDetails!.push(OrderDetail.fromJS(item));
            }
            if (Array.isArray(_data["orderDeposits"])) {
                this.orderDeposits = [] as any;
                for (let item of _data["orderDeposits"])
                    this.orderDeposits!.push(OrderDeposit.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Order {
        data = typeof data === 'object' ? data : {};
        let result = new Order();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["status"] = this.status;
        data["paymentStatus"] = this.paymentStatus;
        data["gender"] = this.gender;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["customerPhoneNumber"] = this.customerPhoneNumber;
        data["customerAddress"] = this.customerAddress;
        data["customerNameOnBehalf"] = this.customerNameOnBehalf;
        data["customerPhoneNumberOnBehalf"] = this.customerPhoneNumberOnBehalf;
        data["deliveryType"] = this.deliveryType;
        data["needInstruction"] = this.needInstruction;
        data["needTest"] = this.needTest;
        data["needBill"] = this.needBill;
        data["isSaveTemplate"] = this.isSaveTemplate;
        data["companyName"] = this.companyName;
        data["companyAddress"] = this.companyAddress;
        data["companyTaxCode"] = this.companyTaxCode;
        data["otherRequirement"] = this.otherRequirement;
        data["total"] = this.total;
        data["vatAmount"] = this.vatAmount;
        data["discountAmount"] = this.discountAmount;
        data["couponCode"] = this.couponCode;
        data["totalCustomerPay"] = this.totalCustomerPay;
        data["depositAmount"] = this.depositAmount;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["customerLevel"] = this.customerLevel;
        data["orderFormularType"] = this.orderFormularType;
        data["paymentMethod"] = this.paymentMethod;
        data["bankingNote"] = this.bankingNote;
        data["employeeId"] = this.employeeId;
        data["email"] = this.email;
        data["codAmount"] = this.codAmount;
        data["codNote"] = this.codNote;
        data["shippingFee"] = this.shippingFee;
        data["isSentCompleteMessage"] = this.isSentCompleteMessage;
        data["vatInvoiceStatus"] = this.vatInvoiceStatus;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        if (Array.isArray(this.orderDetails)) {
            data["orderDetails"] = [];
            for (let item of this.orderDetails)
                data["orderDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.orderDeposits)) {
            data["orderDeposits"] = [];
            for (let item of this.orderDeposits)
                data["orderDeposits"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IOrder extends IBaseEntity {
    id: number;
    code: string;
    status: OrderStatus;
    paymentStatus: OrderPaymentStatus;
    gender: Gender;
    customerId?: string | undefined;
    customerName: string;
    customerPhoneNumber: string;
    customerAddress?: string | undefined;
    customerNameOnBehalf?: string | undefined;
    customerPhoneNumberOnBehalf?: string | undefined;
    deliveryType: OrderDeliveryType;
    needInstruction: boolean;
    needTest: boolean;
    needBill: boolean;
    isSaveTemplate: boolean;
    companyName?: string | undefined;
    companyAddress?: string | undefined;
    companyTaxCode?: string | undefined;
    otherRequirement?: string | undefined;
    total: number;
    vatAmount: number;
    discountAmount: number;
    couponCode?: string | undefined;
    totalCustomerPay: number;
    depositAmount: number;
    deliveryDate: Date;
    customerLevel: CustomerLevel;
    orderFormularType: OrderFormularType;
    paymentMethod: OrderPaymentMethod;
    bankingNote?: string | undefined;
    employeeId?: string | undefined;
    email?: string | undefined;
    codAmount: number;
    codNote?: string | undefined;
    shippingFee: number;
    isSentCompleteMessage: boolean;
    vatInvoiceStatus: VATInvoiceStatus;
    employee?: Admin | undefined;
    customer?: Customer | undefined;
    orderDetails?: OrderDetail[] | undefined;
    orderDeposits?: OrderDeposit[] | undefined;
}

export enum OrderDeliveryType {
    ByCompany = 1,
    ByCustomer = 2,
    ByShippingUnit = 3,
}

export enum OrderFormularType {
    ByArea = 1,
    ByQuantity = 2,
    ByPrice = 3,
}

export enum VATInvoiceStatus {
    NoVATInvoice = 0,
    VATInvoice = 1,
    VATInvoiceExported = 2,
}

export class IdentityUserOfString implements IIdentityUserOfString {
    id?: string | undefined;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed!: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed!: boolean;
    twoFactorEnabled!: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled!: boolean;
    accessFailedCount!: number;

    constructor(data?: IIdentityUserOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.email = _data["email"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.passwordHash = _data["passwordHash"];
            this.securityStamp = _data["securityStamp"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : <any>undefined;
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
        }
    }

    static fromJS(data: any): IdentityUserOfString {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUserOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["normalizedUserName"] = this.normalizedUserName;
        data["email"] = this.email;
        data["normalizedEmail"] = this.normalizedEmail;
        data["emailConfirmed"] = this.emailConfirmed;
        data["passwordHash"] = this.passwordHash;
        data["securityStamp"] = this.securityStamp;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>undefined;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        return data; 
    }
}

export interface IIdentityUserOfString {
    id?: string | undefined;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed: boolean;
    twoFactorEnabled: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled: boolean;
    accessFailedCount: number;
}

export class IdentityUser extends IdentityUserOfString implements IIdentityUser {

    constructor(data?: IIdentityUser) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): IdentityUser {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IIdentityUser extends IIdentityUserOfString {
}

export abstract class ApplicationUser extends IdentityUser implements IApplicationUser {
    displayName?: string | undefined;
    gender!: Gender;
    address?: string | undefined;

    constructor(data?: IApplicationUser) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.displayName = _data["displayName"];
            this.gender = _data["gender"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): ApplicationUser {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ApplicationUser' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["gender"] = this.gender;
        data["address"] = this.address;
        super.toJSON(data);
        return data; 
    }
}

export interface IApplicationUser extends IIdentityUser {
    displayName?: string | undefined;
    gender: Gender;
    address?: string | undefined;
}

export class Admin extends ApplicationUser implements IAdmin {

    constructor(data?: IAdmin) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): Admin {
        data = typeof data === 'object' ? data : {};
        let result = new Admin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IAdmin extends IApplicationUser {
}

export class Customer extends ApplicationUser implements ICustomer {
    level!: CustomerLevel;
    assignedSalesId?: string | undefined;
    code!: number;
    sales?: Admin | undefined;
    orders?: Order[] | undefined;
    customerCode?: string | undefined;

    constructor(data?: ICustomer) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.level = _data["level"];
            this.assignedSalesId = _data["assignedSalesId"];
            this.code = _data["code"];
            this.sales = _data["sales"] ? Admin.fromJS(_data["sales"]) : <any>undefined;
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(Order.fromJS(item));
            }
            this.customerCode = _data["customerCode"];
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["assignedSalesId"] = this.assignedSalesId;
        data["code"] = this.code;
        data["sales"] = this.sales ? this.sales.toJSON() : <any>undefined;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        data["customerCode"] = this.customerCode;
        super.toJSON(data);
        return data; 
    }
}

export interface ICustomer extends IApplicationUser {
    level: CustomerLevel;
    assignedSalesId?: string | undefined;
    code: number;
    sales?: Admin | undefined;
    orders?: Order[] | undefined;
    customerCode?: string | undefined;
}

export class OrderDeposit extends BaseEntity implements IOrderDeposit {
    id!: string;
    amount!: number;
    paymentMethod!: OrderPaymentMethod;
    note?: string | undefined;
    orderId!: number;
    order?: Order | undefined;

    constructor(data?: IOrderDeposit) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.amount = _data["amount"];
            this.paymentMethod = _data["paymentMethod"];
            this.note = _data["note"];
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderDeposit {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDeposit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amount"] = this.amount;
        data["paymentMethod"] = this.paymentMethod;
        data["note"] = this.note;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IOrderDeposit extends IBaseEntity {
    id: string;
    amount: number;
    paymentMethod: OrderPaymentMethod;
    note?: string | undefined;
    orderId: number;
    order?: Order | undefined;
}

export class CatalogueProductItem extends BaseEntity implements ICatalogueProductItem {
    id!: string;
    name!: string;
    catalogueProductId!: number;
    paperProductId?: number | undefined;
    paperProductName?: string | undefined;
    coverPaperProductId?: number | undefined;
    coverPaperProductName?: string | undefined;
    catalogueType!: CatalogueType;
    catalogueProduct?: Product | undefined;
    paperProduct?: Product | undefined;
    coverPaperProduct?: Product | undefined;
    cataloguePrices?: CataloguePrice[] | undefined;

    constructor(data?: ICatalogueProductItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.catalogueProductId = _data["catalogueProductId"];
            this.paperProductId = _data["paperProductId"];
            this.paperProductName = _data["paperProductName"];
            this.coverPaperProductId = _data["coverPaperProductId"];
            this.coverPaperProductName = _data["coverPaperProductName"];
            this.catalogueType = _data["catalogueType"];
            this.catalogueProduct = _data["catalogueProduct"] ? Product.fromJS(_data["catalogueProduct"]) : <any>undefined;
            this.paperProduct = _data["paperProduct"] ? Product.fromJS(_data["paperProduct"]) : <any>undefined;
            this.coverPaperProduct = _data["coverPaperProduct"] ? Product.fromJS(_data["coverPaperProduct"]) : <any>undefined;
            if (Array.isArray(_data["cataloguePrices"])) {
                this.cataloguePrices = [] as any;
                for (let item of _data["cataloguePrices"])
                    this.cataloguePrices!.push(CataloguePrice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CatalogueProductItem {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogueProductItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["catalogueProductId"] = this.catalogueProductId;
        data["paperProductId"] = this.paperProductId;
        data["paperProductName"] = this.paperProductName;
        data["coverPaperProductId"] = this.coverPaperProductId;
        data["coverPaperProductName"] = this.coverPaperProductName;
        data["catalogueType"] = this.catalogueType;
        data["catalogueProduct"] = this.catalogueProduct ? this.catalogueProduct.toJSON() : <any>undefined;
        data["paperProduct"] = this.paperProduct ? this.paperProduct.toJSON() : <any>undefined;
        data["coverPaperProduct"] = this.coverPaperProduct ? this.coverPaperProduct.toJSON() : <any>undefined;
        if (Array.isArray(this.cataloguePrices)) {
            data["cataloguePrices"] = [];
            for (let item of this.cataloguePrices)
                data["cataloguePrices"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface ICatalogueProductItem extends IBaseEntity {
    id: string;
    name: string;
    catalogueProductId: number;
    paperProductId?: number | undefined;
    paperProductName?: string | undefined;
    coverPaperProductId?: number | undefined;
    coverPaperProductName?: string | undefined;
    catalogueType: CatalogueType;
    catalogueProduct?: Product | undefined;
    paperProduct?: Product | undefined;
    coverPaperProduct?: Product | undefined;
    cataloguePrices?: CataloguePrice[] | undefined;
}

export enum CatalogueType {
    Ghim = 0,
    Loxo = 1,
}

export class CataloguePrice extends BaseEntity implements ICataloguePrice {
    id!: string;
    totalPage!: number;
    totalBook!: number;
    price!: number;
    catalogueProductItemId!: string;
    catalogueProductItem?: CatalogueProductItem | undefined;

    constructor(data?: ICataloguePrice) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.totalPage = _data["totalPage"];
            this.totalBook = _data["totalBook"];
            this.price = _data["price"];
            this.catalogueProductItemId = _data["catalogueProductItemId"];
            this.catalogueProductItem = _data["catalogueProductItem"] ? CatalogueProductItem.fromJS(_data["catalogueProductItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CataloguePrice {
        data = typeof data === 'object' ? data : {};
        let result = new CataloguePrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["totalPage"] = this.totalPage;
        data["totalBook"] = this.totalBook;
        data["price"] = this.price;
        data["catalogueProductItemId"] = this.catalogueProductItemId;
        data["catalogueProductItem"] = this.catalogueProductItem ? this.catalogueProductItem.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface ICataloguePrice extends IBaseEntity {
    id: string;
    totalPage: number;
    totalBook: number;
    price: number;
    catalogueProductItemId: string;
    catalogueProductItem?: CatalogueProductItem | undefined;
}

export class OrderDetailProcessingTypeItem extends BaseEntity implements IOrderDetailProcessingTypeItem {
    id!: string;
    orderDetailId!: string;
    processingTypeItemId!: string;
    processingTypeItem?: ProcessingTypeItem | undefined;
    orderDetail?: OrderDetail | undefined;

    constructor(data?: IOrderDetailProcessingTypeItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.orderDetailId = _data["orderDetailId"];
            this.processingTypeItemId = _data["processingTypeItemId"];
            this.processingTypeItem = _data["processingTypeItem"] ? ProcessingTypeItem.fromJS(_data["processingTypeItem"]) : <any>undefined;
            this.orderDetail = _data["orderDetail"] ? OrderDetail.fromJS(_data["orderDetail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderDetailProcessingTypeItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailProcessingTypeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderDetailId"] = this.orderDetailId;
        data["processingTypeItemId"] = this.processingTypeItemId;
        data["processingTypeItem"] = this.processingTypeItem ? this.processingTypeItem.toJSON() : <any>undefined;
        data["orderDetail"] = this.orderDetail ? this.orderDetail.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IOrderDetailProcessingTypeItem extends IBaseEntity {
    id: string;
    orderDetailId: string;
    processingTypeItemId: string;
    processingTypeItem?: ProcessingTypeItem | undefined;
    orderDetail?: OrderDetail | undefined;
}

export class ProcessingTypeItem extends BaseEntity implements IProcessingTypeItem {
    id!: string;
    name?: string | undefined;
    showOnClientSite!: boolean;
    processingTypeId!: string;
    processingType?: ProcessingType | undefined;
    orderDetailProcessingTypeItems?: OrderDetailProcessingTypeItem[] | undefined;

    constructor(data?: IProcessingTypeItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.showOnClientSite = _data["showOnClientSite"];
            this.processingTypeId = _data["processingTypeId"];
            this.processingType = _data["processingType"] ? ProcessingType.fromJS(_data["processingType"]) : <any>undefined;
            if (Array.isArray(_data["orderDetailProcessingTypeItems"])) {
                this.orderDetailProcessingTypeItems = [] as any;
                for (let item of _data["orderDetailProcessingTypeItems"])
                    this.orderDetailProcessingTypeItems!.push(OrderDetailProcessingTypeItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcessingTypeItem {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessingTypeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["showOnClientSite"] = this.showOnClientSite;
        data["processingTypeId"] = this.processingTypeId;
        data["processingType"] = this.processingType ? this.processingType.toJSON() : <any>undefined;
        if (Array.isArray(this.orderDetailProcessingTypeItems)) {
            data["orderDetailProcessingTypeItems"] = [];
            for (let item of this.orderDetailProcessingTypeItems)
                data["orderDetailProcessingTypeItems"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IProcessingTypeItem extends IBaseEntity {
    id: string;
    name?: string | undefined;
    showOnClientSite: boolean;
    processingTypeId: string;
    processingType?: ProcessingType | undefined;
    orderDetailProcessingTypeItems?: OrderDetailProcessingTypeItem[] | undefined;
}

export class CatalogueSizeOption implements ICatalogueSizeOption {
    width!: number;
    height!: number;
    name?: string | undefined;

    constructor(data?: ICatalogueSizeOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.width = _data["width"];
            this.height = _data["height"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CatalogueSizeOption {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogueSizeOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["width"] = this.width;
        data["height"] = this.height;
        data["name"] = this.name;
        return data; 
    }
}

export interface ICatalogueSizeOption {
    width: number;
    height: number;
    name?: string | undefined;
}

export class BaseValueModelOfInteger implements IBaseValueModelOfInteger {
    value!: number;
    text?: string | undefined;

    constructor(data?: IBaseValueModelOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): BaseValueModelOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new BaseValueModelOfInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["text"] = this.text;
        return data; 
    }
}

export interface IBaseValueModelOfInteger {
    value: number;
    text?: string | undefined;
}

export class PagedResultsOfSampleForOnlineLibraryViewModel implements IPagedResultsOfSampleForOnlineLibraryViewModel {
    resultCount!: number;
    pageNumber!: number;
    totalPages!: number;
    pageSize!: number;
    results?: SampleForOnlineLibraryViewModel[] | undefined;

    constructor(data?: IPagedResultsOfSampleForOnlineLibraryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SampleForOnlineLibraryViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultsOfSampleForOnlineLibraryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultsOfSampleForOnlineLibraryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultsOfSampleForOnlineLibraryViewModel {
    resultCount: number;
    pageNumber: number;
    totalPages: number;
    pageSize: number;
    results?: SampleForOnlineLibraryViewModel[] | undefined;
}

export class SampleForOnlineLibraryViewModel implements ISampleForOnlineLibraryViewModel {
    id!: number;
    name?: string | undefined;
    image?: string | undefined;

    constructor(data?: ISampleForOnlineLibraryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): SampleForOnlineLibraryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SampleForOnlineLibraryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["image"] = this.image;
        return data; 
    }
}

export interface ISampleForOnlineLibraryViewModel {
    id: number;
    name?: string | undefined;
    image?: string | undefined;
}

export class PagedResultsOfOrderListViewModel implements IPagedResultsOfOrderListViewModel {
    resultCount!: number;
    pageNumber!: number;
    totalPages!: number;
    pageSize!: number;
    results?: OrderListViewModel[] | undefined;

    constructor(data?: IPagedResultsOfOrderListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(OrderListViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultsOfOrderListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultsOfOrderListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultsOfOrderListViewModel {
    resultCount: number;
    pageNumber: number;
    totalPages: number;
    pageSize: number;
    results?: OrderListViewModel[] | undefined;
}

export class OrderListViewModel implements IOrderListViewModel {
    id!: number;
    code?: string | undefined;
    status!: OrderStatus;
    paymentStatus!: OrderPaymentStatus;
    vatInvoiceStatus!: VATInvoiceStatus;
    totalCustomerPay!: number;
    deliveryDate!: number;
    dateCreated!: number;
    customerName?: string | undefined;
    customerCode?: string | undefined;
    employeeName?: string | undefined;
    services?: string[] | undefined;
    depositAmount!: number;
    remainTotalCustomerPay!: number;
    customerLevel!: CustomerLevel;
    paymentMethod!: OrderPaymentMethod;
    bankingNote?: string | undefined;
    codAmount!: number;
    codNote?: string | undefined;
    vatAmount!: number;
    shippingFee!: number;
    discountAmount!: number;
    deliveryType?: string | undefined;
    sentZaloMessage!: boolean;
    orderDetails?: OrderDetailViewModel[] | undefined;

    constructor(data?: IOrderListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.status = _data["status"];
            this.paymentStatus = _data["paymentStatus"];
            this.vatInvoiceStatus = _data["vatInvoiceStatus"];
            this.totalCustomerPay = _data["totalCustomerPay"];
            this.deliveryDate = _data["deliveryDate"];
            this.dateCreated = _data["dateCreated"];
            this.customerName = _data["customerName"];
            this.customerCode = _data["customerCode"];
            this.employeeName = _data["employeeName"];
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(item);
            }
            this.depositAmount = _data["depositAmount"];
            this.remainTotalCustomerPay = _data["remainTotalCustomerPay"];
            this.customerLevel = _data["customerLevel"];
            this.paymentMethod = _data["paymentMethod"];
            this.bankingNote = _data["bankingNote"];
            this.codAmount = _data["codAmount"];
            this.codNote = _data["codNote"];
            this.vatAmount = _data["vatAmount"];
            this.shippingFee = _data["shippingFee"];
            this.discountAmount = _data["discountAmount"];
            this.deliveryType = _data["deliveryType"];
            this.sentZaloMessage = _data["sentZaloMessage"];
            if (Array.isArray(_data["orderDetails"])) {
                this.orderDetails = [] as any;
                for (let item of _data["orderDetails"])
                    this.orderDetails!.push(OrderDetailViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["status"] = this.status;
        data["paymentStatus"] = this.paymentStatus;
        data["vatInvoiceStatus"] = this.vatInvoiceStatus;
        data["totalCustomerPay"] = this.totalCustomerPay;
        data["deliveryDate"] = this.deliveryDate;
        data["dateCreated"] = this.dateCreated;
        data["customerName"] = this.customerName;
        data["customerCode"] = this.customerCode;
        data["employeeName"] = this.employeeName;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item);
        }
        data["depositAmount"] = this.depositAmount;
        data["remainTotalCustomerPay"] = this.remainTotalCustomerPay;
        data["customerLevel"] = this.customerLevel;
        data["paymentMethod"] = this.paymentMethod;
        data["bankingNote"] = this.bankingNote;
        data["codAmount"] = this.codAmount;
        data["codNote"] = this.codNote;
        data["vatAmount"] = this.vatAmount;
        data["shippingFee"] = this.shippingFee;
        data["discountAmount"] = this.discountAmount;
        data["deliveryType"] = this.deliveryType;
        data["sentZaloMessage"] = this.sentZaloMessage;
        if (Array.isArray(this.orderDetails)) {
            data["orderDetails"] = [];
            for (let item of this.orderDetails)
                data["orderDetails"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IOrderListViewModel {
    id: number;
    code?: string | undefined;
    status: OrderStatus;
    paymentStatus: OrderPaymentStatus;
    vatInvoiceStatus: VATInvoiceStatus;
    totalCustomerPay: number;
    deliveryDate: number;
    dateCreated: number;
    customerName?: string | undefined;
    customerCode?: string | undefined;
    employeeName?: string | undefined;
    services?: string[] | undefined;
    depositAmount: number;
    remainTotalCustomerPay: number;
    customerLevel: CustomerLevel;
    paymentMethod: OrderPaymentMethod;
    bankingNote?: string | undefined;
    codAmount: number;
    codNote?: string | undefined;
    vatAmount: number;
    shippingFee: number;
    discountAmount: number;
    deliveryType?: string | undefined;
    sentZaloMessage: boolean;
    orderDetails?: OrderDetailViewModel[] | undefined;
}

export class OrderDetailViewModel implements IOrderDetailViewModel {
    id!: string;
    serviceId!: number;
    categoryId!: number;
    serviceName?: string | undefined;
    machining!: boolean;
    cutType!: CutType;
    width!: number;
    height!: number;
    quantity!: number;
    total!: number;
    note?: string | undefined;
    sample?: string | undefined;
    area!: number;
    couponCode?: string | undefined;
    couponAmount!: number;
    pricePerUnit!: number;
    fileName?: string | undefined;
    includeVAT!: boolean;
    vatAmount!: number;
    processingTypeId?: string | undefined;
    processingTypeName?: string | undefined;
    processingTypeId2?: string | undefined;
    processingTypeName2?: string | undefined;
    polymeCoverTypeId?: string | undefined;
    polymeCoverTypeName?: string | undefined;
    type!: OrderDetailType;
    employee?: string | undefined;
    vat!: number;
    status!: OrderDetailStatus;
    totalArea!: number;
    processingSettingModels?: ProcessingSettingModel[] | undefined;
    totalPage!: number;
    catalogueProductId?: string | undefined;
    catalogueProductName?: string | undefined;
    catalogueSizeName?: string | undefined;

    constructor(data?: IOrderDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceId = _data["serviceId"];
            this.categoryId = _data["categoryId"];
            this.serviceName = _data["serviceName"];
            this.machining = _data["machining"];
            this.cutType = _data["cutType"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.quantity = _data["quantity"];
            this.total = _data["total"];
            this.note = _data["note"];
            this.sample = _data["sample"];
            this.area = _data["area"];
            this.couponCode = _data["couponCode"];
            this.couponAmount = _data["couponAmount"];
            this.pricePerUnit = _data["pricePerUnit"];
            this.fileName = _data["fileName"];
            this.includeVAT = _data["includeVAT"];
            this.vatAmount = _data["vatAmount"];
            this.processingTypeId = _data["processingTypeId"];
            this.processingTypeName = _data["processingTypeName"];
            this.processingTypeId2 = _data["processingTypeId2"];
            this.processingTypeName2 = _data["processingTypeName2"];
            this.polymeCoverTypeId = _data["polymeCoverTypeId"];
            this.polymeCoverTypeName = _data["polymeCoverTypeName"];
            this.type = _data["type"];
            this.employee = _data["employee"];
            this.vat = _data["vat"];
            this.status = _data["status"];
            this.totalArea = _data["totalArea"];
            if (Array.isArray(_data["processingSettingModels"])) {
                this.processingSettingModels = [] as any;
                for (let item of _data["processingSettingModels"])
                    this.processingSettingModels!.push(ProcessingSettingModel.fromJS(item));
            }
            this.totalPage = _data["totalPage"];
            this.catalogueProductId = _data["catalogueProductId"];
            this.catalogueProductName = _data["catalogueProductName"];
            this.catalogueSizeName = _data["catalogueSizeName"];
        }
    }

    static fromJS(data: any): OrderDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceId"] = this.serviceId;
        data["categoryId"] = this.categoryId;
        data["serviceName"] = this.serviceName;
        data["machining"] = this.machining;
        data["cutType"] = this.cutType;
        data["width"] = this.width;
        data["height"] = this.height;
        data["quantity"] = this.quantity;
        data["total"] = this.total;
        data["note"] = this.note;
        data["sample"] = this.sample;
        data["area"] = this.area;
        data["couponCode"] = this.couponCode;
        data["couponAmount"] = this.couponAmount;
        data["pricePerUnit"] = this.pricePerUnit;
        data["fileName"] = this.fileName;
        data["includeVAT"] = this.includeVAT;
        data["vatAmount"] = this.vatAmount;
        data["processingTypeId"] = this.processingTypeId;
        data["processingTypeName"] = this.processingTypeName;
        data["processingTypeId2"] = this.processingTypeId2;
        data["processingTypeName2"] = this.processingTypeName2;
        data["polymeCoverTypeId"] = this.polymeCoverTypeId;
        data["polymeCoverTypeName"] = this.polymeCoverTypeName;
        data["type"] = this.type;
        data["employee"] = this.employee;
        data["vat"] = this.vat;
        data["status"] = this.status;
        data["totalArea"] = this.totalArea;
        if (Array.isArray(this.processingSettingModels)) {
            data["processingSettingModels"] = [];
            for (let item of this.processingSettingModels)
                data["processingSettingModels"].push(item.toJSON());
        }
        data["totalPage"] = this.totalPage;
        data["catalogueProductId"] = this.catalogueProductId;
        data["catalogueProductName"] = this.catalogueProductName;
        data["catalogueSizeName"] = this.catalogueSizeName;
        return data; 
    }
}

export interface IOrderDetailViewModel {
    id: string;
    serviceId: number;
    categoryId: number;
    serviceName?: string | undefined;
    machining: boolean;
    cutType: CutType;
    width: number;
    height: number;
    quantity: number;
    total: number;
    note?: string | undefined;
    sample?: string | undefined;
    area: number;
    couponCode?: string | undefined;
    couponAmount: number;
    pricePerUnit: number;
    fileName?: string | undefined;
    includeVAT: boolean;
    vatAmount: number;
    processingTypeId?: string | undefined;
    processingTypeName?: string | undefined;
    processingTypeId2?: string | undefined;
    processingTypeName2?: string | undefined;
    polymeCoverTypeId?: string | undefined;
    polymeCoverTypeName?: string | undefined;
    type: OrderDetailType;
    employee?: string | undefined;
    vat: number;
    status: OrderDetailStatus;
    totalArea: number;
    processingSettingModels?: ProcessingSettingModel[] | undefined;
    totalPage: number;
    catalogueProductId?: string | undefined;
    catalogueProductName?: string | undefined;
    catalogueSizeName?: string | undefined;
}

export enum FilterType {
    CustomerName = 0,
    CustomerPhoneNumber = 1,
    CustomerCode = 2,
    OrderId = 3,
}

export class OrderViewModel implements IOrderViewModel {
    id!: number;
    code?: string | undefined;
    status!: OrderStatus;
    paymentStatus?: OrderPaymentStatus | undefined;
    orderDate!: number;
    deliveryDate!: Date;
    employeeId?: string | undefined;
    employeeName?: string | undefined;
    employeePhoneNumber?: string | undefined;
    email?: string | undefined;
    gender!: Gender;
    isSaveTemplate!: boolean;
    companyName?: string | undefined;
    companyAddress?: string | undefined;
    companyTaxCode?: string | undefined;
    otherRequirement?: string | undefined;
    customerId?: string | undefined;
    customerName?: string | undefined;
    customerCode?: string | undefined;
    customerNameOnBehalf?: string | undefined;
    customerPhone?: string | undefined;
    customerPhoneOnBehalf?: string | undefined;
    customerAddress?: string | undefined;
    orderAddress?: string | undefined;
    needBill!: boolean;
    needInstruction!: boolean;
    needTest!: boolean;
    deliveryType!: OrderDeliveryType;
    total!: number;
    vatAmount!: number;
    couponAmount!: number;
    totalCustomerPay!: number;
    depositAmount!: number;
    remainTotalCustomerPay!: number;
    shippingFee!: number;
    customerLevel!: CustomerLevel;
    orderFormularType!: OrderFormularType;
    orderDetails?: OrderDetailViewModel[] | undefined;
    bankingNote?: string | undefined;

    constructor(data?: IOrderViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.status = _data["status"];
            this.paymentStatus = _data["paymentStatus"];
            this.orderDate = _data["orderDate"];
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : <any>undefined;
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.employeePhoneNumber = _data["employeePhoneNumber"];
            this.email = _data["email"];
            this.gender = _data["gender"];
            this.isSaveTemplate = _data["isSaveTemplate"];
            this.companyName = _data["companyName"];
            this.companyAddress = _data["companyAddress"];
            this.companyTaxCode = _data["companyTaxCode"];
            this.otherRequirement = _data["otherRequirement"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.customerCode = _data["customerCode"];
            this.customerNameOnBehalf = _data["customerNameOnBehalf"];
            this.customerPhone = _data["customerPhone"];
            this.customerPhoneOnBehalf = _data["customerPhoneOnBehalf"];
            this.customerAddress = _data["customerAddress"];
            this.orderAddress = _data["orderAddress"];
            this.needBill = _data["needBill"];
            this.needInstruction = _data["needInstruction"];
            this.needTest = _data["needTest"];
            this.deliveryType = _data["deliveryType"];
            this.total = _data["total"];
            this.vatAmount = _data["vatAmount"];
            this.couponAmount = _data["couponAmount"];
            this.totalCustomerPay = _data["totalCustomerPay"];
            this.depositAmount = _data["depositAmount"];
            this.remainTotalCustomerPay = _data["remainTotalCustomerPay"];
            this.shippingFee = _data["shippingFee"];
            this.customerLevel = _data["customerLevel"];
            this.orderFormularType = _data["orderFormularType"];
            if (Array.isArray(_data["orderDetails"])) {
                this.orderDetails = [] as any;
                for (let item of _data["orderDetails"])
                    this.orderDetails!.push(OrderDetailViewModel.fromJS(item));
            }
            this.bankingNote = _data["bankingNote"];
        }
    }

    static fromJS(data: any): OrderViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["status"] = this.status;
        data["paymentStatus"] = this.paymentStatus;
        data["orderDate"] = this.orderDate;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["employeePhoneNumber"] = this.employeePhoneNumber;
        data["email"] = this.email;
        data["gender"] = this.gender;
        data["isSaveTemplate"] = this.isSaveTemplate;
        data["companyName"] = this.companyName;
        data["companyAddress"] = this.companyAddress;
        data["companyTaxCode"] = this.companyTaxCode;
        data["otherRequirement"] = this.otherRequirement;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["customerCode"] = this.customerCode;
        data["customerNameOnBehalf"] = this.customerNameOnBehalf;
        data["customerPhone"] = this.customerPhone;
        data["customerPhoneOnBehalf"] = this.customerPhoneOnBehalf;
        data["customerAddress"] = this.customerAddress;
        data["orderAddress"] = this.orderAddress;
        data["needBill"] = this.needBill;
        data["needInstruction"] = this.needInstruction;
        data["needTest"] = this.needTest;
        data["deliveryType"] = this.deliveryType;
        data["total"] = this.total;
        data["vatAmount"] = this.vatAmount;
        data["couponAmount"] = this.couponAmount;
        data["totalCustomerPay"] = this.totalCustomerPay;
        data["depositAmount"] = this.depositAmount;
        data["remainTotalCustomerPay"] = this.remainTotalCustomerPay;
        data["shippingFee"] = this.shippingFee;
        data["customerLevel"] = this.customerLevel;
        data["orderFormularType"] = this.orderFormularType;
        if (Array.isArray(this.orderDetails)) {
            data["orderDetails"] = [];
            for (let item of this.orderDetails)
                data["orderDetails"].push(item.toJSON());
        }
        data["bankingNote"] = this.bankingNote;
        return data; 
    }
}

export interface IOrderViewModel {
    id: number;
    code?: string | undefined;
    status: OrderStatus;
    paymentStatus?: OrderPaymentStatus | undefined;
    orderDate: number;
    deliveryDate: Date;
    employeeId?: string | undefined;
    employeeName?: string | undefined;
    employeePhoneNumber?: string | undefined;
    email?: string | undefined;
    gender: Gender;
    isSaveTemplate: boolean;
    companyName?: string | undefined;
    companyAddress?: string | undefined;
    companyTaxCode?: string | undefined;
    otherRequirement?: string | undefined;
    customerId?: string | undefined;
    customerName?: string | undefined;
    customerCode?: string | undefined;
    customerNameOnBehalf?: string | undefined;
    customerPhone?: string | undefined;
    customerPhoneOnBehalf?: string | undefined;
    customerAddress?: string | undefined;
    orderAddress?: string | undefined;
    needBill: boolean;
    needInstruction: boolean;
    needTest: boolean;
    deliveryType: OrderDeliveryType;
    total: number;
    vatAmount: number;
    couponAmount: number;
    totalCustomerPay: number;
    depositAmount: number;
    remainTotalCustomerPay: number;
    shippingFee: number;
    customerLevel: CustomerLevel;
    orderFormularType: OrderFormularType;
    orderDetails?: OrderDetailViewModel[] | undefined;
    bankingNote?: string | undefined;
}

export class UpdateOrderPaymentStatusInput implements IUpdateOrderPaymentStatusInput {
    ids!: number[];
    paymentStatus!: OrderPaymentStatus;
    orderDepositModels?: OrderDepositModel[] | undefined;

    constructor(data?: IUpdateOrderPaymentStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.paymentStatus = _data["paymentStatus"];
            if (Array.isArray(_data["orderDepositModels"])) {
                this.orderDepositModels = [] as any;
                for (let item of _data["orderDepositModels"])
                    this.orderDepositModels!.push(OrderDepositModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateOrderPaymentStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderPaymentStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["paymentStatus"] = this.paymentStatus;
        if (Array.isArray(this.orderDepositModels)) {
            data["orderDepositModels"] = [];
            for (let item of this.orderDepositModels)
                data["orderDepositModels"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateOrderPaymentStatusInput {
    ids: number[];
    paymentStatus: OrderPaymentStatus;
    orderDepositModels?: OrderDepositModel[] | undefined;
}

export class OrderDepositModel implements IOrderDepositModel {
    id?: string | undefined;
    orderId!: number;
    amount!: number;
    paymentMethod!: OrderPaymentMethod;
    note?: string | undefined;
    date!: Date;

    constructor(data?: IOrderDepositModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.amount = _data["amount"];
            this.paymentMethod = _data["paymentMethod"];
            this.note = _data["note"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderDepositModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDepositModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["amount"] = this.amount;
        data["paymentMethod"] = this.paymentMethod;
        data["note"] = this.note;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IOrderDepositModel {
    id?: string | undefined;
    orderId: number;
    amount: number;
    paymentMethod: OrderPaymentMethod;
    note?: string | undefined;
    date: Date;
}

export class UpdateOrderVATStatusInput implements IUpdateOrderVATStatusInput {
    ids?: number[] | undefined;
    status!: VATInvoiceStatus;

    constructor(data?: IUpdateOrderVATStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateOrderVATStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderVATStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["status"] = this.status;
        return data; 
    }
}

export interface IUpdateOrderVATStatusInput {
    ids?: number[] | undefined;
    status: VATInvoiceStatus;
}

export class CreateOrderInput implements ICreateOrderInput {
    gender!: Gender;
    customerId?: string | undefined;
    customerName!: string;
    customerPhoneNumber!: string;
    customerAddress?: string | undefined;
    customerNameOnBehalf?: string | undefined;
    customerPhoneNumberOnBehalf?: string | undefined;
    deliveryType!: OrderDeliveryType;
    shippingFee!: number;
    needInstruction!: boolean;
    needTest!: boolean;
    needBill!: boolean;
    isSaveTemplate!: boolean;
    companyName?: string | undefined;
    companyAddress?: string | undefined;
    companyTaxCode?: string | undefined;
    otherRequirement?: string | undefined;
    customerLevel!: CustomerLevel;
    orderFormularType!: OrderFormularType;
    daysForDelivery!: Date;
    createOrderDetails!: CreateOrderDetailInput[];
    employeeId?: string | undefined;
    email?: string | undefined;
    totalPrice!: number;
    discountAmount!: number;
    depositAmount!: number;
    vatAmount!: number;
    couponCode?: string | undefined;
    isFromPublicSite!: boolean;

    constructor(data?: ICreateOrderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.createOrderDetails = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gender = _data["gender"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.customerPhoneNumber = _data["customerPhoneNumber"];
            this.customerAddress = _data["customerAddress"];
            this.customerNameOnBehalf = _data["customerNameOnBehalf"];
            this.customerPhoneNumberOnBehalf = _data["customerPhoneNumberOnBehalf"];
            this.deliveryType = _data["deliveryType"];
            this.shippingFee = _data["shippingFee"];
            this.needInstruction = _data["needInstruction"];
            this.needTest = _data["needTest"];
            this.needBill = _data["needBill"];
            this.isSaveTemplate = _data["isSaveTemplate"];
            this.companyName = _data["companyName"];
            this.companyAddress = _data["companyAddress"];
            this.companyTaxCode = _data["companyTaxCode"];
            this.otherRequirement = _data["otherRequirement"];
            this.customerLevel = _data["customerLevel"];
            this.orderFormularType = _data["orderFormularType"];
            this.daysForDelivery = _data["daysForDelivery"] ? new Date(_data["daysForDelivery"].toString()) : <any>undefined;
            if (Array.isArray(_data["createOrderDetails"])) {
                this.createOrderDetails = [] as any;
                for (let item of _data["createOrderDetails"])
                    this.createOrderDetails!.push(CreateOrderDetailInput.fromJS(item));
            }
            this.employeeId = _data["employeeId"];
            this.email = _data["email"];
            this.totalPrice = _data["totalPrice"];
            this.discountAmount = _data["discountAmount"];
            this.depositAmount = _data["depositAmount"];
            this.vatAmount = _data["vatAmount"];
            this.couponCode = _data["couponCode"];
            this.isFromPublicSite = _data["isFromPublicSite"];
        }
    }

    static fromJS(data: any): CreateOrderInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gender"] = this.gender;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["customerPhoneNumber"] = this.customerPhoneNumber;
        data["customerAddress"] = this.customerAddress;
        data["customerNameOnBehalf"] = this.customerNameOnBehalf;
        data["customerPhoneNumberOnBehalf"] = this.customerPhoneNumberOnBehalf;
        data["deliveryType"] = this.deliveryType;
        data["shippingFee"] = this.shippingFee;
        data["needInstruction"] = this.needInstruction;
        data["needTest"] = this.needTest;
        data["needBill"] = this.needBill;
        data["isSaveTemplate"] = this.isSaveTemplate;
        data["companyName"] = this.companyName;
        data["companyAddress"] = this.companyAddress;
        data["companyTaxCode"] = this.companyTaxCode;
        data["otherRequirement"] = this.otherRequirement;
        data["customerLevel"] = this.customerLevel;
        data["orderFormularType"] = this.orderFormularType;
        data["daysForDelivery"] = this.daysForDelivery ? this.daysForDelivery.toISOString() : <any>undefined;
        if (Array.isArray(this.createOrderDetails)) {
            data["createOrderDetails"] = [];
            for (let item of this.createOrderDetails)
                data["createOrderDetails"].push(item.toJSON());
        }
        data["employeeId"] = this.employeeId;
        data["email"] = this.email;
        data["totalPrice"] = this.totalPrice;
        data["discountAmount"] = this.discountAmount;
        data["depositAmount"] = this.depositAmount;
        data["vatAmount"] = this.vatAmount;
        data["couponCode"] = this.couponCode;
        data["isFromPublicSite"] = this.isFromPublicSite;
        return data; 
    }
}

export interface ICreateOrderInput {
    gender: Gender;
    customerId?: string | undefined;
    customerName: string;
    customerPhoneNumber: string;
    customerAddress?: string | undefined;
    customerNameOnBehalf?: string | undefined;
    customerPhoneNumberOnBehalf?: string | undefined;
    deliveryType: OrderDeliveryType;
    shippingFee: number;
    needInstruction: boolean;
    needTest: boolean;
    needBill: boolean;
    isSaveTemplate: boolean;
    companyName?: string | undefined;
    companyAddress?: string | undefined;
    companyTaxCode?: string | undefined;
    otherRequirement?: string | undefined;
    customerLevel: CustomerLevel;
    orderFormularType: OrderFormularType;
    daysForDelivery: Date;
    createOrderDetails: CreateOrderDetailInput[];
    employeeId?: string | undefined;
    email?: string | undefined;
    totalPrice: number;
    discountAmount: number;
    depositAmount: number;
    vatAmount: number;
    couponCode?: string | undefined;
    isFromPublicSite: boolean;
}

export class CreateOrderDetailInput implements ICreateOrderDetailInput {
    id?: string | undefined;
    serviceId!: number;
    categoryId!: number;
    machining?: string | undefined;
    cutType?: string | undefined;
    processingTypeId?: string | undefined;
    processingTypeName?: string | undefined;
    processingTypeId2?: string | undefined;
    processingTypeName2?: string | undefined;
    polymeCoverTypeId?: string | undefined;
    polymeCoverTypeName?: string | undefined;
    processingSettings?: ProcessingSettingModel[] | undefined;
    width!: number;
    height!: number;
    quantity!: number;
    area!: number;
    pricePerUnit!: number;
    totalPrice!: number;
    fileName?: string | undefined;
    note?: string | undefined;
    sample?: string | undefined;
    couponCode?: string | undefined;
    depositAmount!: number;
    includeVAT!: boolean;
    vatAmount!: number;
    status!: OrderDetailStatus;
    catalogueProductItemId?: string | undefined;
    totalPage!: number;

    constructor(data?: ICreateOrderDetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceId = _data["serviceId"];
            this.categoryId = _data["categoryId"];
            this.machining = _data["machining"];
            this.cutType = _data["cutType"];
            this.processingTypeId = _data["processingTypeId"];
            this.processingTypeName = _data["processingTypeName"];
            this.processingTypeId2 = _data["processingTypeId2"];
            this.processingTypeName2 = _data["processingTypeName2"];
            this.polymeCoverTypeId = _data["polymeCoverTypeId"];
            this.polymeCoverTypeName = _data["polymeCoverTypeName"];
            if (Array.isArray(_data["processingSettings"])) {
                this.processingSettings = [] as any;
                for (let item of _data["processingSettings"])
                    this.processingSettings!.push(ProcessingSettingModel.fromJS(item));
            }
            this.width = _data["width"];
            this.height = _data["height"];
            this.quantity = _data["quantity"];
            this.area = _data["area"];
            this.pricePerUnit = _data["pricePerUnit"];
            this.totalPrice = _data["totalPrice"];
            this.fileName = _data["fileName"];
            this.note = _data["note"];
            this.sample = _data["sample"];
            this.couponCode = _data["couponCode"];
            this.depositAmount = _data["depositAmount"];
            this.includeVAT = _data["includeVAT"];
            this.vatAmount = _data["vatAmount"];
            this.status = _data["status"];
            this.catalogueProductItemId = _data["catalogueProductItemId"];
            this.totalPage = _data["totalPage"];
        }
    }

    static fromJS(data: any): CreateOrderDetailInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderDetailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceId"] = this.serviceId;
        data["categoryId"] = this.categoryId;
        data["machining"] = this.machining;
        data["cutType"] = this.cutType;
        data["processingTypeId"] = this.processingTypeId;
        data["processingTypeName"] = this.processingTypeName;
        data["processingTypeId2"] = this.processingTypeId2;
        data["processingTypeName2"] = this.processingTypeName2;
        data["polymeCoverTypeId"] = this.polymeCoverTypeId;
        data["polymeCoverTypeName"] = this.polymeCoverTypeName;
        if (Array.isArray(this.processingSettings)) {
            data["processingSettings"] = [];
            for (let item of this.processingSettings)
                data["processingSettings"].push(item.toJSON());
        }
        data["width"] = this.width;
        data["height"] = this.height;
        data["quantity"] = this.quantity;
        data["area"] = this.area;
        data["pricePerUnit"] = this.pricePerUnit;
        data["totalPrice"] = this.totalPrice;
        data["fileName"] = this.fileName;
        data["note"] = this.note;
        data["sample"] = this.sample;
        data["couponCode"] = this.couponCode;
        data["depositAmount"] = this.depositAmount;
        data["includeVAT"] = this.includeVAT;
        data["vatAmount"] = this.vatAmount;
        data["status"] = this.status;
        data["catalogueProductItemId"] = this.catalogueProductItemId;
        data["totalPage"] = this.totalPage;
        return data; 
    }
}

export interface ICreateOrderDetailInput {
    id?: string | undefined;
    serviceId: number;
    categoryId: number;
    machining?: string | undefined;
    cutType?: string | undefined;
    processingTypeId?: string | undefined;
    processingTypeName?: string | undefined;
    processingTypeId2?: string | undefined;
    processingTypeName2?: string | undefined;
    polymeCoverTypeId?: string | undefined;
    polymeCoverTypeName?: string | undefined;
    processingSettings?: ProcessingSettingModel[] | undefined;
    width: number;
    height: number;
    quantity: number;
    area: number;
    pricePerUnit: number;
    totalPrice: number;
    fileName?: string | undefined;
    note?: string | undefined;
    sample?: string | undefined;
    couponCode?: string | undefined;
    depositAmount: number;
    includeVAT: boolean;
    vatAmount: number;
    status: OrderDetailStatus;
    catalogueProductItemId?: string | undefined;
    totalPage: number;
}

export class OrderMaterialVewModel implements IOrderMaterialVewModel {
    productId!: number;
    categoryId!: number;
    processingType?: ProcessingTypeViewModel[] | undefined;
    processingType2?: ProcessingTypeViewModel[] | undefined;
    polymeCoverType?: PolymeCoverTypesViewModel[] | undefined;
    prices?: PriceViewModel[] | undefined;
    processingSettings?: ProcessingSettingModel[] | undefined;
    pricingType?: PricingType | undefined;
    quotationType!: QuotationType;

    constructor(data?: IOrderMaterialVewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.categoryId = _data["categoryId"];
            if (Array.isArray(_data["processingType"])) {
                this.processingType = [] as any;
                for (let item of _data["processingType"])
                    this.processingType!.push(ProcessingTypeViewModel.fromJS(item));
            }
            if (Array.isArray(_data["processingType2"])) {
                this.processingType2 = [] as any;
                for (let item of _data["processingType2"])
                    this.processingType2!.push(ProcessingTypeViewModel.fromJS(item));
            }
            if (Array.isArray(_data["polymeCoverType"])) {
                this.polymeCoverType = [] as any;
                for (let item of _data["polymeCoverType"])
                    this.polymeCoverType!.push(PolymeCoverTypesViewModel.fromJS(item));
            }
            if (Array.isArray(_data["prices"])) {
                this.prices = [] as any;
                for (let item of _data["prices"])
                    this.prices!.push(PriceViewModel.fromJS(item));
            }
            if (Array.isArray(_data["processingSettings"])) {
                this.processingSettings = [] as any;
                for (let item of _data["processingSettings"])
                    this.processingSettings!.push(ProcessingSettingModel.fromJS(item));
            }
            this.pricingType = _data["pricingType"];
            this.quotationType = _data["quotationType"];
        }
    }

    static fromJS(data: any): OrderMaterialVewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderMaterialVewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["categoryId"] = this.categoryId;
        if (Array.isArray(this.processingType)) {
            data["processingType"] = [];
            for (let item of this.processingType)
                data["processingType"].push(item.toJSON());
        }
        if (Array.isArray(this.processingType2)) {
            data["processingType2"] = [];
            for (let item of this.processingType2)
                data["processingType2"].push(item.toJSON());
        }
        if (Array.isArray(this.polymeCoverType)) {
            data["polymeCoverType"] = [];
            for (let item of this.polymeCoverType)
                data["polymeCoverType"].push(item.toJSON());
        }
        if (Array.isArray(this.prices)) {
            data["prices"] = [];
            for (let item of this.prices)
                data["prices"].push(item.toJSON());
        }
        if (Array.isArray(this.processingSettings)) {
            data["processingSettings"] = [];
            for (let item of this.processingSettings)
                data["processingSettings"].push(item.toJSON());
        }
        data["pricingType"] = this.pricingType;
        data["quotationType"] = this.quotationType;
        return data; 
    }
}

export interface IOrderMaterialVewModel {
    productId: number;
    categoryId: number;
    processingType?: ProcessingTypeViewModel[] | undefined;
    processingType2?: ProcessingTypeViewModel[] | undefined;
    polymeCoverType?: PolymeCoverTypesViewModel[] | undefined;
    prices?: PriceViewModel[] | undefined;
    processingSettings?: ProcessingSettingModel[] | undefined;
    pricingType?: PricingType | undefined;
    quotationType: QuotationType;
}

export class ProcessingTypeViewModel implements IProcessingTypeViewModel {
    id!: string;
    name?: string | undefined;
    isNotProcessedValue!: boolean;

    constructor(data?: IProcessingTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isNotProcessedValue = _data["isNotProcessedValue"];
        }
    }

    static fromJS(data: any): ProcessingTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessingTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isNotProcessedValue"] = this.isNotProcessedValue;
        return data; 
    }
}

export interface IProcessingTypeViewModel {
    id: string;
    name?: string | undefined;
    isNotProcessedValue: boolean;
}

export class PolymeCoverTypesViewModel implements IPolymeCoverTypesViewModel {
    id!: string;
    name?: string | undefined;
    isNotProcessedValue!: boolean;
    machiningType!: MachiningType;

    constructor(data?: IPolymeCoverTypesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isNotProcessedValue = _data["isNotProcessedValue"];
            this.machiningType = _data["machiningType"];
        }
    }

    static fromJS(data: any): PolymeCoverTypesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolymeCoverTypesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isNotProcessedValue"] = this.isNotProcessedValue;
        data["machiningType"] = this.machiningType;
        return data; 
    }
}

export interface IPolymeCoverTypesViewModel {
    id: string;
    name?: string | undefined;
    isNotProcessedValue: boolean;
    machiningType: MachiningType;
}

export class PriceViewModel implements IPriceViewModel {
    productId!: number;
    machining!: boolean;
    machiningType!: MachiningType;
    cutType!: CutType;
    customerLevel!: CustomerLevel;
    processingTypeId!: number;
    polymeCoverTypeId!: number;
    value?: PriceValueViewModel[] | undefined;

    constructor(data?: IPriceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.machining = _data["machining"];
            this.machiningType = _data["machiningType"];
            this.cutType = _data["cutType"];
            this.customerLevel = _data["customerLevel"];
            this.processingTypeId = _data["processingTypeId"];
            this.polymeCoverTypeId = _data["polymeCoverTypeId"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(PriceValueViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PriceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PriceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["machining"] = this.machining;
        data["machiningType"] = this.machiningType;
        data["cutType"] = this.cutType;
        data["customerLevel"] = this.customerLevel;
        data["processingTypeId"] = this.processingTypeId;
        data["polymeCoverTypeId"] = this.polymeCoverTypeId;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPriceViewModel {
    productId: number;
    machining: boolean;
    machiningType: MachiningType;
    cutType: CutType;
    customerLevel: CustomerLevel;
    processingTypeId: number;
    polymeCoverTypeId: number;
    value?: PriceValueViewModel[] | undefined;
}

export class PriceValueViewModel implements IPriceValueViewModel {
    id!: string;
    area!: number;
    price!: number;
    minQuantity!: number;
    maxQuantity!: number;

    constructor(data?: IPriceValueViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.area = _data["area"];
            this.price = _data["price"];
            this.minQuantity = _data["minQuantity"];
            this.maxQuantity = _data["maxQuantity"];
        }
    }

    static fromJS(data: any): PriceValueViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PriceValueViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["area"] = this.area;
        data["price"] = this.price;
        data["minQuantity"] = this.minQuantity;
        data["maxQuantity"] = this.maxQuantity;
        return data; 
    }
}

export interface IPriceValueViewModel {
    id: string;
    area: number;
    price: number;
    minQuantity: number;
    maxQuantity: number;
}

export enum PricingType {
    Quantity = 1,
    Size = 2,
    Sticker = 3,
}

export class UpdateOrderDetailStatusModel implements IUpdateOrderDetailStatusModel {
    orderDetailIds?: string[] | undefined;
    status!: number;

    constructor(data?: IUpdateOrderDetailStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderDetailIds"])) {
                this.orderDetailIds = [] as any;
                for (let item of _data["orderDetailIds"])
                    this.orderDetailIds!.push(item);
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateOrderDetailStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderDetailStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderDetailIds)) {
            data["orderDetailIds"] = [];
            for (let item of this.orderDetailIds)
                data["orderDetailIds"].push(item);
        }
        data["status"] = this.status;
        return data; 
    }
}

export interface IUpdateOrderDetailStatusModel {
    orderDetailIds?: string[] | undefined;
    status: number;
}

export class PagedResultsOfProducingListViewModel implements IPagedResultsOfProducingListViewModel {
    resultCount!: number;
    pageNumber!: number;
    totalPages!: number;
    pageSize!: number;
    results?: ProducingListViewModel[] | undefined;

    constructor(data?: IPagedResultsOfProducingListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ProducingListViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultsOfProducingListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultsOfProducingListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultsOfProducingListViewModel {
    resultCount: number;
    pageNumber: number;
    totalPages: number;
    pageSize: number;
    results?: ProducingListViewModel[] | undefined;
}

export class ProducingListViewModel implements IProducingListViewModel {
    id!: number;
    code?: string | undefined;
    status!: OrderStatus;
    paymentStatus!: OrderPaymentStatus;
    totalCustomerPay!: number;
    deliveryDate!: number;
    dateCreated!: number;
    customerName?: string | undefined;
    employeeName?: string | undefined;
    services?: string[] | undefined;
    depositAmount!: number;
    remainTotalCustomerPay!: number;
    customerLevel!: CustomerLevel;
    paymentMethod!: OrderPaymentMethod;
    bankingNote?: string | undefined;
    codAmount!: number;
    codNote?: string | undefined;
    vatAmount!: number;
    shippingFee!: number;
    discountAmount!: number;
    orderDetails?: OrderDetailViewModel[] | undefined;

    constructor(data?: IProducingListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.status = _data["status"];
            this.paymentStatus = _data["paymentStatus"];
            this.totalCustomerPay = _data["totalCustomerPay"];
            this.deliveryDate = _data["deliveryDate"];
            this.dateCreated = _data["dateCreated"];
            this.customerName = _data["customerName"];
            this.employeeName = _data["employeeName"];
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(item);
            }
            this.depositAmount = _data["depositAmount"];
            this.remainTotalCustomerPay = _data["remainTotalCustomerPay"];
            this.customerLevel = _data["customerLevel"];
            this.paymentMethod = _data["paymentMethod"];
            this.bankingNote = _data["bankingNote"];
            this.codAmount = _data["codAmount"];
            this.codNote = _data["codNote"];
            this.vatAmount = _data["vatAmount"];
            this.shippingFee = _data["shippingFee"];
            this.discountAmount = _data["discountAmount"];
            if (Array.isArray(_data["orderDetails"])) {
                this.orderDetails = [] as any;
                for (let item of _data["orderDetails"])
                    this.orderDetails!.push(OrderDetailViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProducingListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProducingListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["status"] = this.status;
        data["paymentStatus"] = this.paymentStatus;
        data["totalCustomerPay"] = this.totalCustomerPay;
        data["deliveryDate"] = this.deliveryDate;
        data["dateCreated"] = this.dateCreated;
        data["customerName"] = this.customerName;
        data["employeeName"] = this.employeeName;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item);
        }
        data["depositAmount"] = this.depositAmount;
        data["remainTotalCustomerPay"] = this.remainTotalCustomerPay;
        data["customerLevel"] = this.customerLevel;
        data["paymentMethod"] = this.paymentMethod;
        data["bankingNote"] = this.bankingNote;
        data["codAmount"] = this.codAmount;
        data["codNote"] = this.codNote;
        data["vatAmount"] = this.vatAmount;
        data["shippingFee"] = this.shippingFee;
        data["discountAmount"] = this.discountAmount;
        if (Array.isArray(this.orderDetails)) {
            data["orderDetails"] = [];
            for (let item of this.orderDetails)
                data["orderDetails"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProducingListViewModel {
    id: number;
    code?: string | undefined;
    status: OrderStatus;
    paymentStatus: OrderPaymentStatus;
    totalCustomerPay: number;
    deliveryDate: number;
    dateCreated: number;
    customerName?: string | undefined;
    employeeName?: string | undefined;
    services?: string[] | undefined;
    depositAmount: number;
    remainTotalCustomerPay: number;
    customerLevel: CustomerLevel;
    paymentMethod: OrderPaymentMethod;
    bankingNote?: string | undefined;
    codAmount: number;
    codNote?: string | undefined;
    vatAmount: number;
    shippingFee: number;
    discountAmount: number;
    orderDetails?: OrderDetailViewModel[] | undefined;
}

export class CreateOtherServiceInput implements ICreateOtherServiceInput {
    name!: string;

    constructor(data?: ICreateOtherServiceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateOtherServiceInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOtherServiceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface ICreateOtherServiceInput {
    name: string;
}

export class EditOtherServiceInput implements IEditOtherServiceInput {
    name!: string;

    constructor(data?: IEditOtherServiceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EditOtherServiceInput {
        data = typeof data === 'object' ? data : {};
        let result = new EditOtherServiceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface IEditOtherServiceInput {
    name: string;
}

export class EditOtherServicePriceInput implements IEditOtherServicePriceInput {
    quantity!: number;
    price!: number;

    constructor(data?: IEditOtherServicePriceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): EditOtherServicePriceInput {
        data = typeof data === 'object' ? data : {};
        let result = new EditOtherServicePriceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        return data; 
    }
}

export interface IEditOtherServicePriceInput {
    quantity: number;
    price: number;
}

export class PagedResultsOfOtherServiceListViewModel implements IPagedResultsOfOtherServiceListViewModel {
    resultCount!: number;
    pageNumber!: number;
    totalPages!: number;
    pageSize!: number;
    results?: OtherServiceListViewModel[] | undefined;

    constructor(data?: IPagedResultsOfOtherServiceListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(OtherServiceListViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultsOfOtherServiceListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultsOfOtherServiceListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultsOfOtherServiceListViewModel {
    resultCount: number;
    pageNumber: number;
    totalPages: number;
    pageSize: number;
    results?: OtherServiceListViewModel[] | undefined;
}

export class OtherServiceListViewModel implements IOtherServiceListViewModel {
    id!: number;
    name?: string | undefined;
    otherServicePriceViewModels?: OtherServicePriceViewModel[] | undefined;

    constructor(data?: IOtherServiceListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["otherServicePriceViewModels"])) {
                this.otherServicePriceViewModels = [] as any;
                for (let item of _data["otherServicePriceViewModels"])
                    this.otherServicePriceViewModels!.push(OtherServicePriceViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OtherServiceListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OtherServiceListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.otherServicePriceViewModels)) {
            data["otherServicePriceViewModels"] = [];
            for (let item of this.otherServicePriceViewModels)
                data["otherServicePriceViewModels"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IOtherServiceListViewModel {
    id: number;
    name?: string | undefined;
    otherServicePriceViewModels?: OtherServicePriceViewModel[] | undefined;
}

export class OtherServicePriceViewModel implements IOtherServicePriceViewModel {
    quantity!: number;
    price!: number;

    constructor(data?: IOtherServicePriceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): OtherServicePriceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OtherServicePriceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        return data; 
    }
}

export interface IOtherServicePriceViewModel {
    quantity: number;
    price: number;
}

export class OtherServiceViewModel implements IOtherServiceViewModel {
    name?: string | undefined;
    otherServicePriceViewModels?: OtherServicePriceViewModel[] | undefined;

    constructor(data?: IOtherServiceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["otherServicePriceViewModels"])) {
                this.otherServicePriceViewModels = [] as any;
                for (let item of _data["otherServicePriceViewModels"])
                    this.otherServicePriceViewModels!.push(OtherServicePriceViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OtherServiceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OtherServiceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.otherServicePriceViewModels)) {
            data["otherServicePriceViewModels"] = [];
            for (let item of this.otherServicePriceViewModels)
                data["otherServicePriceViewModels"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IOtherServiceViewModel {
    name?: string | undefined;
    otherServicePriceViewModels?: OtherServicePriceViewModel[] | undefined;
}

export class UpdatePriceInput implements IUpdatePriceInput {
    productId!: number;
    machining!: boolean;
    machiningType!: MachiningType;
    cutType!: CutType;
    priceValues?: PriceValueInput[] | undefined;
    customerLevel!: CustomerLevel;

    constructor(data?: IUpdatePriceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.machining = _data["machining"];
            this.machiningType = _data["machiningType"];
            this.cutType = _data["cutType"];
            if (Array.isArray(_data["priceValues"])) {
                this.priceValues = [] as any;
                for (let item of _data["priceValues"])
                    this.priceValues!.push(PriceValueInput.fromJS(item));
            }
            this.customerLevel = _data["customerLevel"];
        }
    }

    static fromJS(data: any): UpdatePriceInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePriceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["machining"] = this.machining;
        data["machiningType"] = this.machiningType;
        data["cutType"] = this.cutType;
        if (Array.isArray(this.priceValues)) {
            data["priceValues"] = [];
            for (let item of this.priceValues)
                data["priceValues"].push(item.toJSON());
        }
        data["customerLevel"] = this.customerLevel;
        return data; 
    }
}

export interface IUpdatePriceInput {
    productId: number;
    machining: boolean;
    machiningType: MachiningType;
    cutType: CutType;
    priceValues?: PriceValueInput[] | undefined;
    customerLevel: CustomerLevel;
}

export class PriceValueInput implements IPriceValueInput {
    id?: string | undefined;
    width!: number;
    height!: number;
    area!: number;
    price!: number;
    minQuantity!: number;
    maxQuantity!: number;
    type!: QuotationType;

    constructor(data?: IPriceValueInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.area = _data["area"];
            this.price = _data["price"];
            this.minQuantity = _data["minQuantity"];
            this.maxQuantity = _data["maxQuantity"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): PriceValueInput {
        data = typeof data === 'object' ? data : {};
        let result = new PriceValueInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["width"] = this.width;
        data["height"] = this.height;
        data["area"] = this.area;
        data["price"] = this.price;
        data["minQuantity"] = this.minQuantity;
        data["maxQuantity"] = this.maxQuantity;
        data["type"] = this.type;
        return data; 
    }
}

export interface IPriceValueInput {
    id?: string | undefined;
    width: number;
    height: number;
    area: number;
    price: number;
    minQuantity: number;
    maxQuantity: number;
    type: QuotationType;
}

export class PriceListViewModel implements IPriceListViewModel {
    id!: string;
    productId!: number;
    productName?: string | undefined;
    haveMachining!: boolean;
    noMachining!: boolean;
    machiningType!: MachiningType;
    categoryId!: number;
    width!: number;
    height!: number;
    minQuatity!: number;
    maxQuatity!: number;
    price!: number;
    isPricingByQuantity!: boolean;
    priceViewModels?: PriceViewModel[] | undefined;

    constructor(data?: IPriceListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.haveMachining = _data["haveMachining"];
            this.noMachining = _data["noMachining"];
            this.machiningType = _data["machiningType"];
            this.categoryId = _data["categoryId"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.minQuatity = _data["minQuatity"];
            this.maxQuatity = _data["maxQuatity"];
            this.price = _data["price"];
            this.isPricingByQuantity = _data["isPricingByQuantity"];
            if (Array.isArray(_data["priceViewModels"])) {
                this.priceViewModels = [] as any;
                for (let item of _data["priceViewModels"])
                    this.priceViewModels!.push(PriceViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PriceListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PriceListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["haveMachining"] = this.haveMachining;
        data["noMachining"] = this.noMachining;
        data["machiningType"] = this.machiningType;
        data["categoryId"] = this.categoryId;
        data["width"] = this.width;
        data["height"] = this.height;
        data["minQuatity"] = this.minQuatity;
        data["maxQuatity"] = this.maxQuatity;
        data["price"] = this.price;
        data["isPricingByQuantity"] = this.isPricingByQuantity;
        if (Array.isArray(this.priceViewModels)) {
            data["priceViewModels"] = [];
            for (let item of this.priceViewModels)
                data["priceViewModels"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPriceListViewModel {
    id: string;
    productId: number;
    productName?: string | undefined;
    haveMachining: boolean;
    noMachining: boolean;
    machiningType: MachiningType;
    categoryId: number;
    width: number;
    height: number;
    minQuatity: number;
    maxQuatity: number;
    price: number;
    isPricingByQuantity: boolean;
    priceViewModels?: PriceViewModel[] | undefined;
}

export class AddPriceInput implements IAddPriceInput {
    name?: string | undefined;
    productId!: number;
    isPricingByQuantity!: boolean;
    type!: QuotationType;
    priceValueInputs?: PriceValueInput[] | undefined;

    constructor(data?: IAddPriceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.productId = _data["productId"];
            this.isPricingByQuantity = _data["isPricingByQuantity"];
            this.type = _data["type"];
            if (Array.isArray(_data["priceValueInputs"])) {
                this.priceValueInputs = [] as any;
                for (let item of _data["priceValueInputs"])
                    this.priceValueInputs!.push(PriceValueInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddPriceInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddPriceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["productId"] = this.productId;
        data["isPricingByQuantity"] = this.isPricingByQuantity;
        data["type"] = this.type;
        if (Array.isArray(this.priceValueInputs)) {
            data["priceValueInputs"] = [];
            for (let item of this.priceValueInputs)
                data["priceValueInputs"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAddPriceInput {
    name?: string | undefined;
    productId: number;
    isPricingByQuantity: boolean;
    type: QuotationType;
    priceValueInputs?: PriceValueInput[] | undefined;
}

export class UpdateQuantityThresholdInput implements IUpdateQuantityThresholdInput {
    categotyIds?: number[] | undefined;
    updateQuantityThresholdInputs?: UpdateQuantityThresholdItem[] | undefined;

    constructor(data?: IUpdateQuantityThresholdInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categotyIds"])) {
                this.categotyIds = [] as any;
                for (let item of _data["categotyIds"])
                    this.categotyIds!.push(item);
            }
            if (Array.isArray(_data["updateQuantityThresholdInputs"])) {
                this.updateQuantityThresholdInputs = [] as any;
                for (let item of _data["updateQuantityThresholdInputs"])
                    this.updateQuantityThresholdInputs!.push(UpdateQuantityThresholdItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateQuantityThresholdInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuantityThresholdInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categotyIds)) {
            data["categotyIds"] = [];
            for (let item of this.categotyIds)
                data["categotyIds"].push(item);
        }
        if (Array.isArray(this.updateQuantityThresholdInputs)) {
            data["updateQuantityThresholdInputs"] = [];
            for (let item of this.updateQuantityThresholdInputs)
                data["updateQuantityThresholdInputs"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateQuantityThresholdInput {
    categotyIds?: number[] | undefined;
    updateQuantityThresholdInputs?: UpdateQuantityThresholdItem[] | undefined;
}

export class UpdateQuantityThresholdItem implements IUpdateQuantityThresholdItem {
    from!: number;
    to!: number;
    originalValue?: UpdateQuantityThresholdItem | undefined;

    constructor(data?: IUpdateQuantityThresholdItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"];
            this.to = _data["to"];
            this.originalValue = _data["originalValue"] ? UpdateQuantityThresholdItem.fromJS(_data["originalValue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateQuantityThresholdItem {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuantityThresholdItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from;
        data["to"] = this.to;
        data["originalValue"] = this.originalValue ? this.originalValue.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateQuantityThresholdItem {
    from: number;
    to: number;
    originalValue?: UpdateQuantityThresholdItem | undefined;
}

export class UpdateSizeThresholdInput implements IUpdateSizeThresholdInput {
    quotationType!: QuotationType;
    width!: number;
    height!: number;
    originalValue?: UpdateSizeThresholdInput | undefined;

    constructor(data?: IUpdateSizeThresholdInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quotationType = _data["quotationType"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.originalValue = _data["originalValue"] ? UpdateSizeThresholdInput.fromJS(_data["originalValue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateSizeThresholdInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSizeThresholdInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quotationType"] = this.quotationType;
        data["width"] = this.width;
        data["height"] = this.height;
        data["originalValue"] = this.originalValue ? this.originalValue.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateSizeThresholdInput {
    quotationType: QuotationType;
    width: number;
    height: number;
    originalValue?: UpdateSizeThresholdInput | undefined;
}

export class ProductListViewModel implements IProductListViewModel {
    id!: number;
    name?: string | undefined;
    productCategoryId!: number;
    productCategoryName?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    price!: number;
    images?: string | undefined;
    status!: ProductStatus;
    seoUrl?: string | undefined;
    metaDescription?: string | undefined;
    metaTitle?: string | undefined;
    displayNumber?: number | undefined;

    constructor(data?: IProductListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.productCategoryId = _data["productCategoryId"];
            this.productCategoryName = _data["productCategoryName"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.images = _data["images"];
            this.status = _data["status"];
            this.seoUrl = _data["seoUrl"];
            this.metaDescription = _data["metaDescription"];
            this.metaTitle = _data["metaTitle"];
            this.displayNumber = _data["displayNumber"];
        }
    }

    static fromJS(data: any): ProductListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["productCategoryId"] = this.productCategoryId;
        data["productCategoryName"] = this.productCategoryName;
        data["code"] = this.code;
        data["description"] = this.description;
        data["price"] = this.price;
        data["images"] = this.images;
        data["status"] = this.status;
        data["seoUrl"] = this.seoUrl;
        data["metaDescription"] = this.metaDescription;
        data["metaTitle"] = this.metaTitle;
        data["displayNumber"] = this.displayNumber;
        return data; 
    }
}

export interface IProductListViewModel {
    id: number;
    name?: string | undefined;
    productCategoryId: number;
    productCategoryName?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    price: number;
    images?: string | undefined;
    status: ProductStatus;
    seoUrl?: string | undefined;
    metaDescription?: string | undefined;
    metaTitle?: string | undefined;
    displayNumber?: number | undefined;
}

export class CataloguePriceListViewModel implements ICataloguePriceListViewModel {
    id!: number;
    name?: string | undefined;
    productId?: number | undefined;
    processingTypeId?: string | undefined;
    polymeCoverTypeId?: string | undefined;
    catalogPricingType!: PaperPricingType;
    catalogPricingUnit!: PaperPricingUnit;
    thresholdViewModels?: CataloguePriceThresholdViewModel[] | undefined;

    constructor(data?: ICataloguePriceListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.productId = _data["productId"];
            this.processingTypeId = _data["processingTypeId"];
            this.polymeCoverTypeId = _data["polymeCoverTypeId"];
            this.catalogPricingType = _data["catalogPricingType"];
            this.catalogPricingUnit = _data["catalogPricingUnit"];
            if (Array.isArray(_data["thresholdViewModels"])) {
                this.thresholdViewModels = [] as any;
                for (let item of _data["thresholdViewModels"])
                    this.thresholdViewModels!.push(CataloguePriceThresholdViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CataloguePriceListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CataloguePriceListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["productId"] = this.productId;
        data["processingTypeId"] = this.processingTypeId;
        data["polymeCoverTypeId"] = this.polymeCoverTypeId;
        data["catalogPricingType"] = this.catalogPricingType;
        data["catalogPricingUnit"] = this.catalogPricingUnit;
        if (Array.isArray(this.thresholdViewModels)) {
            data["thresholdViewModels"] = [];
            for (let item of this.thresholdViewModels)
                data["thresholdViewModels"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICataloguePriceListViewModel {
    id: number;
    name?: string | undefined;
    productId?: number | undefined;
    processingTypeId?: string | undefined;
    polymeCoverTypeId?: string | undefined;
    catalogPricingType: PaperPricingType;
    catalogPricingUnit: PaperPricingUnit;
    thresholdViewModels?: CataloguePriceThresholdViewModel[] | undefined;
}

export enum PaperPricingType {
    Printing = 0,
    Paper = 1,
    Processing = 2,
    CoverPolyme = 3,
}

export enum PaperPricingUnit {
    Page = 0,
    Book = 1,
}

export class CataloguePriceThresholdViewModel implements ICataloguePriceThresholdViewModel {
    id!: string;
    minValue!: number;
    maxValue!: number;
    price!: number;

    constructor(data?: ICataloguePriceThresholdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): CataloguePriceThresholdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CataloguePriceThresholdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["price"] = this.price;
        return data; 
    }
}

export interface ICataloguePriceThresholdViewModel {
    id: string;
    minValue: number;
    maxValue: number;
    price: number;
}

export class CatalogUpdatePriceThresholdInput implements ICatalogUpdatePriceThresholdInput {
    id?: string | undefined;
    minValue!: number;
    maxValue!: number;
    price!: number;

    constructor(data?: ICatalogUpdatePriceThresholdInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): CatalogUpdatePriceThresholdInput {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogUpdatePriceThresholdInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["price"] = this.price;
        return data; 
    }
}

export interface ICatalogUpdatePriceThresholdInput {
    id?: string | undefined;
    minValue: number;
    maxValue: number;
    price: number;
}

export class CatalogUpdatePriceInput implements ICatalogUpdatePriceInput {
    id!: number;
    name?: string | undefined;
    productId?: number | undefined;
    processingTypeId?: string | undefined;
    polymeCoverTypeId?: string | undefined;
    catalogPricingType!: PaperPricingType;
    catalogPricingUnit!: PaperPricingUnit;
    thresholdInputs?: CatalogUpdatePriceThresholdInput[] | undefined;

    constructor(data?: ICatalogUpdatePriceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.productId = _data["productId"];
            this.processingTypeId = _data["processingTypeId"];
            this.polymeCoverTypeId = _data["polymeCoverTypeId"];
            this.catalogPricingType = _data["catalogPricingType"];
            this.catalogPricingUnit = _data["catalogPricingUnit"];
            if (Array.isArray(_data["thresholdInputs"])) {
                this.thresholdInputs = [] as any;
                for (let item of _data["thresholdInputs"])
                    this.thresholdInputs!.push(CatalogUpdatePriceThresholdInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CatalogUpdatePriceInput {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogUpdatePriceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["productId"] = this.productId;
        data["processingTypeId"] = this.processingTypeId;
        data["polymeCoverTypeId"] = this.polymeCoverTypeId;
        data["catalogPricingType"] = this.catalogPricingType;
        data["catalogPricingUnit"] = this.catalogPricingUnit;
        if (Array.isArray(this.thresholdInputs)) {
            data["thresholdInputs"] = [];
            for (let item of this.thresholdInputs)
                data["thresholdInputs"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICatalogUpdatePriceInput {
    id: number;
    name?: string | undefined;
    productId?: number | undefined;
    processingTypeId?: string | undefined;
    polymeCoverTypeId?: string | undefined;
    catalogPricingType: PaperPricingType;
    catalogPricingUnit: PaperPricingUnit;
    thresholdInputs?: CatalogUpdatePriceThresholdInput[] | undefined;
}

export class CatalogueProductItemsPrice implements ICatalogueProductItemsPrice {
    id!: string;
    totalPage!: number;
    totalBook!: number;
    catalogueProductId!: string;
    price!: number;

    constructor(data?: ICatalogueProductItemsPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.totalPage = _data["totalPage"];
            this.totalBook = _data["totalBook"];
            this.catalogueProductId = _data["catalogueProductId"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): CatalogueProductItemsPrice {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogueProductItemsPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["totalPage"] = this.totalPage;
        data["totalBook"] = this.totalBook;
        data["catalogueProductId"] = this.catalogueProductId;
        data["price"] = this.price;
        return data; 
    }
}

export interface ICatalogueProductItemsPrice {
    id: string;
    totalPage: number;
    totalBook: number;
    catalogueProductId: string;
    price: number;
}

export class UpdateCatalogueProductItemPrice implements IUpdateCatalogueProductItemPrice {
    id!: string;
    price!: number;

    constructor(data?: IUpdateCatalogueProductItemPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): UpdateCatalogueProductItemPrice {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCatalogueProductItemPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["price"] = this.price;
        return data; 
    }
}

export interface IUpdateCatalogueProductItemPrice {
    id: string;
    price: number;
}

export class ProductCategoryViewModel implements IProductCategoryViewModel {
    id!: number;
    name?: string | undefined;
    status!: ProductCategoryStatus;
    image?: string | undefined;
    seoUrl?: string | undefined;
    metaDescription?: string | undefined;
    metaTitle?: string | undefined;
    showOnMenu!: boolean;
    orderNumber!: number;
    category!: Category;

    constructor(data?: IProductCategoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.image = _data["image"];
            this.seoUrl = _data["seoUrl"];
            this.metaDescription = _data["metaDescription"];
            this.metaTitle = _data["metaTitle"];
            this.showOnMenu = _data["showOnMenu"];
            this.orderNumber = _data["orderNumber"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): ProductCategoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCategoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["image"] = this.image;
        data["seoUrl"] = this.seoUrl;
        data["metaDescription"] = this.metaDescription;
        data["metaTitle"] = this.metaTitle;
        data["showOnMenu"] = this.showOnMenu;
        data["orderNumber"] = this.orderNumber;
        data["category"] = this.category;
        return data; 
    }
}

export interface IProductCategoryViewModel {
    id: number;
    name?: string | undefined;
    status: ProductCategoryStatus;
    image?: string | undefined;
    seoUrl?: string | undefined;
    metaDescription?: string | undefined;
    metaTitle?: string | undefined;
    showOnMenu: boolean;
    orderNumber: number;
    category: Category;
}

export class PagedResultsOfProductCategoryListViewModel implements IPagedResultsOfProductCategoryListViewModel {
    resultCount!: number;
    pageNumber!: number;
    totalPages!: number;
    pageSize!: number;
    results?: ProductCategoryListViewModel[] | undefined;

    constructor(data?: IPagedResultsOfProductCategoryListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ProductCategoryListViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultsOfProductCategoryListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultsOfProductCategoryListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultsOfProductCategoryListViewModel {
    resultCount: number;
    pageNumber: number;
    totalPages: number;
    pageSize: number;
    results?: ProductCategoryListViewModel[] | undefined;
}

export class ProductCategoryListViewModel implements IProductCategoryListViewModel {
    id!: number;
    name?: string | undefined;
    status!: ProductCategoryStatus;
    image?: string | undefined;
    seoUrl?: string | undefined;
    showOnMenu!: boolean;

    constructor(data?: IProductCategoryListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.image = _data["image"];
            this.seoUrl = _data["seoUrl"];
            this.showOnMenu = _data["showOnMenu"];
        }
    }

    static fromJS(data: any): ProductCategoryListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCategoryListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["image"] = this.image;
        data["seoUrl"] = this.seoUrl;
        data["showOnMenu"] = this.showOnMenu;
        return data; 
    }
}

export interface IProductCategoryListViewModel {
    id: number;
    name?: string | undefined;
    status: ProductCategoryStatus;
    image?: string | undefined;
    seoUrl?: string | undefined;
    showOnMenu: boolean;
}

export class ProductCategoryOrderNumber implements IProductCategoryOrderNumber {
    id!: number;
    name?: string | undefined;
    orderNumber!: number;

    constructor(data?: IProductCategoryOrderNumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.orderNumber = _data["orderNumber"];
        }
    }

    static fromJS(data: any): ProductCategoryOrderNumber {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCategoryOrderNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["orderNumber"] = this.orderNumber;
        return data; 
    }
}

export interface IProductCategoryOrderNumber {
    id: number;
    name?: string | undefined;
    orderNumber: number;
}

export class UpdateCategoryOrderNumbers implements IUpdateCategoryOrderNumbers {
    productCategoryOrderNumbers?: ProductCategoryOrderNumber[] | undefined;

    constructor(data?: IUpdateCategoryOrderNumbers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productCategoryOrderNumbers"])) {
                this.productCategoryOrderNumbers = [] as any;
                for (let item of _data["productCategoryOrderNumbers"])
                    this.productCategoryOrderNumbers!.push(ProductCategoryOrderNumber.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateCategoryOrderNumbers {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCategoryOrderNumbers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productCategoryOrderNumbers)) {
            data["productCategoryOrderNumbers"] = [];
            for (let item of this.productCategoryOrderNumbers)
                data["productCategoryOrderNumbers"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateCategoryOrderNumbers {
    productCategoryOrderNumbers?: ProductCategoryOrderNumber[] | undefined;
}

export class ProductMenu implements IProductMenu {
    id!: string;
    productMenuName?: string | undefined;
    productMenuItems?: ProductMenuItem[] | undefined;

    constructor(data?: IProductMenu) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productMenuName = _data["productMenuName"];
            if (Array.isArray(_data["productMenuItems"])) {
                this.productMenuItems = [] as any;
                for (let item of _data["productMenuItems"])
                    this.productMenuItems!.push(ProductMenuItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductMenu {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMenu();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productMenuName"] = this.productMenuName;
        if (Array.isArray(this.productMenuItems)) {
            data["productMenuItems"] = [];
            for (let item of this.productMenuItems)
                data["productMenuItems"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProductMenu {
    id: string;
    productMenuName?: string | undefined;
    productMenuItems?: ProductMenuItem[] | undefined;
}

export class ProductMenuItem implements IProductMenuItem {
    id!: number;
    name?: string | undefined;
    imageUrl?: string | undefined;
    description1?: string | undefined;
    description2?: string | undefined;

    constructor(data?: IProductMenuItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.imageUrl = _data["imageUrl"];
            this.description1 = _data["description1"];
            this.description2 = _data["description2"];
        }
    }

    static fromJS(data: any): ProductMenuItem {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMenuItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["imageUrl"] = this.imageUrl;
        data["description1"] = this.description1;
        data["description2"] = this.description2;
        return data; 
    }
}

export interface IProductMenuItem {
    id: number;
    name?: string | undefined;
    imageUrl?: string | undefined;
    description1?: string | undefined;
    description2?: string | undefined;
}

export class PagedResultsOfProductListViewModel implements IPagedResultsOfProductListViewModel {
    resultCount!: number;
    pageNumber!: number;
    totalPages!: number;
    pageSize!: number;
    results?: ProductListViewModel[] | undefined;

    constructor(data?: IPagedResultsOfProductListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ProductListViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultsOfProductListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultsOfProductListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultsOfProductListViewModel {
    resultCount: number;
    pageNumber: number;
    totalPages: number;
    pageSize: number;
    results?: ProductListViewModel[] | undefined;
}

export enum ProductType {
    Normal = 1,
    Special = 2,
    Creative = 3,
}

export enum PaperType {
    All = 0,
    Cover = 1,
    Paper = 2,
}

export enum ProductPricingType {
    Size = 0,
    Pieces = 1,
    Sticker = 2,
    Catalogue = 3,
}

export class ProductViewModel implements IProductViewModel {
    id!: number;
    name?: string | undefined;
    productCategoryId!: number;
    code?: string | undefined;
    description?: string | undefined;
    basicCharacteristics?: string | undefined;
    price!: number;
    haveMachining!: boolean;
    noMachining!: boolean;
    imageLinks?: string[] | undefined;
    status!: ProductStatus;
    seoUrl?: string | undefined;
    metaDescription?: string | undefined;
    metaTitle?: string | undefined;
    types?: ProductType[] | undefined;
    paperType!: PaperType;
    isAnotherProduct!: boolean;
    isHiddenPrice!: boolean;
    displayNumber?: number | undefined;
    productPricingType!: ProductPricingType;

    constructor(data?: IProductViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.productCategoryId = _data["productCategoryId"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.basicCharacteristics = _data["basicCharacteristics"];
            this.price = _data["price"];
            this.haveMachining = _data["haveMachining"];
            this.noMachining = _data["noMachining"];
            if (Array.isArray(_data["imageLinks"])) {
                this.imageLinks = [] as any;
                for (let item of _data["imageLinks"])
                    this.imageLinks!.push(item);
            }
            this.status = _data["status"];
            this.seoUrl = _data["seoUrl"];
            this.metaDescription = _data["metaDescription"];
            this.metaTitle = _data["metaTitle"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            this.paperType = _data["paperType"];
            this.isAnotherProduct = _data["isAnotherProduct"];
            this.isHiddenPrice = _data["isHiddenPrice"];
            this.displayNumber = _data["displayNumber"];
            this.productPricingType = _data["productPricingType"];
        }
    }

    static fromJS(data: any): ProductViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["productCategoryId"] = this.productCategoryId;
        data["code"] = this.code;
        data["description"] = this.description;
        data["basicCharacteristics"] = this.basicCharacteristics;
        data["price"] = this.price;
        data["haveMachining"] = this.haveMachining;
        data["noMachining"] = this.noMachining;
        if (Array.isArray(this.imageLinks)) {
            data["imageLinks"] = [];
            for (let item of this.imageLinks)
                data["imageLinks"].push(item);
        }
        data["status"] = this.status;
        data["seoUrl"] = this.seoUrl;
        data["metaDescription"] = this.metaDescription;
        data["metaTitle"] = this.metaTitle;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        data["paperType"] = this.paperType;
        data["isAnotherProduct"] = this.isAnotherProduct;
        data["isHiddenPrice"] = this.isHiddenPrice;
        data["displayNumber"] = this.displayNumber;
        data["productPricingType"] = this.productPricingType;
        return data; 
    }
}

export interface IProductViewModel {
    id: number;
    name?: string | undefined;
    productCategoryId: number;
    code?: string | undefined;
    description?: string | undefined;
    basicCharacteristics?: string | undefined;
    price: number;
    haveMachining: boolean;
    noMachining: boolean;
    imageLinks?: string[] | undefined;
    status: ProductStatus;
    seoUrl?: string | undefined;
    metaDescription?: string | undefined;
    metaTitle?: string | undefined;
    types?: ProductType[] | undefined;
    paperType: PaperType;
    isAnotherProduct: boolean;
    isHiddenPrice: boolean;
    displayNumber?: number | undefined;
    productPricingType: ProductPricingType;
}

export class CatalogueMaterialsViewModel implements ICatalogueMaterialsViewModel {
    type!: PaperPricingType;
    productId!: number;
    productName?: string | undefined;
    materialId!: string;
    materialName?: string | undefined;

    constructor(data?: ICatalogueMaterialsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.materialId = _data["materialId"];
            this.materialName = _data["materialName"];
        }
    }

    static fromJS(data: any): CatalogueMaterialsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogueMaterialsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        return data; 
    }
}

export interface ICatalogueMaterialsViewModel {
    type: PaperPricingType;
    productId: number;
    productName?: string | undefined;
    materialId: string;
    materialName?: string | undefined;
}

export class SelectModelOfGuid implements ISelectModelOfGuid {
    id!: string;
    name?: string | undefined;
    defaultValue!: boolean;

    constructor(data?: ISelectModelOfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.defaultValue = _data["defaultValue"];
        }
    }

    static fromJS(data: any): SelectModelOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new SelectModelOfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["defaultValue"] = this.defaultValue;
        return data; 
    }
}

export interface ISelectModelOfGuid {
    id: string;
    name?: string | undefined;
    defaultValue: boolean;
}

export class ProcessingTypeModel implements IProcessingTypeModel {
    id?: string | undefined;
    name?: string | undefined;
    productId!: number;
    productCategoryId!: number;
    processingTypeItemModels?: ProcessingTypeItemModel[] | undefined;

    constructor(data?: IProcessingTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.productId = _data["productId"];
            this.productCategoryId = _data["productCategoryId"];
            if (Array.isArray(_data["processingTypeItemModels"])) {
                this.processingTypeItemModels = [] as any;
                for (let item of _data["processingTypeItemModels"])
                    this.processingTypeItemModels!.push(ProcessingTypeItemModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcessingTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessingTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["productId"] = this.productId;
        data["productCategoryId"] = this.productCategoryId;
        if (Array.isArray(this.processingTypeItemModels)) {
            data["processingTypeItemModels"] = [];
            for (let item of this.processingTypeItemModels)
                data["processingTypeItemModels"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProcessingTypeModel {
    id?: string | undefined;
    name?: string | undefined;
    productId: number;
    productCategoryId: number;
    processingTypeItemModels?: ProcessingTypeItemModel[] | undefined;
}

export class ProcessingTypeItemModel implements IProcessingTypeItemModel {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IProcessingTypeItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProcessingTypeItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessingTypeItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IProcessingTypeItemModel {
    id?: string | undefined;
    name?: string | undefined;
}

export class ProcessingTypeInput implements IProcessingTypeInput {
    productId!: number;
    processingTypeModels?: ProcessingTypeModel[] | undefined;

    constructor(data?: IProcessingTypeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            if (Array.isArray(_data["processingTypeModels"])) {
                this.processingTypeModels = [] as any;
                for (let item of _data["processingTypeModels"])
                    this.processingTypeModels!.push(ProcessingTypeModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcessingTypeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessingTypeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        if (Array.isArray(this.processingTypeModels)) {
            data["processingTypeModels"] = [];
            for (let item of this.processingTypeModels)
                data["processingTypeModels"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProcessingTypeInput {
    productId: number;
    processingTypeModels?: ProcessingTypeModel[] | undefined;
}

export class ProductMenuSettingModel implements IProductMenuSettingModel {
    productMenuTypeId!: number;
    productMenuTypeName?: string | undefined;
    themeColor?: string | undefined;
    productMenuSettingItems?: ProductMenuSettingItem[] | undefined;

    constructor(data?: IProductMenuSettingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productMenuTypeId = _data["productMenuTypeId"];
            this.productMenuTypeName = _data["productMenuTypeName"];
            this.themeColor = _data["themeColor"];
            if (Array.isArray(_data["productMenuSettingItems"])) {
                this.productMenuSettingItems = [] as any;
                for (let item of _data["productMenuSettingItems"])
                    this.productMenuSettingItems!.push(ProductMenuSettingItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductMenuSettingModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMenuSettingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productMenuTypeId"] = this.productMenuTypeId;
        data["productMenuTypeName"] = this.productMenuTypeName;
        data["themeColor"] = this.themeColor;
        if (Array.isArray(this.productMenuSettingItems)) {
            data["productMenuSettingItems"] = [];
            for (let item of this.productMenuSettingItems)
                data["productMenuSettingItems"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProductMenuSettingModel {
    productMenuTypeId: number;
    productMenuTypeName?: string | undefined;
    themeColor?: string | undefined;
    productMenuSettingItems?: ProductMenuSettingItem[] | undefined;
}

export class ProductMenuSettingItem implements IProductMenuSettingItem {
    id!: string;
    productName?: string | undefined;
    categoryName?: string | undefined;
    productId!: number;
    categoryId!: number;
    ordinal!: number;
    imagePath?: string | undefined;
    url?: string | undefined;

    constructor(data?: IProductMenuSettingItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productName = _data["productName"];
            this.categoryName = _data["categoryName"];
            this.productId = _data["productId"];
            this.categoryId = _data["categoryId"];
            this.ordinal = _data["ordinal"];
            this.imagePath = _data["imagePath"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): ProductMenuSettingItem {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMenuSettingItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productName"] = this.productName;
        data["categoryName"] = this.categoryName;
        data["productId"] = this.productId;
        data["categoryId"] = this.categoryId;
        data["ordinal"] = this.ordinal;
        data["imagePath"] = this.imagePath;
        data["url"] = this.url;
        return data; 
    }
}

export interface IProductMenuSettingItem {
    id: string;
    productName?: string | undefined;
    categoryName?: string | undefined;
    productId: number;
    categoryId: number;
    ordinal: number;
    imagePath?: string | undefined;
    url?: string | undefined;
}

export class ProductMenuTypeInput implements IProductMenuTypeInput {
    id!: number;
    name?: string | undefined;
    themeColor?: string | undefined;

    constructor(data?: IProductMenuTypeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.themeColor = _data["themeColor"];
        }
    }

    static fromJS(data: any): ProductMenuTypeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMenuTypeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["themeColor"] = this.themeColor;
        return data; 
    }
}

export interface IProductMenuTypeInput {
    id: number;
    name?: string | undefined;
    themeColor?: string | undefined;
}

export class CatalogueMaterials implements ICatalogueMaterials {
    productId!: number;
    categoryId!: number;
    productName?: string | undefined;
    products?: CataloguePaperMaterial[] | undefined;
    polymeCoverTypes?: BaseValueModelOfGuid[] | undefined;
    processingTypes?: BaseValueModelOfGuid[] | undefined;

    constructor(data?: ICatalogueMaterials) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.categoryId = _data["categoryId"];
            this.productName = _data["productName"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(CataloguePaperMaterial.fromJS(item));
            }
            if (Array.isArray(_data["polymeCoverTypes"])) {
                this.polymeCoverTypes = [] as any;
                for (let item of _data["polymeCoverTypes"])
                    this.polymeCoverTypes!.push(BaseValueModelOfGuid.fromJS(item));
            }
            if (Array.isArray(_data["processingTypes"])) {
                this.processingTypes = [] as any;
                for (let item of _data["processingTypes"])
                    this.processingTypes!.push(BaseValueModelOfGuid.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CatalogueMaterials {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogueMaterials();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["categoryId"] = this.categoryId;
        data["productName"] = this.productName;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        if (Array.isArray(this.polymeCoverTypes)) {
            data["polymeCoverTypes"] = [];
            for (let item of this.polymeCoverTypes)
                data["polymeCoverTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.processingTypes)) {
            data["processingTypes"] = [];
            for (let item of this.processingTypes)
                data["processingTypes"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICatalogueMaterials {
    productId: number;
    categoryId: number;
    productName?: string | undefined;
    products?: CataloguePaperMaterial[] | undefined;
    polymeCoverTypes?: BaseValueModelOfGuid[] | undefined;
    processingTypes?: BaseValueModelOfGuid[] | undefined;
}

export class CataloguePaperMaterial implements ICataloguePaperMaterial {
    id!: number;
    name?: string | undefined;
    paperType!: PaperType;

    constructor(data?: ICataloguePaperMaterial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.paperType = _data["paperType"];
        }
    }

    static fromJS(data: any): CataloguePaperMaterial {
        data = typeof data === 'object' ? data : {};
        let result = new CataloguePaperMaterial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["paperType"] = this.paperType;
        return data; 
    }
}

export interface ICataloguePaperMaterial {
    id: number;
    name?: string | undefined;
    paperType: PaperType;
}

export class BaseValueModelOfGuid implements IBaseValueModelOfGuid {
    value!: string;
    text?: string | undefined;

    constructor(data?: IBaseValueModelOfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): BaseValueModelOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new BaseValueModelOfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["text"] = this.text;
        return data; 
    }
}

export interface IBaseValueModelOfGuid {
    value: string;
    text?: string | undefined;
}

export class CataloguePriceViewModel implements ICataloguePriceViewModel {
    id!: number;
    name?: string | undefined;
    productId?: number | undefined;
    processingTypeId?: string | undefined;
    polymeCoverTypeId?: string | undefined;
    catalogPricingType!: PaperPricingType;
    catalogPricingUnit!: PaperPricingUnit;
    thresholdViewModels?: CataloguePriceThresholdViewModel2[] | undefined;

    constructor(data?: ICataloguePriceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.productId = _data["productId"];
            this.processingTypeId = _data["processingTypeId"];
            this.polymeCoverTypeId = _data["polymeCoverTypeId"];
            this.catalogPricingType = _data["catalogPricingType"];
            this.catalogPricingUnit = _data["catalogPricingUnit"];
            if (Array.isArray(_data["thresholdViewModels"])) {
                this.thresholdViewModels = [] as any;
                for (let item of _data["thresholdViewModels"])
                    this.thresholdViewModels!.push(CataloguePriceThresholdViewModel2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CataloguePriceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CataloguePriceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["productId"] = this.productId;
        data["processingTypeId"] = this.processingTypeId;
        data["polymeCoverTypeId"] = this.polymeCoverTypeId;
        data["catalogPricingType"] = this.catalogPricingType;
        data["catalogPricingUnit"] = this.catalogPricingUnit;
        if (Array.isArray(this.thresholdViewModels)) {
            data["thresholdViewModels"] = [];
            for (let item of this.thresholdViewModels)
                data["thresholdViewModels"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICataloguePriceViewModel {
    id: number;
    name?: string | undefined;
    productId?: number | undefined;
    processingTypeId?: string | undefined;
    polymeCoverTypeId?: string | undefined;
    catalogPricingType: PaperPricingType;
    catalogPricingUnit: PaperPricingUnit;
    thresholdViewModels?: CataloguePriceThresholdViewModel2[] | undefined;
}

export class CataloguePriceThresholdViewModel2 implements ICataloguePriceThresholdViewModel2 {
    id!: string;
    minValue!: number;
    maxValue!: number;
    price!: number;

    constructor(data?: ICataloguePriceThresholdViewModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): CataloguePriceThresholdViewModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new CataloguePriceThresholdViewModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["price"] = this.price;
        return data; 
    }
}

export interface ICataloguePriceThresholdViewModel2 {
    id: string;
    minValue: number;
    maxValue: number;
    price: number;
}

export class PagedResultsOfRevenueStatisticsListViewModel implements IPagedResultsOfRevenueStatisticsListViewModel {
    resultCount!: number;
    pageNumber!: number;
    totalPages!: number;
    pageSize!: number;
    results?: RevenueStatisticsListViewModel[] | undefined;

    constructor(data?: IPagedResultsOfRevenueStatisticsListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(RevenueStatisticsListViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultsOfRevenueStatisticsListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultsOfRevenueStatisticsListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultsOfRevenueStatisticsListViewModel {
    resultCount: number;
    pageNumber: number;
    totalPages: number;
    pageSize: number;
    results?: RevenueStatisticsListViewModel[] | undefined;
}

export class RevenueStatisticsListViewModel implements IRevenueStatisticsListViewModel {
    date!: number;
    paperDecalAmount!: number;
    milkDecalAmount!: number;
    transparentDecalAmount!: number;
    kraftDecalAmount!: number;
    silverXiAmount!: number;
    goldXiAmount!: number;
    sevenColorAmount!: number;
    brokenStickerAmount!: number;
    specialMilkDecalAmount!: number;

    constructor(data?: IRevenueStatisticsListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.paperDecalAmount = _data["paperDecalAmount"];
            this.milkDecalAmount = _data["milkDecalAmount"];
            this.transparentDecalAmount = _data["transparentDecalAmount"];
            this.kraftDecalAmount = _data["kraftDecalAmount"];
            this.silverXiAmount = _data["silverXiAmount"];
            this.goldXiAmount = _data["goldXiAmount"];
            this.sevenColorAmount = _data["sevenColorAmount"];
            this.brokenStickerAmount = _data["brokenStickerAmount"];
            this.specialMilkDecalAmount = _data["specialMilkDecalAmount"];
        }
    }

    static fromJS(data: any): RevenueStatisticsListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RevenueStatisticsListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["paperDecalAmount"] = this.paperDecalAmount;
        data["milkDecalAmount"] = this.milkDecalAmount;
        data["transparentDecalAmount"] = this.transparentDecalAmount;
        data["kraftDecalAmount"] = this.kraftDecalAmount;
        data["silverXiAmount"] = this.silverXiAmount;
        data["goldXiAmount"] = this.goldXiAmount;
        data["sevenColorAmount"] = this.sevenColorAmount;
        data["brokenStickerAmount"] = this.brokenStickerAmount;
        data["specialMilkDecalAmount"] = this.specialMilkDecalAmount;
        return data; 
    }
}

export interface IRevenueStatisticsListViewModel {
    date: number;
    paperDecalAmount: number;
    milkDecalAmount: number;
    transparentDecalAmount: number;
    kraftDecalAmount: number;
    silverXiAmount: number;
    goldXiAmount: number;
    sevenColorAmount: number;
    brokenStickerAmount: number;
    specialMilkDecalAmount: number;
}

export class RevenueStatisticsByEmployee implements IRevenueStatisticsByEmployee {
    year!: number;
    month!: number;
    total!: number;
    employeeId?: string | undefined;
    employeeName?: string | undefined;
    orderPaymentStatus!: OrderPaymentStatus;

    constructor(data?: IRevenueStatisticsByEmployee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.total = _data["total"];
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.orderPaymentStatus = _data["orderPaymentStatus"];
        }
    }

    static fromJS(data: any): RevenueStatisticsByEmployee {
        data = typeof data === 'object' ? data : {};
        let result = new RevenueStatisticsByEmployee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["total"] = this.total;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["orderPaymentStatus"] = this.orderPaymentStatus;
        return data; 
    }
}

export interface IRevenueStatisticsByEmployee {
    year: number;
    month: number;
    total: number;
    employeeId?: string | undefined;
    employeeName?: string | undefined;
    orderPaymentStatus: OrderPaymentStatus;
}

export class RevenueStatisticsByProductCategory implements IRevenueStatisticsByProductCategory {
    productId!: number;
    productName?: string | undefined;
    orderCount!: number;
    totalProduct!: number;
    totalItem!: number;
    totalPrice!: number;

    constructor(data?: IRevenueStatisticsByProductCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.orderCount = _data["orderCount"];
            this.totalProduct = _data["totalProduct"];
            this.totalItem = _data["totalItem"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): RevenueStatisticsByProductCategory {
        data = typeof data === 'object' ? data : {};
        let result = new RevenueStatisticsByProductCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["orderCount"] = this.orderCount;
        data["totalProduct"] = this.totalProduct;
        data["totalItem"] = this.totalItem;
        data["totalPrice"] = this.totalPrice;
        return data; 
    }
}

export interface IRevenueStatisticsByProductCategory {
    productId: number;
    productName?: string | undefined;
    orderCount: number;
    totalProduct: number;
    totalItem: number;
    totalPrice: number;
}

export enum BaseStatus {
    Active = 1,
    Inactive = 2,
}

export class SampleViewModel implements ISampleViewModel {
    id!: number;
    name?: string | undefined;
    image?: string | undefined;
    description?: string | undefined;
    status!: BaseStatus;
    productCategoryId?: number | undefined;
    productCategoryName?: string | undefined;
    sampleTypeIds?: string | undefined;
    sampleTypeItems?: SampleTypeItem[] | undefined;

    constructor(data?: ISampleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.image = _data["image"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.productCategoryId = _data["productCategoryId"];
            this.productCategoryName = _data["productCategoryName"];
            this.sampleTypeIds = _data["sampleTypeIds"];
            if (Array.isArray(_data["sampleTypeItems"])) {
                this.sampleTypeItems = [] as any;
                for (let item of _data["sampleTypeItems"])
                    this.sampleTypeItems!.push(SampleTypeItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SampleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SampleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["image"] = this.image;
        data["description"] = this.description;
        data["status"] = this.status;
        data["productCategoryId"] = this.productCategoryId;
        data["productCategoryName"] = this.productCategoryName;
        data["sampleTypeIds"] = this.sampleTypeIds;
        if (Array.isArray(this.sampleTypeItems)) {
            data["sampleTypeItems"] = [];
            for (let item of this.sampleTypeItems)
                data["sampleTypeItems"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISampleViewModel {
    id: number;
    name?: string | undefined;
    image?: string | undefined;
    description?: string | undefined;
    status: BaseStatus;
    productCategoryId?: number | undefined;
    productCategoryName?: string | undefined;
    sampleTypeIds?: string | undefined;
    sampleTypeItems?: SampleTypeItem[] | undefined;
}

export class SampleTypeItem implements ISampleTypeItem {
    id!: number;
    name?: string | undefined;
    type!: SampleLibraryType;

    constructor(data?: ISampleTypeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SampleTypeItem {
        data = typeof data === 'object' ? data : {};
        let result = new SampleTypeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        return data; 
    }
}

export interface ISampleTypeItem {
    id: number;
    name?: string | undefined;
    type: SampleLibraryType;
}

export enum SampleLibraryType {
    Shape = 0,
    Career = 1,
}

export class PagedResultsOfSampleListViewModel implements IPagedResultsOfSampleListViewModel {
    resultCount!: number;
    pageNumber!: number;
    totalPages!: number;
    pageSize!: number;
    results?: SampleListViewModel[] | undefined;

    constructor(data?: IPagedResultsOfSampleListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SampleListViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultsOfSampleListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultsOfSampleListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultsOfSampleListViewModel {
    resultCount: number;
    pageNumber: number;
    totalPages: number;
    pageSize: number;
    results?: SampleListViewModel[] | undefined;
}

export class SampleListViewModel implements ISampleListViewModel {
    id!: number;
    name?: string | undefined;
    image?: string | undefined;
    description?: string | undefined;
    status!: BaseStatus;
    productCategoryId?: number | undefined;
    productCategoryName?: string | undefined;

    constructor(data?: ISampleListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.image = _data["image"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.productCategoryId = _data["productCategoryId"];
            this.productCategoryName = _data["productCategoryName"];
        }
    }

    static fromJS(data: any): SampleListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SampleListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["image"] = this.image;
        data["description"] = this.description;
        data["status"] = this.status;
        data["productCategoryId"] = this.productCategoryId;
        data["productCategoryName"] = this.productCategoryName;
        return data; 
    }
}

export interface ISampleListViewModel {
    id: number;
    name?: string | undefined;
    image?: string | undefined;
    description?: string | undefined;
    status: BaseStatus;
    productCategoryId?: number | undefined;
    productCategoryName?: string | undefined;
}

export class PagedResultsOfSampleTypeListViewModel implements IPagedResultsOfSampleTypeListViewModel {
    resultCount!: number;
    pageNumber!: number;
    totalPages!: number;
    pageSize!: number;
    results?: SampleTypeListViewModel[] | undefined;

    constructor(data?: IPagedResultsOfSampleTypeListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SampleTypeListViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultsOfSampleTypeListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultsOfSampleTypeListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultsOfSampleTypeListViewModel {
    resultCount: number;
    pageNumber: number;
    totalPages: number;
    pageSize: number;
    results?: SampleTypeListViewModel[] | undefined;
}

export class SampleTypeListViewModel implements ISampleTypeListViewModel {
    id!: number;
    name?: string | undefined;
    status!: BaseStatus;
    type!: SampleLibraryType;

    constructor(data?: ISampleTypeListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SampleTypeListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SampleTypeListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["type"] = this.type;
        return data; 
    }
}

export interface ISampleTypeListViewModel {
    id: number;
    name?: string | undefined;
    status: BaseStatus;
    type: SampleLibraryType;
}

export class SampleTypeViewModel implements ISampleTypeViewModel {
    id!: number;
    name?: string | undefined;
    status!: BaseStatus;
    type!: SampleLibraryType;

    constructor(data?: ISampleTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SampleTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SampleTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["type"] = this.type;
        return data; 
    }
}

export interface ISampleTypeViewModel {
    id: number;
    name?: string | undefined;
    status: BaseStatus;
    type: SampleLibraryType;
}

export class PagedResultsOfSettingListViewModel implements IPagedResultsOfSettingListViewModel {
    resultCount!: number;
    pageNumber!: number;
    totalPages!: number;
    pageSize!: number;
    results?: SettingListViewModel[] | undefined;

    constructor(data?: IPagedResultsOfSettingListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SettingListViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultsOfSettingListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultsOfSettingListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultsOfSettingListViewModel {
    resultCount: number;
    pageNumber: number;
    totalPages: number;
    pageSize: number;
    results?: SettingListViewModel[] | undefined;
}

export class SettingListViewModel implements ISettingListViewModel {
    id!: number;
    name?: string | undefined;
    settingValue?: string | undefined;
    type!: SettingType;

    constructor(data?: ISettingListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.settingValue = _data["settingValue"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SettingListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SettingListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["settingValue"] = this.settingValue;
        data["type"] = this.type;
        return data; 
    }
}

export interface ISettingListViewModel {
    id: number;
    name?: string | undefined;
    settingValue?: string | undefined;
    type: SettingType;
}

export enum SettingType {
    Image = 1,
    TextEditor = 2,
    JsonObject = 3,
}

export class SettingViewModel implements ISettingViewModel {
    id!: number;
    name?: string | undefined;
    settingValue?: string | undefined;
    type!: SettingType;

    constructor(data?: ISettingViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.settingValue = _data["settingValue"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): SettingViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SettingViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["settingValue"] = this.settingValue;
        data["type"] = this.type;
        return data; 
    }
}

export interface ISettingViewModel {
    id: number;
    name?: string | undefined;
    settingValue?: string | undefined;
    type: SettingType;
}

export class MasterData implements IMasterData {
    stickerCategoryId!: number;
    otherProductCategory!: number;
    paperProductCategory!: number;
    quickPrintingProductCategory!: number;
    deliveryProductCategoryId!: number;
    catalogueCategoryId!: number;
    catalogueProductId!: number;
    hastagProductId!: number;
    designCategoryId!: number;
    printCategoryIds?: number[] | undefined;
    assignEmployeeCategoryIds?: number[] | undefined;
    standeeCategoryIds?: number[] | undefined;
    pricingBySizeProductIds?: number[] | undefined;
    pricingBySizeCategoryIds?: number[] | undefined;
    pricingByQuantityProductIds?: number[] | undefined;
    pricingByQuantityCategoryIds?: number[] | undefined;
    cataloguePageOptions?: number[] | undefined;
    catalogueBookOptions?: number[] | undefined;
    categorySizeOptions?: CatalogueSizeOption[] | undefined;
    quickProductMenu?: ProductMenu2 | undefined;
    inkjetPrintingMenu?: ProductMenu2 | undefined;
    marketingMenu?: ProductMenu2 | undefined;
    otherProductMenu?: ProductMenu2 | undefined;

    constructor(data?: IMasterData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stickerCategoryId = _data["stickerCategoryId"];
            this.otherProductCategory = _data["otherProductCategory"];
            this.paperProductCategory = _data["paperProductCategory"];
            this.quickPrintingProductCategory = _data["quickPrintingProductCategory"];
            this.deliveryProductCategoryId = _data["deliveryProductCategoryId"];
            this.catalogueCategoryId = _data["catalogueCategoryId"];
            this.catalogueProductId = _data["catalogueProductId"];
            this.hastagProductId = _data["hastagProductId"];
            this.designCategoryId = _data["designCategoryId"];
            if (Array.isArray(_data["printCategoryIds"])) {
                this.printCategoryIds = [] as any;
                for (let item of _data["printCategoryIds"])
                    this.printCategoryIds!.push(item);
            }
            if (Array.isArray(_data["assignEmployeeCategoryIds"])) {
                this.assignEmployeeCategoryIds = [] as any;
                for (let item of _data["assignEmployeeCategoryIds"])
                    this.assignEmployeeCategoryIds!.push(item);
            }
            if (Array.isArray(_data["standeeCategoryIds"])) {
                this.standeeCategoryIds = [] as any;
                for (let item of _data["standeeCategoryIds"])
                    this.standeeCategoryIds!.push(item);
            }
            if (Array.isArray(_data["pricingBySizeProductIds"])) {
                this.pricingBySizeProductIds = [] as any;
                for (let item of _data["pricingBySizeProductIds"])
                    this.pricingBySizeProductIds!.push(item);
            }
            if (Array.isArray(_data["pricingBySizeCategoryIds"])) {
                this.pricingBySizeCategoryIds = [] as any;
                for (let item of _data["pricingBySizeCategoryIds"])
                    this.pricingBySizeCategoryIds!.push(item);
            }
            if (Array.isArray(_data["pricingByQuantityProductIds"])) {
                this.pricingByQuantityProductIds = [] as any;
                for (let item of _data["pricingByQuantityProductIds"])
                    this.pricingByQuantityProductIds!.push(item);
            }
            if (Array.isArray(_data["pricingByQuantityCategoryIds"])) {
                this.pricingByQuantityCategoryIds = [] as any;
                for (let item of _data["pricingByQuantityCategoryIds"])
                    this.pricingByQuantityCategoryIds!.push(item);
            }
            if (Array.isArray(_data["cataloguePageOptions"])) {
                this.cataloguePageOptions = [] as any;
                for (let item of _data["cataloguePageOptions"])
                    this.cataloguePageOptions!.push(item);
            }
            if (Array.isArray(_data["catalogueBookOptions"])) {
                this.catalogueBookOptions = [] as any;
                for (let item of _data["catalogueBookOptions"])
                    this.catalogueBookOptions!.push(item);
            }
            if (Array.isArray(_data["categorySizeOptions"])) {
                this.categorySizeOptions = [] as any;
                for (let item of _data["categorySizeOptions"])
                    this.categorySizeOptions!.push(CatalogueSizeOption.fromJS(item));
            }
            this.quickProductMenu = _data["quickProductMenu"] ? ProductMenu2.fromJS(_data["quickProductMenu"]) : <any>undefined;
            this.inkjetPrintingMenu = _data["inkjetPrintingMenu"] ? ProductMenu2.fromJS(_data["inkjetPrintingMenu"]) : <any>undefined;
            this.marketingMenu = _data["marketingMenu"] ? ProductMenu2.fromJS(_data["marketingMenu"]) : <any>undefined;
            this.otherProductMenu = _data["otherProductMenu"] ? ProductMenu2.fromJS(_data["otherProductMenu"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MasterData {
        data = typeof data === 'object' ? data : {};
        let result = new MasterData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stickerCategoryId"] = this.stickerCategoryId;
        data["otherProductCategory"] = this.otherProductCategory;
        data["paperProductCategory"] = this.paperProductCategory;
        data["quickPrintingProductCategory"] = this.quickPrintingProductCategory;
        data["deliveryProductCategoryId"] = this.deliveryProductCategoryId;
        data["catalogueCategoryId"] = this.catalogueCategoryId;
        data["catalogueProductId"] = this.catalogueProductId;
        data["hastagProductId"] = this.hastagProductId;
        data["designCategoryId"] = this.designCategoryId;
        if (Array.isArray(this.printCategoryIds)) {
            data["printCategoryIds"] = [];
            for (let item of this.printCategoryIds)
                data["printCategoryIds"].push(item);
        }
        if (Array.isArray(this.assignEmployeeCategoryIds)) {
            data["assignEmployeeCategoryIds"] = [];
            for (let item of this.assignEmployeeCategoryIds)
                data["assignEmployeeCategoryIds"].push(item);
        }
        if (Array.isArray(this.standeeCategoryIds)) {
            data["standeeCategoryIds"] = [];
            for (let item of this.standeeCategoryIds)
                data["standeeCategoryIds"].push(item);
        }
        if (Array.isArray(this.pricingBySizeProductIds)) {
            data["pricingBySizeProductIds"] = [];
            for (let item of this.pricingBySizeProductIds)
                data["pricingBySizeProductIds"].push(item);
        }
        if (Array.isArray(this.pricingBySizeCategoryIds)) {
            data["pricingBySizeCategoryIds"] = [];
            for (let item of this.pricingBySizeCategoryIds)
                data["pricingBySizeCategoryIds"].push(item);
        }
        if (Array.isArray(this.pricingByQuantityProductIds)) {
            data["pricingByQuantityProductIds"] = [];
            for (let item of this.pricingByQuantityProductIds)
                data["pricingByQuantityProductIds"].push(item);
        }
        if (Array.isArray(this.pricingByQuantityCategoryIds)) {
            data["pricingByQuantityCategoryIds"] = [];
            for (let item of this.pricingByQuantityCategoryIds)
                data["pricingByQuantityCategoryIds"].push(item);
        }
        if (Array.isArray(this.cataloguePageOptions)) {
            data["cataloguePageOptions"] = [];
            for (let item of this.cataloguePageOptions)
                data["cataloguePageOptions"].push(item);
        }
        if (Array.isArray(this.catalogueBookOptions)) {
            data["catalogueBookOptions"] = [];
            for (let item of this.catalogueBookOptions)
                data["catalogueBookOptions"].push(item);
        }
        if (Array.isArray(this.categorySizeOptions)) {
            data["categorySizeOptions"] = [];
            for (let item of this.categorySizeOptions)
                data["categorySizeOptions"].push(item.toJSON());
        }
        data["quickProductMenu"] = this.quickProductMenu ? this.quickProductMenu.toJSON() : <any>undefined;
        data["inkjetPrintingMenu"] = this.inkjetPrintingMenu ? this.inkjetPrintingMenu.toJSON() : <any>undefined;
        data["marketingMenu"] = this.marketingMenu ? this.marketingMenu.toJSON() : <any>undefined;
        data["otherProductMenu"] = this.otherProductMenu ? this.otherProductMenu.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IMasterData {
    stickerCategoryId: number;
    otherProductCategory: number;
    paperProductCategory: number;
    quickPrintingProductCategory: number;
    deliveryProductCategoryId: number;
    catalogueCategoryId: number;
    catalogueProductId: number;
    hastagProductId: number;
    designCategoryId: number;
    printCategoryIds?: number[] | undefined;
    assignEmployeeCategoryIds?: number[] | undefined;
    standeeCategoryIds?: number[] | undefined;
    pricingBySizeProductIds?: number[] | undefined;
    pricingBySizeCategoryIds?: number[] | undefined;
    pricingByQuantityProductIds?: number[] | undefined;
    pricingByQuantityCategoryIds?: number[] | undefined;
    cataloguePageOptions?: number[] | undefined;
    catalogueBookOptions?: number[] | undefined;
    categorySizeOptions?: CatalogueSizeOption[] | undefined;
    quickProductMenu?: ProductMenu2 | undefined;
    inkjetPrintingMenu?: ProductMenu2 | undefined;
    marketingMenu?: ProductMenu2 | undefined;
    otherProductMenu?: ProductMenu2 | undefined;
}

export class MasterDataViewModel extends MasterData implements IMasterDataViewModel {

    constructor(data?: IMasterDataViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MasterDataViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MasterDataViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IMasterDataViewModel extends IMasterData {
}

export class ProductMenu2 implements IProductMenu2 {
    themeColor?: string | undefined;
    categories?: ProductMenuItem2[] | undefined;
    products?: ProductMenuItem2[] | undefined;

    constructor(data?: IProductMenu2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.themeColor = _data["themeColor"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(ProductMenuItem2.fromJS(item));
            }
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductMenuItem2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductMenu2 {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMenu2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["themeColor"] = this.themeColor;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProductMenu2 {
    themeColor?: string | undefined;
    categories?: ProductMenuItem2[] | undefined;
    products?: ProductMenuItem2[] | undefined;
}

export class ProductMenuItem2 implements IProductMenuItem2 {
    id!: number;
    image?: string | undefined;

    constructor(data?: IProductMenuItem2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): ProductMenuItem2 {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMenuItem2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["image"] = this.image;
        return data; 
    }
}

export interface IProductMenuItem2 {
    id: number;
    image?: string | undefined;
}

export enum ShapeStatus {
    Active = 1,
    Inactive = 2,
}

export class ShapeViewModel implements IShapeViewModel {
    id!: number;
    name?: string | undefined;
    image?: string | undefined;
    description?: string | undefined;
    status!: ShapeStatus;

    constructor(data?: IShapeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.image = _data["image"];
            this.description = _data["description"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ShapeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShapeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["image"] = this.image;
        data["description"] = this.description;
        data["status"] = this.status;
        return data; 
    }
}

export interface IShapeViewModel {
    id: number;
    name?: string | undefined;
    image?: string | undefined;
    description?: string | undefined;
    status: ShapeStatus;
}

export class PagedResultsOfShapeListViewModel implements IPagedResultsOfShapeListViewModel {
    resultCount!: number;
    pageNumber!: number;
    totalPages!: number;
    pageSize!: number;
    results?: ShapeListViewModel[] | undefined;

    constructor(data?: IPagedResultsOfShapeListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ShapeListViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultsOfShapeListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultsOfShapeListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultsOfShapeListViewModel {
    resultCount: number;
    pageNumber: number;
    totalPages: number;
    pageSize: number;
    results?: ShapeListViewModel[] | undefined;
}

export class ShapeListViewModel implements IShapeListViewModel {
    id!: number;
    name?: string | undefined;
    image?: string | undefined;
    description?: string | undefined;
    status!: ShapeStatus;

    constructor(data?: IShapeListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.image = _data["image"];
            this.description = _data["description"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ShapeListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShapeListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["image"] = this.image;
        data["description"] = this.description;
        data["status"] = this.status;
        return data; 
    }
}

export interface IShapeListViewModel {
    id: number;
    name?: string | undefined;
    image?: string | undefined;
    description?: string | undefined;
    status: ShapeStatus;
}

export class SliderViewModel implements ISliderViewModel {
    imageLinks?: string[] | undefined;

    constructor(data?: ISliderViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["imageLinks"])) {
                this.imageLinks = [] as any;
                for (let item of _data["imageLinks"])
                    this.imageLinks!.push(item);
            }
        }
    }

    static fromJS(data: any): SliderViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SliderViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.imageLinks)) {
            data["imageLinks"] = [];
            for (let item of this.imageLinks)
                data["imageLinks"].push(item);
        }
        return data; 
    }
}

export interface ISliderViewModel {
    imageLinks?: string[] | undefined;
}

export class SuppliesCategoryViewModel implements ISuppliesCategoryViewModel {
    id!: number;
    name?: string | undefined;
    metaDescription?: string | undefined;
    orderNumber!: number;
    status!: BaseStatus;

    constructor(data?: ISuppliesCategoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.metaDescription = _data["metaDescription"];
            this.orderNumber = _data["orderNumber"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): SuppliesCategoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SuppliesCategoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["metaDescription"] = this.metaDescription;
        data["orderNumber"] = this.orderNumber;
        data["status"] = this.status;
        return data; 
    }
}

export interface ISuppliesCategoryViewModel {
    id: number;
    name?: string | undefined;
    metaDescription?: string | undefined;
    orderNumber: number;
    status: BaseStatus;
}

export class PagedResultsOfSuppliesCategoryViewModel implements IPagedResultsOfSuppliesCategoryViewModel {
    resultCount!: number;
    pageNumber!: number;
    totalPages!: number;
    pageSize!: number;
    results?: SuppliesCategoryViewModel[] | undefined;

    constructor(data?: IPagedResultsOfSuppliesCategoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SuppliesCategoryViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultsOfSuppliesCategoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultsOfSuppliesCategoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultsOfSuppliesCategoryViewModel {
    resultCount: number;
    pageNumber: number;
    totalPages: number;
    pageSize: number;
    results?: SuppliesCategoryViewModel[] | undefined;
}

export class SuppliesCategoryOrderNumber implements ISuppliesCategoryOrderNumber {
    id!: number;
    name?: string | undefined;
    orderNumber!: number;

    constructor(data?: ISuppliesCategoryOrderNumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.orderNumber = _data["orderNumber"];
        }
    }

    static fromJS(data: any): SuppliesCategoryOrderNumber {
        data = typeof data === 'object' ? data : {};
        let result = new SuppliesCategoryOrderNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["orderNumber"] = this.orderNumber;
        return data; 
    }
}

export interface ISuppliesCategoryOrderNumber {
    id: number;
    name?: string | undefined;
    orderNumber: number;
}

export class UpdateSuppliesCategoryOrderNumbers implements IUpdateSuppliesCategoryOrderNumbers {
    suppliesCategoryOrderNumbers?: SuppliesCategoryOrderNumber[] | undefined;

    constructor(data?: IUpdateSuppliesCategoryOrderNumbers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["suppliesCategoryOrderNumbers"])) {
                this.suppliesCategoryOrderNumbers = [] as any;
                for (let item of _data["suppliesCategoryOrderNumbers"])
                    this.suppliesCategoryOrderNumbers!.push(SuppliesCategoryOrderNumber.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSuppliesCategoryOrderNumbers {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSuppliesCategoryOrderNumbers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.suppliesCategoryOrderNumbers)) {
            data["suppliesCategoryOrderNumbers"] = [];
            for (let item of this.suppliesCategoryOrderNumbers)
                data["suppliesCategoryOrderNumbers"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateSuppliesCategoryOrderNumbers {
    suppliesCategoryOrderNumbers?: SuppliesCategoryOrderNumber[] | undefined;
}

export class PagedResultsOfSuppliesViewModel implements IPagedResultsOfSuppliesViewModel {
    resultCount!: number;
    pageNumber!: number;
    totalPages!: number;
    pageSize!: number;
    results?: SuppliesViewModel[] | undefined;

    constructor(data?: IPagedResultsOfSuppliesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SuppliesViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultsOfSuppliesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultsOfSuppliesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultsOfSuppliesViewModel {
    resultCount: number;
    pageNumber: number;
    totalPages: number;
    pageSize: number;
    results?: SuppliesViewModel[] | undefined;
}

export class SuppliesViewModel implements ISuppliesViewModel {
    id!: number;
    name?: string | undefined;
    suppliesCategoryId!: number;
    suppliesCategoryName?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    status!: BaseStatus;
    orderNumber!: number;

    constructor(data?: ISuppliesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.suppliesCategoryId = _data["suppliesCategoryId"];
            this.suppliesCategoryName = _data["suppliesCategoryName"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.orderNumber = _data["orderNumber"];
        }
    }

    static fromJS(data: any): SuppliesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SuppliesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["suppliesCategoryId"] = this.suppliesCategoryId;
        data["suppliesCategoryName"] = this.suppliesCategoryName;
        data["code"] = this.code;
        data["description"] = this.description;
        data["status"] = this.status;
        data["orderNumber"] = this.orderNumber;
        return data; 
    }
}

export interface ISuppliesViewModel {
    id: number;
    name?: string | undefined;
    suppliesCategoryId: number;
    suppliesCategoryName?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    status: BaseStatus;
    orderNumber: number;
}

export class VendorModel implements IVendorModel {
    id!: string;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    address?: string | undefined;
    email?: string | undefined;

    constructor(data?: IVendorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.address = _data["address"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): VendorModel {
        data = typeof data === 'object' ? data : {};
        let result = new VendorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["address"] = this.address;
        data["email"] = this.email;
        return data; 
    }
}

export interface IVendorModel {
    id: string;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    address?: string | undefined;
    email?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}